/* rb-ui v2 -------------------------------------------------------------------
   ROBBYTOYS: Ein Modul fuer alles Bewegte und alles Bedienbare.

   Ein IntersectionObserver fuer saemtliche Reveals, ein
   requestAnimationFrame fuer Augen und Neigung. Zeigerbewegungen rechnen
   hoechstens einmal je Bild, nicht bei jedem mousemove. Ohne diese Drosselung
   rechnet der Hauptthread bei jeder Mausbewegung, und die Seite fuehlt sich
   auf einem aelteren Geraet zaeh an.

   prefers-reduced-motion wird VOR dem Registrieren der Zeiger-Effekte
   geprueft. Das ist keine Formsache: wer eine vestibulaere Stoerung hat, dem
   wird von einem 3-Grad-Tilt schlecht.

   Angelegt 20.08.2026. Grundlage: Masterplan Teil C.4, Q.5, Q.6.

   v2 am 21.08.2026: Videokacheln, Hintergrundvideos, die Bildercollage,
   das Nachladen ganzer Bildergruppen und schwebende Figuren. Alles Neue
   haengt an denselben zwei Motoren wie das Alte -- EIN IntersectionObserver,
   EIN requestAnimationFrame. Der Beobachter kann seither auch dauerhaft
   melden (`beiSichtDauernd`), der Bildtakt nimmt beliebige Rechnungen auf
   (`anhaengen`). Beides war noetig, weil eine Schleife, die ausserhalb des
   Bildes weiterlaeuft, Akku kostet, ohne dass sie jemand sieht.

   v3 am 21.08.2026, Bahn "bewegung". Drei Aenderungen und eine Oeffnung:

   - Die Staffelung der Einblendung ist von 80 auf 55ms gegangen und der
     Deckel von 8 auf 6 Stufen. Groesste Verzoegerung damit 330 statt
     640ms, GEMESSEN im Browser vorher und nachher. Eine Kachelreihe kommt
     jetzt als eine Bewegung an, statt als sechs Auftritte nacheinander.
   - Die Parallaxe lief in die falsche Richtung. Sie ist umgedreht --
     Begruendung mit Messwerten steht bei `bahnMessen`.
   - Teil 24 treibt die Welle der Bahn "uebergaenge" an. Sie bekommt
     denselben Beobachter und denselben Bildtakt wie alles andere.
   - Teil 25 macht beides nach aussen ansprechbar: `window.rbUI` und die
     Warteschlange `window.rbQ`. Damit koennen die sechs Sektionsdateien
     ihren eigenen IntersectionObserver ablegen -- gemessen am 21.08.2026
     sind es sieben auf einer Seite, sechs davon fuer dieselbe Aufgabe.
--------------------------------------------------------------------------- */

/* ⚠️ DIESE ZWEI ZEILEN STEHEN GANZ OBEN UND BLEIBEN DORT.

   `rb-js` schaltet in rb-motion.css das Verstecken der Einblendungen erst
   frei. Ohne diese Klasse ist jeder Abschnitt sichtbar. Kommt das Skript
   also gar nicht an -- Netzfehler, Syntaxfehler beim Parsen des Moduls,
   Blocker im Browser --, sieht der Besucher den vollstaendigen Shop ohne
   Einblendung. Bis zum 20.08.2026 war es andersherum: das Skript hat den
   Inhalt selbst versteckt, und jeder Bruch danach liess die Seite leer.

   `rb-alles-sichtbar` ist der Rettungsanker. Er greift nach 2,5 Sekunden,
   wenn sich der Beobachter bis dahin kein einziges Mal gemeldet hat --
   also im Ausfall und nur dort. Eine Animation, die nicht laeuft, ist ein
   Schoenheitsfehler. Ein Text, den niemand sieht, ist ein Totalausfall.
   ⚠️ 31.08.2026 BERICHTIGT: hier stand "er wird unbedingt gesetzt", und so
   war es auch gebaut. Das kostete den Shop jede Einblendung unterhalb des
   ersten Bildschirms. Die lange Begruendung steht bei der Zeile selbst. */
document.documentElement.classList.add('rb-js');
/* ⚠️⚠️ 31.08.2026 -- DER GROESSTE BEFUND DIESER BAHN, UND ER STAND HIER.

   Bis heute lautete diese Zeile:

     setTimeout(() => document.documentElement.classList.add(
       'rb-alles-sichtbar'), 2500);

   OHNE BEDINGUNG. Und in rb-motion.css Zeile 204 steht dazu:

     html.rb-alles-sichtbar .rb-rev,
     html.rb-alles-sichtbar .rb-rev-einzeln,
     html.rb-alles-sichtbar [data-rb-rev] > *{
       opacity:1 !important; transform:none !important; }

   Zusammen heisst das: ZWEIEINHALB SEKUNDEN NACH JEDEM SEITENAUFBAU wird
   jede Einblendung des Shops zwangsweise auf ihren Endzustand gestellt --
   auch jede, die zehn Bildschirme weiter unten steht und die noch niemand
   gesehen hat. Wer danach scrollt, sieht nichts mehr einlaufen. Nicht,
   weil der Beobachter versagt haette, sondern weil ihm die Arbeit
   weggenommen wurde.

   Der Anker war als RETTUNG fuer den Ausfall gedacht ("eine Animation, die
   nicht laeuft, ist ein Schoenheitsfehler; ein Text, den niemand sieht,
   ist ein Totalausfall"). Diese Absicht bleibt richtig und bleibt
   unangetastet. Nur die Bedingung fehlte: er zog IMMER, nicht nur im
   Ausfall.

   JETZT zieht er genau dann, wenn der Beobachter sich ueberhaupt nicht
   gemeldet hat. Ein IntersectionObserver meldet nach `observe()` fuer
   JEDES beobachtete Element einmal von selbst, gleich ob es im Bild steht
   oder nicht -- die Meldung kommt also binnen weniger Bilder, wenn er
   arbeitet. Bleibt sie nach 2,5 Sekunden aus, ist etwas kaputt, und dann
   soll alles sichtbar werden.

   ⚠️ Der try/catch ist kein Schmuck. `beobachterMeldete` wird weiter unten
   mit `let` angelegt. Bricht das Modul VOR dieser Zeile ab, laeuft der
   Zeitgeber trotzdem und griffe in die zeitliche Totzone der Variablen --
   das wirft. Gefangen und als "nicht heil" gewertet setzt der Anker dann,
   wie er soll. Der Ausfall bleibt damit der Fall, in dem alles sichtbar
   wird.

   RUECKWEG: die alte Zeile oben steht woertlich da. Wer sie wieder
   einsetzt, hat wieder einen Shop, in dem sich beim Scrollen nichts regt. */
setTimeout(() => {
  let heil = false;
  try { heil = beobachterMeldete === true; } catch (_) { heil = false; }
  if (!heil) document.documentElement.classList.add('rb-alles-sichtbar');
}, 2500);

/* ⚠️ Befund 22.08.2026: base.css setzt html{scroll-behavior:smooth} fuer das
   GANZE Dokument. Damit animiert der Browser auch jeden Sprung, der beim
   SEITENAUFBAU selbst passiert -- ein Ankerlink mit #ziel in der Adresse und
   jede vom Auftraggeber gemeldete Kachel, die auf /products/eilik#gefuehle
   zeigt, lassen die Seite dadurch sichtbar "runterfliegen" statt sofort dort
   zu stehen. Eine Inline-Angabe auf demselben Element schlaegt jede Regel
   aus einem Stilblatt gleicher Gewichtung, unabhaengig von deren Reihenfolge
   im Dokument -- deshalb genuegt eine Zeile hier, ohne base.css oder unsere
   eigenen drei scroll-behavior-Stellen anzufassen. Weich bleibt es nur noch
   fuer den Wimpernschlag eines ECHTEN Klicks auf einen Anker der laufenden
   Seite, siehe `ankerWeich` bei Teil 23b. */
document.documentElement.style.scrollBehavior = 'auto';

const ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const zeiger = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

/* ==========================================================================
   Werkzeug
   ========================================================================== */
const alle = (sel, wurzel = document) => Array.from(wurzel.querySelectorAll(sel));
const eins = (sel, wurzel = document) => wurzel.querySelector(sel);

/* Zufallszahl zwischen a und b. Wird fuer das Blinzeln gebraucht: vier
   gleichzeitig blinzelnde Gesichter wirken wie ein Fehler, vier versetzte
   wirken lebendig. */
const zwischen = (a, b) => a + Math.random() * (b - a);

/* ==========================================================================
   1 - Der eine IntersectionObserver
   ========================================================================== */
const sichtbarHandler = new WeakMap();

/* Zweite Liste am SELBEN Beobachter: Elemente, die nicht einmal, sondern
   bei jedem Wechsel gemeldet werden wollen -- Laufband, Collage,
   Hintergrundvideo, schwebende Figuren. Sie werden nie abgemeldet und
   bekommen `is-sicht` gesetzt oder genommen.

   ⚠️ Es bleibt bei EINEM Beobachter. Der Unterschied zwischen einmal und
   dauernd sind vier Zeilen in der Schleife, kein zweites Geraet, das bei
   jedem Scrollen eine eigene Rueckrufliste abarbeitet.

   Wozu ueberhaupt: eine Endlosschleife ausserhalb des Bildes kostet
   Rechenzeit und Akku, ohne dass sie jemand sieht. Die Collage schiebt
   Bilder von 2400px Breite, ein Hintergrundvideo dekodiert 25 Bilder je
   Sekunde. Beides gehoert angehalten, sobald es aus dem Bild ist. */
const dauerHandler = new WeakMap();

/* ⚠️ WER EINMALIG ANGEMELDET IST, STEHT HIER DRIN -- UND ZWAR AUCH DANN,
   WENN ER ZUSAETZLICH DAUERHAFT BEOBACHTET WIRD.

   Gemessen am 01.09.2026 auf der LIVE-Seite bei 390 px: 33 von 85
   Einblendungen der Startseite und 35 von 81 auf /products/eilik standen
   nach dem vollstaendigen Durchrollen immer noch auf opacity 0 -- also
   dauerhaft unsichtbar. JEDE einzelne davon lag in einem .rb-lauf. Das ist
   das "viel leer" aus der Beanstandung vom 01.09.2026, und es ist kein
   Bildfehler: der Inhalt war da, mass seine volle Groesse und war
   durchsichtig.

   Die Ursache liegt im Rueckruf des einen Beobachters weiter unten. Ein
   Element, das im dauerHandler steht, nahm dort den oberen Ast und sprang
   mit `continue` ueber den unteren -- und im unteren steht das `is-da`,
   von dem die Einblendung lebt. Genau diese Doppelanmeldung hat der
   Selbstlauf (Teil 30, gebaut am 01.09.2026) geschaffen: revealsStarten
   meldet die Bento- und Rasterbaender einmalig an, selbstlauf danach
   dieselben Elemente dauerhaft. Wer zuletzt kommt, gewinnt den Ast.

   ⚠️ Warum eine eigene Menge und nicht einfach `sichtbarHandler.has()`:
   beiSicht wird an vielen Stellen OHNE Rueckruffunktion aufgerufen (die
   [data-rb-sicht]-Sektionen, die Einzelstuecke). Die haetten keinen
   Eintrag in sichtbarHandler und blieben unsichtbar, sobald sie jemand
   zusaetzlich dauerhaft beobachtet. Die Menge fragt nach der ANMELDUNG,
   nicht nach dem Rueckruf. */
const einmalOffen = new WeakSet();

/* ⚠️ threshold MUSS 0 SEIN.

   Hier stand `threshold: 0.12`. Das verlangt, dass 12 Prozent der Flaeche
   eines Elements gleichzeitig im Sichtfenster stehen. Bei einem Abschnitt,
   der hoeher ist als der Bildschirm, ist das Verhaeltnis von vornherein
   gedeckelt: ein Element von acht Bildschirmhoehen erreicht hoechstens
   12,5 Prozent, eines von zehn nur noch 10 -- und loest damit NIE aus.
   Solche Abschnitte blieben dauerhaft auf opacity:0 stehen.

   Mit threshold 0 loest der Beobachter aus, sobald ein einziger Bildpunkt
   sichtbar wird. Der rootMargin von -8% sorgt weiterhin dafuer, dass die
   Einblendung nicht schon am aeussersten Rand losgeht. */
const HAT_BEOBACHTER = typeof IntersectionObserver === 'function';

/* ⚠️ Der Lebensnachweis des Beobachters. Er wird bei der ERSTEN Meldung
   gesetzt, gleich welcher -- ein IntersectionObserver meldet nach
   `observe()` fuer jedes Element einmal von selbst, auch wenn es weit
   ausserhalb des Bildes liegt. Der Rettungsanker ganz oben liest ihn nach
   2,5 Sekunden. Bleibt er falsch, ist etwas kaputt und alles wird sichtbar
   gemacht. Ist er wahr, arbeitet der Beobachter, und die Einblendungen
   bleiben ihm ueberlassen -- auch die zehn Bildschirme weiter unten. */
let beobachterMeldete = false;

const beobachter = HAT_BEOBACHTER ? new IntersectionObserver((eintraege) => {
  beobachterMeldete = true;
  for (const e of eintraege) {
    const dauer = dauerHandler.get(e.target);
    if (dauer) {
      e.target.classList.toggle('is-sicht', e.isIntersecting);
      /* ⚠️ Erst die einmalige Schuld begleichen, dann den Dauerauftrag.
         Ein Element kann BEIDES sein -- eine Einblendung UND ein Band, das
         beim Verlassen des Bildes anhalten soll. Vor dem 01.09.2026 fiel
         die Einblendung dabei aus; die Zahlen dazu stehen bei einmalOffen.
         Abgemeldet wird hier NICHT: der Dauerauftrag braucht die naechste
         Meldung. */
      if (e.isIntersecting && einmalOffen.has(e.target)) {
        einmalOffen.delete(e.target);
        e.target.classList.add('is-da');
        const einmal = sichtbarHandler.get(e.target);
        if (einmal) { sichtbarHandler.delete(e.target); einmal(e.target); }
      }
      /* Ein Dauerbeobachter, der wirft, wuerde bei JEDEM Scrollen wieder
         werfen. Er wird deshalb nach dem ersten Fehler abgemeldet. */
      try { dauer(e.target, e.isIntersecting); }
      catch (fehler) {
        console.error('[robbytoys] Dauerbeobachtung ist ausgefallen:', fehler);
        dauerHandler.delete(e.target);
        beobachter.unobserve(e.target);
      }
      continue;
    }
    if (!e.isIntersecting) continue;
    einmalOffen.delete(e.target);
    e.target.classList.add('is-da');
    const fn = sichtbarHandler.get(e.target);
    if (fn) { fn(e.target); sichtbarHandler.delete(e.target); }
    beobachter.unobserve(e.target);
  }
}, { rootMargin: '0px 0px -8% 0px', threshold: 0 }) : null;

function beiSicht(el, fn) {
  if (!el) return;
  /* Kein Beobachter im Browser: sofort einblenden statt nie. */
  if (!beobachter) {
    el.classList.add('is-da');
    if (fn) fn(el);
    return;
  }
  if (fn) sichtbarHandler.set(el, fn);
  einmalOffen.add(el);
  beobachter.observe(el);
}

/* Dauerhaft beobachten. fn bekommt (element, istSichtbar) bei jedem Wechsel.
   Ohne Beobachter im Browser gilt alles als sichtbar: eine Schleife, die
   dann eben durchlaeuft, ist ein Schoenheitsfehler -- eine Schleife, die
   nie anlaeuft, ist ein stehendes Bild, das nach einem Fehler aussieht. */
function beiSichtDauernd(el, fn) {
  if (!el) return;
  if (!beobachter) { el.classList.add('is-sicht'); if (fn) fn(el, true); return; }
  dauerHandler.set(el, fn || (() => {}));
  beobachter.observe(el);
}

/* Reveals, gestaffelt zu 55ms (siehe REV_TAKT weiter unten). Die
   Staffelung wird je Gruppe gezaehlt, nicht ueber die ganze Seite: sonst
   haette das zwanzigste Element ueber eine Sekunde Verzoegerung und
   niemand saehe es je erscheinen. */
/* Fuenf Spielarten der Einblendung, ueber den WERT von data-rb-rev
   waehlbar: data-rb-rev="pop" gibt jedem Kind zusaetzlich .rb-rev--pop.
   Die Liste ist geschlossen -- ein Tippfehler im Markup darf keine
   Klasse erzeugen, die es im Stilblatt nicht gibt und die niemand
   wiederfindet. */
/* 31.08.2026: 'servo' ist die sechste Art dazugekommen (rb-motion.css
   Abschnitt 23). Ohne diesen Eintrag faellt data-rb-rev="servo" still auf
   keine Klasse zurueck -- die Einblendung liefe dann im Grundfall, und
   niemand saehe, dass die Spielart fehlt. */
const REV_ARTEN = ['pop', 'seite', 'zoom', 'dreh', 'weich', 'servo'];

/* --- Die Staffelung. Zwei Zahlen, und beide sind am 21.08.2026 kleiner
   geworden.

   VORHER: 80ms je Schritt, gedeckelt bei 8 Schritten. Die groesste
   Verzoegerung war damit 640ms -- GEMESSEN am 21.08.2026 im laufenden Shop
   (`--rb-rev-delay`, groesster Wert auf Startseite, /products/eilik und
   /products/eiliko: je 640ms). Die Einblendung selbst dauert --rb-t-lg,
   also ebenfalls 640ms. Beides zusammen heisst: die erste Kachel einer
   Reihe steht bereits still, bevor die neunte ueberhaupt losgeht. Das
   liest sich nicht als Ankommen, sondern als neun einzelne Auftritte
   nacheinander -- genau das "aufpoppen", das nicht sein soll.

   JETZT: 55ms je Schritt, gedeckelt bei 6. Groesste Verzoegerung 330ms,
   also gut die Haelfte der Einblendungsdauer. Damit ueberlappen sich alle
   Kacheln einer Gruppe: waehrend die letzte anlaeuft, ist die erste noch
   in Bewegung. Eine Gruppe kommt als EINE Bewegung an, die von links nach
   rechts durchlaeuft.

   ⚠️ Der Deckel ist wichtiger als die Schrittweite. Ohne ihn haette das
   zwanzigste Element 1,1 Sekunden Verzoegerung und niemand saehe es je
   erscheinen -- er stand deshalb schon vorher da und bleibt.

   Gesamtdauer einer Gruppe: 330 + 640 = 970ms statt vorher 1280ms. */
const REV_TAKT   = 55;
const REV_STUFEN = 6;
const revArt = (el) => {
  /* Die Gruppe traegt die Art in data-rb-rev, das Einzelstueck in
     data-rb-rev-art. Zwei Namen, weil data-rb-rev an einem Einzelstueck
     es zugleich zur Gruppe machen wuerde -- dann bekaemen seine Kinder
     die Einblendung und es selbst nicht. */
  const a = (el.dataset.rbRev || el.dataset.rbRevArt || '').trim();
  return REV_ARTEN.includes(a) ? 'rb-rev--' + a : '';
};

function revealsStarten(wurzel = document) {
  alle('[data-rb-rev]', wurzel).forEach((gruppe) => {
    const kinder = Array.from(gruppe.children);
    const art = revArt(gruppe);
    kinder.forEach((k, i) => {
      k.classList.add('rb-rev');
      if (art) k.classList.add(art);
      k.style.setProperty('--rb-rev-delay', `${Math.min(i, REV_STUFEN) * REV_TAKT}ms`);
    });
    beiSicht(gruppe, () => kinder.forEach((k) => k.classList.add('is-da')));
  });
  alle('.rb-rev-einzeln', wurzel).forEach((el) => {
    el.classList.add('rb-rev');
    const art = revArt(el);
    if (art) el.classList.add(art);
    beiSicht(el);
  });
  // Sektionen, die beim Sichtbarwerden etwas ausloesen (Ringe, Zaehler, Linien)
  alle('[data-rb-sicht]', wurzel).forEach((el) => beiSicht(el));
}

/* ==========================================================================
   2 - Der eine requestAnimationFrame: Augen und Neigung
   ========================================================================== */
let mausX = 0, mausY = 0, mausNeu = false, laeuft = false;
const augen = [];
const karten = [];

/* Jede laufende Rechnung haengt sich hier ein und gibt false zurueck, wenn
   sie fertig ist. Zwei requestAnimationFrame-Schleifen nebeneinander rechnen
   nicht nur doppelt, sie landen auch in verschiedenen Bildern -- das sieht
   man als Zittern zwischen zwei Zahlen, die zusammen hochlaufen sollen. */
const laeufer = new Set();

function zeigerMerken(e) { mausX = e.clientX; mausY = e.clientY; mausNeu = true; takt(); }

function takt() {
  if (laeuft) return;
  laeuft = true;
  requestAnimationFrame(bild);
}

function bild(zeit) {
  laeuft = false;
  if (mausNeu) { mausNeu = false; augenSetzen(); kartenSetzen(); }
  for (const fn of laeufer) {
    let weiter = false;
    /* Auch hier gilt: ein Fehler kostet genau eine Rechnung. Sonst reisst
       ein kaputter Zaehler die Pupillen und alles andere mit. */
    try { weiter = fn(zeit) !== false; }
    catch (fehler) { console.error('[robbytoys] Bildtakt:', fehler); }
    if (!weiter) laeufer.delete(fn);
  }
  if (laeufer.size) takt();
}

/* Eine Rechnung in den Bildtakt haengen. Sie laeuft, bis sie false liefert. */
function anhaengen(fn) { laeufer.add(fn); takt(); }

/* ZWEITE ROBOTERBEWEGUNG: die Pupillen folgen dem Mauszeiger. Die Bewegung
   wird auf ganze Pixel gerastert, damit sie ruckelt statt gleitet. Das ist
   die Roboter-Ebene: ein Display mit niedriger Bildrate.

   ⚠️ 31.08.2026 GEAENDERT. Vorher stand in `augen` das blosse Element, und
   die Pupille wurde in JEDEM Bild neu gesucht -- ein querySelector je Auge
   je Mausbewegung, fuer ein Ergebnis, das sich nie aendert. Jetzt steht je
   Auge EIN Eintrag mit allem, was der Bildtakt braucht: Element, Pupille,
   Radius.

   ⚠️ Der Radius steht am Augenpaar (data-rb-augenweg), nicht am einzelnen
   Auge, und wird EINMAL gelesen. 4 Pixel ist die Hausvorgabe; ein grosses
   Gesicht darf auf 6, mehr sieht nach Schielen aus. Gedeckelt bei 8. */
function augenSetzen() {
  for (const a of augen) {
    const r = a.el.getBoundingClientRect();
    if (!r.width) continue;
    const dx = mausX - (r.left + r.width / 2);
    const dy = mausY - (r.top + r.height / 2);
    const laenge = Math.hypot(dx, dy) || 1;
    const weite = Math.min(a.weg, laenge / 40);
    a.pupille.style.setProperty('--rb-eye-x', Math.round((dx / laenge) * weite) + 'px');
    a.pupille.style.setProperty('--rb-eye-y', Math.round((dy / laenge) * weite) + 'px');
  }
}

/* Magnetische Karten, hoechstens 3 Grad. Mehr wirkt nicht magnetisch,
   sondern kaputt.

   ⚠️ 31.08.2026 GEAENDERT -- der groesste Hauptfadenposten der
   Bewegungsschicht. Vorher wurde bei JEDER Mausbewegung fuer JEDE Karte
   der Seite ein getBoundingClientRect() gerechnet. Gemessen am 31.08.2026
   am ausgelieferten HTML: 15 .rb-card auf der Startseite, 9 auf
   /products/eilik, 3 auf /products/eiliko -- gerechnet wurde auch fuer die
   vierzehn, unter denen der Zeiger gerade nicht steht. Der Ausstieg
   ("liegt sie ueberhaupt im Bild?") stand DAHINTER; das Rect war da laengst
   gemessen.

   JETZT: eine Trefferabfrage und hoechstens EINE Messung je Bild. Aus 15
   Layoutzugriffen werden zwei. elementFromPoint liest denselben
   Layoutstand wie ein Rect -- es ist nicht gratis, aber es ist einer statt
   fuenfzehn, und die Zahl waechst nicht mehr mit der Seite.

   ⚠️ Die zuletzt beruehrte Karte wird ausdruecklich zurueckgestellt. Ohne
   das bliebe sie geneigt stehen, sobald der Zeiger sie schnell verlaesst.

   ⚠️ RUECKWEG, falls elementFromPoint an dieser Seite die Karte nicht
   findet (ein durchsichtiges Geschwisterelement mit hoeherem z-index
   darueber): die alte Schleife steht woertlich in
   assets/rb-ui.js.stand-vor-welle4-20260831. Erkennbar waere der Fall
   daran, dass sich ueberhaupt keine Karte mehr neigt. */
let karteAktiv = null;

function kartenSetzen() {
  const unter = document.elementFromPoint(mausX, mausY);
  const aktiv = unter && unter.closest ? unter.closest('.rb-card') : null;

  if (karteAktiv && karteAktiv !== aktiv) {
    karteAktiv.style.setProperty('--rb-tilt-x', '0deg');
    karteAktiv.style.setProperty('--rb-tilt-y', '0deg');
  }
  karteAktiv = aktiv;
  if (!aktiv) return;

  const r = aktiv.getBoundingClientRect();
  if (!r.width || !r.height) return;
  const nx = (mausX - (r.left + r.width / 2)) / (r.width / 2);
  const ny = (mausY - (r.top + r.height / 2)) / (r.height / 2);
  aktiv.style.setProperty('--rb-tilt-y', (nx * 3).toFixed(2) + 'deg');
  aktiv.style.setProperty('--rb-tilt-x', (-ny * 3).toFixed(2) + 'deg');
}

/* ⚠️ 31.08.2026: gegen doppeltes Einsammeln gesichert. Diese Funktion steht
   in TEILE und laeuft damit bei JEDEM shopify:section:load erneut. Vorher
   schob sie ihre Funde ungeprueft nach -- im Theme-Editor wuchsen `augen`
   und `karten` mit jedem Sektionswechsel, und derselbe Knoten wurde
   mehrfach je Bild gerechnet.

   ⚠️ Ein .rb-eye OHNE .rb-eye__pupil wird ausdruecklich NICHT aufgenommen.
   Gemessen am 31.08.2026: die gezeichneten Gesichter in
   sections/robby-gesichter.liquid und sections/robby-hoehenangst.liquid
   haben Auge und Lid, aber keine Pupillengruppe. Vorher stand fuer jedes
   von ihnen ein querySelector je Bild in der Schleife, der verlaesslich
   null lieferte. */
const augenGesehen = new WeakSet();
const kartenGesehen = new WeakSet();

function zeigerEffekte(wurzel = document) {
  if (ruhig || !zeiger) return;
  alle('.rb-eye', wurzel).forEach((el) => {
    if (augenGesehen.has(el)) return;
    const pupille = eins('.rb-eye__pupil', el);
    if (!pupille) return;
    augenGesehen.add(el);
    const paar = el.closest('[data-rb-augenweg]');
    const weg = Math.min(8, Number(paar && paar.dataset.rbAugenweg) || 4);
    augen.push({ el, pupille, weg });
  });
  alle('.rb-card', wurzel).forEach((el) => {
    if (kartenGesehen.has(el)) return;
    kartenGesehen.add(el);
    karten.push(el);
  });
  if (augen.length || karten.length) {
    /* Erst abmelden, dann anmelden: die Funktion laeuft mehrfach, und zwei
       gleiche Horcher am selben Ziel waeren zwei Rechnungen je Bewegung. */
    window.removeEventListener('mousemove', zeigerMerken);
    window.addEventListener('mousemove', zeigerMerken, { passive: true });
  }
}

/* ==========================================================================
   3 - Blinzeln, zeitlich zufaellig versetzt
   ========================================================================== */
function blinzelnVerteilen(wurzel = document) {
  if (ruhig) return;
  alle('.rb-face, .rb-eyes', wurzel).forEach((el) => {
    el.style.setProperty('--rb-blink-dur', zwischen(4, 7).toFixed(2) + 's');
    el.style.setProperty('--rb-blink-delay', '-' + zwischen(0, 7).toFixed(2) + 's');
  });
}

/* ==========================================================================
   4 - Boot-Up-Scanline. Einmal je Sitzung, danach nie wieder.
   ========================================================================== */
function bootScanline() {
  const hero = eins('[data-rb-boot]');
  if (!hero || ruhig) return;
  try {
    if (sessionStorage.getItem('rb-boot') === '1') return;
    sessionStorage.setItem('rb-boot', '1');
  } catch (_) { /* privater Modus: dann laeuft sie einmal je Seitenaufruf */ }
  hero.style.setProperty('--rb-scan-h', hero.offsetHeight + 'px');
  hero.classList.add('rb-boot');
}

/* ==========================================================================
   5 - Das Pixel-Laufband. Gleiche Geschwindigkeit auf jeder Breite.
   ========================================================================== */
/* Das gemeinsame Bauteil hinter Laufband und Collage: Spur verdoppeln,
   Breite messen, Dauer daraus rechnen.

   ⚠️ Die zweite Haelfte ist eine KOPIE fuer das Auge und bekommt
   aria-hidden. Vorher stand hier `spur.innerHTML += spur.innerHTML`: damit
   liest ein Screenreader jeden Eintrag zweimal vor, und jeder Verweis
   darin steht zweimal in der Tabulatorreihenfolge. Bei einer Collage aus
   23 Kundenfotos sind das 23 zusaetzliche Halte auf dem Weg zum Kaufknopf. */
function laufschleife(rahmen, spur, tempo, variable) {
  if (!spur.dataset.doppelt) {
    Array.from(spur.children).forEach((kind) => {
      const kopie = kind.cloneNode(true);
      kopie.setAttribute('aria-hidden', 'true');
      alle('a, button, input, [tabindex]', kopie).forEach((f) => { f.tabIndex = -1; });
      if (kopie.matches && kopie.matches('a, button, input, [tabindex]')) kopie.tabIndex = -1;
      spur.appendChild(kopie);
    });
    spur.dataset.doppelt = '1';
  }
  /* Pixel je Sekunde, nicht Prozent: sonst laeuft dasselbe Band auf einem
     breiten Bildschirm schneller als auf einem schmalen. */
  const setzen = () => {
    const breite = spur.scrollWidth / 2;
    if (breite > 0) spur.style.setProperty(variable, (breite / Math.max(1, tempo)).toFixed(2) + 's');
  };
  /* 12.10.2026 Tempo P1-4: kein sofortiges setzen() mehr direkt nach dem
     Verdoppeln -- das erzwang je Band ein Layout. Der ResizeObserver meldet
     beim Anmelden ohnehin einmal (vor dem naechsten Bild) und setzt dann. */
  if ('ResizeObserver' in window) new ResizeObserver(setzen).observe(rahmen);
  else setzen();
  return setzen;
}

/* ⚠️ Schwerpunkt 22.08.2026: traege Bilder, die den Sichtbereich nie
   schneiden.

   Die Spur ist auf das Doppelte verdoppelt (siehe oben) und laeuft
   ausschliesslich per CSS-Transformation innerhalb eines mit
   overflow:hidden geschnittenen Rahmens. Die zweite Haelfte steht dabei
   von Anfang an ausserhalb des Sichtfensters -- nicht nur ausserhalb des
   Rahmens, sondern ausserhalb des Browserfensters selbst. Natives
   loading="lazy" (robby-ph.liquid, Regelfall fuer jedes Bild ausser dem
   einen "eager") misst seinen Abstand zum Sichtfenster beim Scrollen und
   bei Groessenaenderung nach, nicht bei jedem Bild einer laufenden
   Animation -- eine reine transform-Animation loest keinen der beiden
   Anstoesse aus. Ein Bild, das nur durch das Laufband ins Bild wandert,
   bekommt diesen Anstoss also nie und bleibt traege stehen, bis irgendwo
   sonst auf der Seite gescrollt wird.

   Der Fix holt beide Haelften der Spur EIN Mal nach, sobald der Rahmen
   selbst zum ersten Mal im Sichtfenster steht -- ein Band zehn Bildschirme
   tief im Fuss laedt also weiterhin nichts, bis man dort ankommt. */
function spurBilderHolen(spur) {
  alle('img[loading="lazy"]', spur).forEach((bild) => { bild.loading = 'eager'; });
}

function baenderStarten(wurzel = document) {
  alle('.rb-band', wurzel).forEach((band) => {
    const spur = eins('.rb-band__spur', band);
    if (!spur) return;
    laufschleife(band, spur, Number(band.dataset.tempo || 40), '--rb-band-dur');
    /* Ausserhalb des Bildes steht das Band still. Es bewegt sich sonst
       auf jeder Seite dauerhaft, auch wenn es zehn Bildschirme weit weg
       ist -- gemessen im Fussbereich jeder Seite dieses Shops. */
    beiSichtDauernd(band, (_el, drin) => {
      if (drin && !band.dataset.rbBildGeholt) { band.dataset.rbBildGeholt = '1'; spurBilderHolen(spur); }
    });
  });
}

/* ==========================================================================
   6 - Pixel-Herz beim Hinzufuegen zum Warenkorb
   ========================================================================== */
function herzFliegen(vonEl) {
  if (ruhig || !vonEl) return;
  const ziel = eins('#cart-icon-bubble, .header__icon--cart, [href$="/cart"]');
  const a = vonEl.getBoundingClientRect();
  const b = ziel ? ziel.getBoundingClientRect() : { left: innerWidth - 40, top: 20, width: 20, height: 20 };
  const herz = document.createElement('span');
  herz.className = 'rb-herz';
  herz.setAttribute('aria-hidden', 'true');
  herz.style.left = (a.left + a.width / 2) + 'px';
  herz.style.top = (a.top + a.height / 2) + 'px';
  herz.style.setProperty('--rb-herz-dx', ((b.left + b.width / 2) - (a.left + a.width / 2)) + 'px');
  herz.style.setProperty('--rb-herz-dy', ((b.top + b.height / 2) - (a.top + a.height / 2)) + 'px');
  document.body.appendChild(herz);
  setTimeout(() => herz.remove(), 800);
}

function herzHaengen() {
  document.addEventListener('click', (e) => {
    const knopf = e.target.closest('[name="add"], .product-form__submit, [data-rb-atc]');
    if (knopf) herzFliegen(knopf);
  }, { passive: true });
}

/* ==========================================================================
   6b - Formulare mit data-rb-atc per Ajax abschicken

   Befund 22.08.2026: sections/robby-buendel.liquid liefert ein rohes
   <form method="post" action="/cart/add"> ohne return_to. data-rb-atc
   stand bis heute ausschliesslich am Herzchen-Animator oben (Teil 6) --
   es gibt keinen Ajax-Pfad, jeder Klick verlaesst die Produktseite und
   landet auf /cart. Bei einer Buendel-Sektion, deren ganzer Zweck eine
   ZWEITE Karte in denselben Warenkorb ist, kostet das jedes zweite Set
   einen kompletten Seitenwechsel.

   Der Knopf traegt data-rb-atc bereits (fuer die Herzchen-Animation), das
   Formular selbst nicht -- deshalb wird hier delegiert ueber `submit` am
   Dokument gesucht statt eine feste Sektionsklasse vorauszusetzen: jedes
   Formular, dessen Absende-Knopf data-rb-atc traegt UND dessen Ziel
   /cart/add ist, wird abgefangen. So bindet dieselbe eine Zeile jede
   heutige und jede kuenftige Karte, ohne dass eine Sektion ihr Markup
   dafuer aendern muss.

   Der Rueckfallweg bleibt das rohe Formular: schlaegt fetch fehl -- Netz
   weg, Cors, Rate-Limit --, sendet der Knopf sich selbst noch einmal ohne
   diesen Handler ab (`form.submit()` loest keine erneute Absende-Pruefung
   aus). Ohne JavaScript lief das Formular schon vorher, unveraendert. */
function atcAjax() {
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    const knopf = eins('[data-rb-atc]', form);
    if (!knopf) return;
    if (!/\/cart\/add(\.js)?(\?|$)/.test(form.getAttribute('action') || '')) return;
    if (knopf.disabled) { e.preventDefault(); return; }
    e.preventDefault();

    const daten = new FormData(form);
    /* Das Sections-Rendering-API der Ajax-Warenkorb-Route liefert das
       fertig gerenderte Fragment der Kopfblase gleich mit -- damit wird
       hier keine eigene Kopie der Shopify-Uebersetzung und der Markup-
       Struktur erfunden, siehe `#cart-icon-bubble` in header.liquid und
       cart-notification.js, das genau denselben Weg schon geht. */
    daten.set('sections', 'cart-icon-bubble');
    daten.set('sections_url', location.pathname);

    const beschriftungAlt = knopf.textContent;
    knopf.disabled = true;
    knopf.classList.add('is-laedt');

    /* Kein herzFliegen(knopf) hier: herzHaengen (Teil 6) haengt selbst an
       einem Klick auf genau dieses [data-rb-atc] und hat das Herz beim
       Klick -- also lange vor dieser Antwort -- schon losgeschickt. Ein
       zweiter Aufruf hier liesse es ein zweites Mal fliegen. */
    fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: daten })
      .then((antwort) => antwort.json().then((json) => (antwort.ok ? json : Promise.reject(json))))
      .then((json) => {
        const fragment = json.sections && json.sections['cart-icon-bubble'];
        const blase = fragment && document.getElementById('cart-icon-bubble');
        if (fragment && blase) {
          const neu = new DOMParser().parseFromString(fragment, 'text/html').getElementById('cart-icon-bubble');
          if (neu) blase.innerHTML = neu.innerHTML;
        }
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: json }));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        knopf.classList.remove('is-laedt');
        knopf.classList.add('is-erfolg');
        knopf.textContent = 'Im Warenkorb';
        setTimeout(() => {
          knopf.classList.remove('is-erfolg');
          knopf.textContent = beschriftungAlt;
          knopf.disabled = false;
        }, 1600);
      })
      .catch((fehler) => {
        console.error('[robbytoys] /cart/add.js ist ausgefallen:', fehler);
        knopf.disabled = false;
        knopf.classList.remove('is-laedt');
        form.submit();
      });
  });
}

/* ==========================================================================
   7 - Zaehler, die pixelweise springen
   ========================================================================== */
/* Deutsche Schreibweise, ein Formatierer je Zahl. Ein neuer
   Intl.NumberFormat in jedem Bild waere die teuerste Zeile der Datei.

   ⚠️ Ohne Tausenderpunkt liest sich die grosse Zahl des Vorbilds -- 650000
   Nutzer -- als sechshundertfuenfzigtausend erst beim zweiten Hinsehen.
   toFixed liefert genau das: eine Ziffernkette ohne Gliederung. */
function formatierer(stellen) {
  try {
    const nf = new Intl.NumberFormat('de-DE', {
      minimumFractionDigits: stellen, maximumFractionDigits: stellen
    });
    return (w) => nf.format(w);
  } catch (_) {
    return (w) => w.toFixed(stellen).replace('.', ',');
  }
}

function zaehler(el) {
  const ziel = Number(el.dataset.rbZiel || 0);
  const stellen = Number(el.dataset.rbStellen || 0);
  const dauer = Math.max(200, Number(el.dataset.rbDauer || 900));
  const schreiben = formatierer(stellen);
  if (ruhig || !Number.isFinite(ziel)) { el.textContent = schreiben(ziel || 0); return; }

  /* Die Zahl springt hoechstens alle 60ms, nicht in jedem Bild. Sechzig
     Ziffernwechsel je Sekunde sind Flimmern, sechzehn sind lesbar -- und
     die Roboter-Ebene des Shops springt ohnehin gestuft.
     Der Verlauf ist ausgebremst (1 minus Rest hoch drei): die Zahl legt
     sofort los und kommt sanft an, statt gleichmaessig durchzuticken. */
  let start = null, letzte = -1e9;
  anhaengen((zeit) => {
    if (start === null) start = zeit;
    const p = Math.min(1, (zeit - start) / dauer);
    if (p < 1 && zeit - letzte < 60) return true;
    letzte = zeit;
    el.textContent = schreiben(ziel * (1 - Math.pow(1 - p, 3)));
    if (p >= 1) el.textContent = schreiben(ziel);
    return p < 1;
  });
}

/* ⚠️ Auf NULL gesetzt wird nur, was noch UNTER dem Sichtfeld liegt.
   WARUM: der Rueckfalltext in den vier Sektionen traegt seit dem 21.08.2026
   den echten Wert, damit im ausgelieferten HTML keine Unwahrheit steht --
   gemessen standen dort vorher 6 von 6 Zaehlern auf null, darunter die
   Durchschnittsnote als "0,0" neben fuenf vollen Sternen und der Akku des
   Eiliko als "0 mAh". Wer die Zahl schon im Bild hat, wuerde sie sonst
   fuer den Bruchteil einer Sekunde auf null zurueckspringen sehen. */
function zaehlerStarten(wurzel = document) {
  alle('[data-rb-ziel]', wurzel).forEach((el) => {
    let unten = true;
    try { unten = el.getBoundingClientRect().top > window.innerHeight; } catch (_) {}
    if (unten) el.textContent = formatierer(Number(el.dataset.rbStellen || 0))(0);
    beiSicht(el, zaehler);
  });
}

/* Die Ringe fuellen sich beim Sichtbarwerden. */
function ringeStarten(wurzel = document) {
  alle('[data-rb-ring]', wurzel).forEach((ring) => {
    const anteil = Math.max(0, Math.min(1, Number(ring.dataset.rbRing || 0)));
    const bahn = eins('.rb-ring__wert', ring);
    if (!bahn) return;
    const laenge = 2 * Math.PI * 45;
    bahn.style.setProperty('--rb-ring-len', laenge.toFixed(1));
    bahn.style.setProperty('--rb-ring-off', (laenge * (1 - anteil)).toFixed(1));
    beiSicht(ring);
  });
}

/* ==========================================================================
   8 - Ausklapper, Reiter, FAQ. Alles mit Tastatur bedienbar.
   ========================================================================== */
function ausklapper(wurzel = document) {
  alle('.rb-ausklapp__knopf, .rb-faq__knopf, .rb-zeit__kopf', wurzel).forEach((knopf) => {
    if (knopf.dataset.rbBereit) return;
    knopf.dataset.rbBereit = '1';
    knopf.addEventListener('click', () => {
      const offen = knopf.getAttribute('aria-expanded') === 'true';
      knopf.setAttribute('aria-expanded', String(!offen));
      const ziel = document.getElementById(knopf.getAttribute('aria-controls'));
      if (ziel) ziel.classList.toggle('is-offen', !offen);
    });
  });
}

function reiter(wurzel = document) {
  alle('[role="tablist"][data-rb-reiter]', wurzel).forEach((liste) => {
    const tabs = alle('[role="tab"]', liste);
    const waehlen = (tab) => {
      tabs.forEach((t) => {
        const aktiv = t === tab;
        t.setAttribute('aria-selected', String(aktiv));
        t.tabIndex = aktiv ? 0 : -1;
        const panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !aktiv;
      });
    };
    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => waehlen(tab));
      tab.addEventListener('keydown', (e) => {
        const richtung = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
        if (!richtung) return;
        e.preventDefault();
        const naechster = tabs[(i + richtung + tabs.length) % tabs.length];
        naechster.focus(); waehlen(naechster);
      });
    });
  });
}

/* ==========================================================================
   9 - Der Kleiderschrank. Die aufwendigste Sektion.

   Beim Wechsel wird der Koerper nicht ueberblendet, sondern in steps(6,end)
   ausgetauscht, mit einem 90-Grad-Dreh um die Hochachse: genau wie der echte
   Handgriff, links drehen und abziehen, hochschieben und rechts drehen.
   Der Kopf bleibt ruhig stehen und blinzelt einmal, wenn der Koerper sitzt.
   ========================================================================== */
function kleiderschrank(wurzel = document) {
  alle('[data-rb-schrank]', wurzel).forEach((schrank) => {
    const minis = alle('.rb-schrank__mini', schrank);
    const figur = eins('.rb-schrank__figur', schrank);
    const koerper = eins('.rb-schrank__koerper', schrank);
    const rolle = eins('[data-rb-rolle]', schrank);
    const satz = eins('[data-rb-schrank-satz]', schrank);
    const knopf = eins('[data-rb-schrank-knopf]', schrank);
    const melder = eins('[data-rb-schrank-melder]', schrank);
    if (!minis.length) return;

    // Zwoelf Rollen mal drei Ansichten sind 36 Bilder, die niemand braucht,
    // solange man oben auf der Seite ist. Sie werden erst geladen, wenn die
    // Sektion sichtbar wird.
    beiSicht(schrank, () => {
      alle('img[data-rb-src]', schrank).forEach((bild) => {
        bild.src = bild.dataset.rbSrc;
        bild.removeAttribute('data-rb-src');
      });
      /* ⚠️ HIER LAG DIE VERZOEGERUNG, UEBER DIE DER AUFTRAGGEBER AM
         21.08.2026 GESCHRIEBEN HAT: "es bleibt immer noch das alte fuer
         2 Sekunden da".

         Vorgeladen wurden bisher nur die zwoelf Miniaturen (data-rb-src).
         Das grosse Koerperbild wird beim Klick ueber `koerper.src = ...`
         getauscht -- und diese zwoelf Bilder (900 px) waren NIRGENDS
         vorgeladen. Ein <img> zeigt beim Wechsel der Quelle so lange das
         ALTE Bild, bis das neue geladen und dekodiert ist. Beim ersten
         Klick auf eine Rolle war das die volle Ladezeit.

         Der Ruecklauf ist kostenlos: die Bilder kommen ohnehin, sobald
         jemand die Rolle anklickt. Sie kommen jetzt nur frueher, und zwar
         erst, wenn die Sektion ueberhaupt im Bild ist. */
      minis.forEach((m) => {
        if (!m.dataset.rbBild) return;
        const vor = new Image();
        vor.decoding = 'async';
        vor.src = m.dataset.rbBild;
      });
    });

    const waehlen = (mini) => {
      minis.forEach((m) => {
        const aktiv = m === mini;
        m.setAttribute('aria-selected', String(aktiv));
        m.tabIndex = aktiv ? 0 : -1;
      });
      const d = mini.dataset;
      if (koerper && d.rbBild) {
        if (figur && !ruhig) {
          figur.classList.remove('is-wechsel');
          void figur.offsetWidth;            // Neustart der Animation erzwingen
          figur.classList.add('is-wechsel');
        }
        /* Der Tausch liegt auf der Mitte der Drehung (250 ms von 500), weil
           die Figur dort um 90 Grad gedreht steht und praktisch nichts zu
           sehen ist. Das war und bleibt richtig.

           ⚠️ Was fehlte: die Zusicherung, dass das neue Bild zu diesem
           Zeitpunkt ueberhaupt DA ist. `koerper.src = ...` allein zeigt
           weiter das alte Bild, bis das neue dekodiert ist -- der Tausch
           sah dann aus, als haenge die Sektion.

           Jetzt wird beides abgewartet: die halbe Drehung UND das fertig
           dekodierte Bild. Ist es vorgeladen (Regelfall, siehe oben), ist
           decode() sofort fertig und es bleibt bei den 250 ms. Ist die
           Leitung langsam, wartet der Tausch, statt ein halbes Bild zu
           zeigen -- und die Drehung laeuft dafuer ein zweites Mal, damit
           der Wechsel weiterhin verdeckt ist statt hart umzuspringen. */
        const tauschen = () => { koerper.src = d.rbBild; koerper.alt = d.rbAlt || ''; };
        if (ruhig) { tauschen(); }
        else {
          const halbzeit = new Promise((r) => setTimeout(r, 250));
          const neu = new Image();
          neu.decoding = 'async';
          neu.src = d.rbBild;
          const fertig = (neu.decode ? neu.decode() : Promise.resolve())
            .catch(() => {});          /* decode() wirft bei Abbruch -- kein Grund, den Tausch zu lassen */
          const start = performance.now();
          Promise.all([halbzeit, fertig]).then(() => {
            /* Nur wenn inzwischen eine ANDERE Rolle gewaehlt wurde, ist
               dieser Tausch ueberholt. Ohne diese Pruefung ueberholt ein
               langsames Bild ein spaeter angeklicktes schnelles. */
            if (mini.getAttribute('aria-selected') !== 'true') return;
            tauschen();
            if (figur && performance.now() - start > 400) {
              figur.classList.remove('is-wechsel');
              void figur.offsetWidth;
              figur.classList.add('is-wechsel');
            }
          });
        }
      }
      if (rolle) rolle.textContent = d.rbName || '';
      if (satz) satz.textContent = d.rbSatz || '';
      if (knopf && d.rbLink) { knopf.href = d.rbLink; knopf.textContent = d.rbKnopf || 'set ansehen'; }
      // Die grosse Figur meldet den neuen Rollennamen. Ohne diese Zeile
      // bekommt ein Screenreader vom Wechsel nichts mit.
      if (melder) melder.textContent = (d.rbName || '') + ' ausgewählt';
    };

    minis.forEach((mini, i) => {
      mini.addEventListener('click', () => waehlen(mini));
      mini.addEventListener('keydown', (e) => {
        const richtung = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
        if (!richtung) return;
        e.preventDefault();
        const n = minis[(i + richtung + minis.length) % minis.length];
        n.focus(); waehlen(n);
        n.scrollIntoView({ inline: 'center', block: 'nearest', behavior: ruhig ? 'auto' : 'smooth' });
      });
    });
    waehlen(minis[0]);
  });
}

/* ==========================================================================
   10 - Die Sensorkarte

   ⚠️ Zwei Befunde vom 22.08.2026, beide hier behoben:

   a) Der Startaufruf waehlen(0) rollte beim Laden GENAUSO wie ein echter
      Klick -- die Seite sprang beim Aufruf jeder Produktseite sofort zur
      Sensorkarte. `waehlen(i, rollen)` unterscheidet jetzt beide Faelle:
      der Start setzt den Zustand ohne zu rollen, nur ein echter Klick oder
      Tastendruck rollt.

   b) Alle 7 Punkte und alle 7 Zeilen trugen aria-selected ohne passende
      Rolle -- das Attribut ist nur bei tab/option/row/gridcell gueltig.
      Beide Reihen werden jetzt als zwei gekoppelte Reiterpaare
      ausgezeichnet (je role=tablist/tab, Pfeiltasten wie bei `reiter`):
      die Bildpunkte sind die einzige Bedienung, die sonst nur eine Maus
      erreicht, und die Liste ist "eine zweite, gleichwertige Bedienung"
      (so nennt es der Befund selbst) -- ein role=tab dort macht ihr
      eigenes aria-selected erst gueltig, ohne den Attributselektor in
      rb-sections.css (`.rb-anat__zeile[aria-selected="true"]`) anzufassen,
      der nicht mir gehoert. Dazu ein Melder, der den Wechsel vorliest --
      dasselbe Muster, das robby-kleiderschrank schon benutzt (Teil 9,
      `melder`). Ids und aria-controls kommen aus dem Skript, weil das
      Markup keine mitbringt; ein Ankerpraefix je Sektionsaufruf haelt sie
      eindeutig, falls die Sensorkarte einmal zweimal auf einer Seite
      steht.
   ========================================================================== */
let anatomieLauf = 0;

function anatomie(wurzel = document) {
  alle('[data-rb-anatomie]', wurzel).forEach((sek) => {
    /* Ohne diesen Riegel haengt ein zweiter Aufruf -- etwa nach
       shopify:section:load -- eine zweite Klick- und Tastaturbindung an
       dieselben Knoepfe. Vorher fiel das nicht auf, weil waehlen() ohnehin
       nur denselben Zustand noch einmal setzte; mit eigenen Ids waere ein
       zweiter Lauf ein zweites Mal derselbe Praefix. */
    if (sek.dataset.rbAnatBereit) return;
    sek.dataset.rbAnatBereit = '1';

    const punkte = alle('.rb-anat__punkt', sek);
    const zeilen = alle('.rb-anat__zeile', sek);
    const bildkasten = eins('.rb-anat__bild', sek);
    const liste = eins('.rb-anat__liste', sek);
    if (!punkte.length) return;

    const praefix = 'rb-anat-' + (++anatomieLauf) + '-';
    let melder = eins('[data-rb-anat-melder]', sek);
    if (!melder) {
      melder = document.createElement('span');
      melder.className = 'rb-sr';
      melder.setAttribute('aria-live', 'polite');
      melder.setAttribute('data-rb-anat-melder', '');
      sek.appendChild(melder);
    }
    if (bildkasten) bildkasten.setAttribute('role', 'tablist');
    if (liste) liste.setAttribute('role', 'tablist');

    punkte.forEach((p, i) => {
      if (!p.id) p.id = praefix + 'punkt-' + i;
      p.setAttribute('role', 'tab');
      if (zeilen[i]) {
        if (!zeilen[i].id) zeilen[i].id = praefix + 'zeile-' + i;
        p.setAttribute('aria-controls', zeilen[i].id);
      }
    });
    zeilen.forEach((z, i) => {
      z.setAttribute('role', 'tab');
      if (punkte[i]) z.setAttribute('aria-controls', punkte[i].id);
    });

    const waehlen = (i, rollen) => {
      punkte.forEach((p, k) => {
        const aktiv = k === i;
        p.setAttribute('aria-selected', String(aktiv));
        p.tabIndex = aktiv ? 0 : -1;
      });
      zeilen.forEach((z, k) => {
        const aktiv = k === i;
        z.setAttribute('aria-selected', String(aktiv));
        z.tabIndex = aktiv ? 0 : -1;
        if (aktiv && rollen) z.scrollIntoView({ block: 'nearest', behavior: ruhig ? 'auto' : 'smooth' });
      });
      if (melder) {
        const stelle = zeilen[i] && eins('b', zeilen[i]);
        melder.textContent = stelle ? stelle.textContent + ' ausgewählt' : '';
      }
    };

    const pfeiltaste = (gruppe, i) => (e) => {
      const richtung = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
      if (!richtung) return;
      e.preventDefault();
      const n = (i + richtung + gruppe.length) % gruppe.length;
      gruppe[n].focus();
      waehlen(n, true);
    };
    punkte.forEach((p, i) => {
      p.addEventListener('click', () => waehlen(i, true));
      p.addEventListener('keydown', pfeiltaste(punkte, i));
    });
    zeilen.forEach((z, i) => {
      z.addEventListener('click', () => waehlen(i, true));
      z.addEventListener('keydown', pfeiltaste(zeilen, i));
    });

    waehlen(0, false);
  });
}

/* ==========================================================================
   11 - Der Schreibtisch
   ========================================================================== */
function schreibtisch(wurzel = document) {
  alle('[data-rb-tisch]', wurzel).forEach((sek) => {
    const punkte = alle('.rb-tisch__hotspot', sek);
    punkte.forEach((p, i) => {
      p.style.setProperty('--rb-punkt-delay', (i * 0.38).toFixed(2) + 's');
      const karte = document.getElementById(p.getAttribute('aria-controls'));
      p.addEventListener('click', () => {
        const offen = p.getAttribute('aria-expanded') === 'true';
        punkte.forEach((q) => {
          q.setAttribute('aria-expanded', 'false');
          const k = document.getElementById(q.getAttribute('aria-controls'));
          if (k) k.classList.remove('is-offen');
        });
        if (!offen && karte) { p.setAttribute('aria-expanded', 'true'); karte.classList.add('is-offen'); }
      });
    });
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      punkte.forEach((q) => {
        q.setAttribute('aria-expanded', 'false');
        const k = document.getElementById(q.getAttribute('aria-controls'));
        if (k) k.classList.remove('is-offen');
      });
    });
  });
}

/* ==========================================================================
   12 - Der Vorher-Nachher-Schieber. Maus, Touch und Tastatur.
   ========================================================================== */
function schieber(wurzel = document) {
  alle('[data-rb-schieber]', wurzel).forEach((sch) => {
    const eingabe = eins('.rb-schieb__eingabe', sch);
    if (!eingabe) return;
    const setzen = () => sch.style.setProperty('--rb-schieb', eingabe.value + '%');
    eingabe.addEventListener('input', setzen);
    setzen();
  });
}

/* ==========================================================================
   13 - Die Filterpillen der Bewertungen
   ========================================================================== */
function stimmenFilter(wurzel = document) {
  alle('[data-rb-stimmen]', wurzel).forEach((sek) => {
    const pillen = alle('.rb-filter__pille', sek);
    const karten = alle('[data-rb-stimme]', sek);
    pillen.forEach((pille) => {
      pille.addEventListener('click', () => {
        pillen.forEach((p) => p.setAttribute('aria-pressed', String(p === pille)));
        const f = pille.dataset.rbFilter;
        let sichtbar = 0;
        karten.forEach((k) => {
          const passt = f === 'alle' || (k.dataset.rbStimme || '').split(' ').includes(f);
          k.hidden = !passt;
          if (passt) sichtbar++;
        });
        const melder = eins('[data-rb-stimmen-melder]', sek);
        if (melder) melder.textContent = sichtbar + ' Bewertungen sichtbar';
      });
    });
  });
}

/* ==========================================================================
   14 - Der 99-Euro-Fortschrittsbalken im Warenkorb

   Ein Fortschrittsbalken darf nur zaehlen, was wirklich zaehlt. Die Grundlage
   ist derselbe Warenkorbwert, auf den auch der automatische Shopify-Rabatt
   sieht. Sonst zeigt der Balken "freigeschaltet" und der Warenkorb tut es
   nicht.
   ========================================================================== */
function fortschritt(wurzel = document) {
  alle('[data-rb-fortschritt]', wurzel).forEach((el) => {
    const schwelle = Number(el.dataset.rbSchwelle || 9900);   // in Cent
    const wert = Number(el.dataset.rbWert || 0);
    const anteil = Math.max(0, Math.min(1, wert / schwelle));
    const fuell = eins('.rb-fortschritt__fuell', el);
    if (fuell) fuell.style.setProperty('--rb-fortschritt', anteil.toFixed(3));
    if (anteil >= 1) {
      const geschenk = eins('[data-rb-geschenk]', document);
      if (geschenk && !geschenk.dataset.rbGeklackt) {
        geschenk.dataset.rbGeklackt = '1';
        geschenk.classList.add('rb-badge--klack');
      }
    }
  });
}

/* ==========================================================================
   14b - Die Hoehenangst-Abfolge

   Drei Schritte, gestuft. Der Ausdruck im Display springt, er blendet nicht
   ueber: ein Display mit niedriger Bildrate blendet nicht ueber.

   Die Schritte sind eine echte tablist mit Pfeiltasten. Jeder Schritt traegt
   seinen Text auch dann, wenn das Display nicht zu sehen ist.
   ========================================================================== */
function hoehenangst(wurzel = document) {
  alle('[data-rb-schritte]', wurzel).forEach((sek) => {
    const tabs = alle('.rb-angst__tab', sek);
    const buehne = eins('.rb-angst__buehne', sek);
    const satz = eins('[data-rb-angst-satz]', sek);
    const zustaende = alle('[data-rb-zustand]', eins('.rb-angst__display', sek) || sek);
    if (!tabs.length) return;

    const waehlen = (tab) => {
      tabs.forEach((t) => {
        const aktiv = t === tab;
        t.setAttribute('aria-selected', String(aktiv));
        t.tabIndex = aktiv ? 0 : -1;
        const panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !aktiv;
      });
      const z = tab.dataset.rbZustand;
      /* hidden statt opacity: gestuft umschalten, nicht ueberblenden.

         ⚠️ 27.09.2026: UEBER DAS ATTRIBUT, NICHT UEBER DIE EIGENSCHAFT.
         Hier stand `g.hidden = ...`. Das sieht richtig aus und tut nichts:
         hidden ist eine Eigenschaft von HTMLElement, die Zustaende sind
         aber <g> im SVG-Namensraum. SVGElement hat sie nicht -- die
         Zuweisung legt still eine gewoehnliche JavaScript-Eigenschaft an
         und ruehrt das Attribut nie an.

         Gemessen am 27.09.2026 an /products/eilik: nach Klick auf Schritt
         2 und 3 stand weiterhin dieselbe Gruppe auf display:inline, nur
         Text und Sprechzeile wechselten. Das Display zeigte in allen drei
         Schritten dasselbe Gesicht.

         Derselbe Irrtum steckte in der Darstellung: das display:none fuer
         [hidden] aus dem Browser-Grundblatt greift bei SVG ebenfalls
         nicht, deshalb lagen vorher alle drei Zustaende uebereinander.
         Dafuer gibt es jetzt .rb-angst__display [hidden] in
         rb-sections.css. Beides gehoert zusammen: die Regel sorgt fuers
         Verschwinden, diese Zeile dafuer, dass ueberhaupt umgeschaltet
         wird. */
      zustaende.forEach((g) => {
        if (g.dataset.rbZustand === z) { g.removeAttribute('hidden'); }
        else { g.setAttribute('hidden', ''); }
      });
      if (buehne) buehne.dataset.rbHand = tab.dataset.rbHand || 'weg';
      if (satz) satz.textContent = tab.dataset.rbSatz || '';
    };

    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => waehlen(tab));
      tab.addEventListener('keydown', (e) => {
        const richtung = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
        if (!richtung) return;
        e.preventDefault();
        const n = tabs[(i + richtung + tabs.length) % tabs.length];
        n.focus(); waehlen(n);
      });
    });
    waehlen(tabs[0]);
  });
}

/* ==========================================================================
   14c - Der Geschenkfinder

   Drei Fragen, die jeder beantworten kann. Laeuft vollstaendig im Browser:
   die Vorschlaege stehen als Bloecke im Markup, hier wird nur ein- und
   ausgeblendet. Kein Fremdskript, keine Einwilligung noetig.

   Der Zustand ohne Treffer ist keine Sackgasse: er nennt, was zu aendern
   waere, und bietet einen Weg hinaus.
   ========================================================================== */
function geschenkfinder(wurzel = document) {
  alle('[data-rb-finder]', wurzel).forEach((sek) => {
    const pillen = alle('.rb-filter__pille[data-rb-feld]', sek);
    const karten = alle('[data-rb-treffer]', sek);
    const stand = eins('[data-rb-finder-stand]', sek);
    const leer = eins('[data-rb-finder-leer]', sek);
    const reset = eins('[data-rb-finder-reset]', sek);
    if (!pillen.length || !karten.length) return;

    /* ⚠️ DER STARTZUSTAND KOMMT AUS DEM MARKUP, NICHT AUS DIESER ZEILE.
       Die Sektion kann eine Stufe vorbelegen, indem sie aria-pressed="true"
       an eine andere Pille als "Egal" schreibt (Einstellung start_preis).
       Stuende hier fest 'alle', saehe die vorbelegte Pille gewaehlt aus,
       ohne zu filtern -- eine Anzeige, die luegt.
       Ohne Vorbelegung ergibt das genau die alten Werte. */
    const start = { alter: 'alle', preis: 'alle', anlass: 'alle' };
    pillen.forEach((p) => {
      if (p.getAttribute('aria-pressed') === 'true') start[p.dataset.rbFeld] = p.dataset.rbWert;
    });
    const wahl = Object.assign({}, start);

    const rechnen = () => {
      let sichtbar = 0;
      karten.forEach((k) => {
        const m = (k.dataset.rbTreffer || '').split(/\s+/);
        const passt = Object.entries(wahl).every(([, wert]) =>
          wert === 'alle' || m.includes(wert));
        k.hidden = !passt;
        if (passt) sichtbar++;
      });
      if (leer) leer.hidden = sichtbar > 0;
      if (stand) {
        stand.textContent = sichtbar === 0
          ? 'kein vorschlag zu dieser auswahl'
          : (sichtbar === 1 ? '1 vorschlag' : sichtbar + ' vorschläge');
      }
    };

    pillen.forEach((p) => {
      p.addEventListener('click', () => {
        const feld = p.dataset.rbFeld;
        wahl[feld] = p.dataset.rbWert;
        pillen.filter(q => q.dataset.rbFeld === feld)
          .forEach(q => q.setAttribute('aria-pressed', String(q === p)));
        rechnen();
      });
    });

    if (reset) {
      reset.addEventListener('click', () => {
        /* Zurueck heisst zurueck zum Startzustand, nicht zu "alle": auf einer
           Seite mit Vorbelegung waere "alle" nicht der Anfang, sondern mehr,
           als der Kunde je gewaehlt hatte. */
        Object.keys(wahl).forEach(k => { wahl[k] = start[k]; });
        pillen.forEach(q => q.setAttribute('aria-pressed', String(q.dataset.rbWert === start[q.dataset.rbFeld])));
        rechnen();
        sek.scrollIntoView({ block: 'start', behavior: ruhig ? 'auto' : 'smooth' });
      });
    }

    rechnen();
  });
}

/* ==========================================================================
   14d - Der Groessenvergleich

   Die Balkenhoehen stehen bereits im Markup, gerechnet aus den Millimetern.
   Hier wird nur dafuer gesorgt, dass sie erst beim Sichtbarwerden wachsen:
   ein Balkendiagramm, das schon fertig dasteht, wenn man hinscrollt, wird
   nicht gelesen.
   ========================================================================== */
function groessenvergleich(wurzel = document) {
  alle('.rb-groesse', wurzel).forEach((g) => {
    const objekte = alle('.rb-groesse__objekt', g);
    if (ruhig) return;
    const ziel = objekte.map(o => o.style.height);
    objekte.forEach(o => { o.style.height = '0%'; });
    beiSicht(g, () => objekte.forEach((o, i) => {
      setTimeout(() => { o.style.height = ziel[i]; }, i * 80);
    }));
  });
}

/* ==========================================================================
   15 - Die Ladeanimation ist ueberall das blinzelnde Gesicht
   ========================================================================== */
function ladegesicht() {
  // Shrine setzt beim Variantenwechsel, im Warenkorb und in den Filtern die
  // Klasse .loading. Statt des Spinners erscheint dort das Gesicht.
  const vorlage = eins('#rb-ladegesicht');
  if (!vorlage) return;
  const einsetzen = (el) => {
    if (eins('.rb-laden', el)) return;
    el.appendChild(vorlage.content.cloneNode(true));
  };
  new MutationObserver((eintraege) => {
    for (const e of eintraege) {
      const el = e.target;
      if (el.classList && (el.classList.contains('loading') || el.classList.contains('loading-overlay'))) {
        einsetzen(el);
      }
    }
  }).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['class'] });
}

/* ==========================================================================
   16 - Hoehe der mitlaufenden Kaufleiste messen
   ========================================================================== */
function atcHoehe() {
  const leiste = eins('.sticky-atc, [data-rb-atc-leiste]');
  if (!leiste) return;
  const setzen = () => document.body.style.setProperty('--rb-atc-h', leiste.offsetHeight + 'px');
  setzen();
  if ('ResizeObserver' in window) new ResizeObserver(setzen).observe(leiste);
}

/* ==========================================================================
   17 - Der Halteknopf. Ein Bauteil fuer alles, was von selbst laeuft.

   ⚠️ WCAG 2.2.2 verlangt fuer jede Bewegung, die von selbst startet und
   laenger als fuenf Sekunden dauert, eine Moeglichkeit sie anzuhalten.
   Ein Hover ist keine: mit der Tastatur gibt es keinen, auf dem Handy auch
   nicht. Deshalb legt dieses Bauteil den Knopf selbst an, wenn die Sektion
   keinen mitbringt. Ein Knopf, den man vergessen kann, wird vergessen --
   und der Verstoss faellt niemandem auf, weil nichts bricht.

   Der Knopf schaltet nur die Klasse `is-halt` um. Was das anhaelt, steht
   in rb-motion.css: animation-play-state. Kein Skript rechnet dabei mit.
   ========================================================================== */
function halteknopf(rahmen, was, umschalten) {
  let knopf = eins('[data-rb-halt]', rahmen);
  if (!knopf) {
    knopf = document.createElement('button');
    knopf.type = 'button';
    knopf.className = 'rb-halt';
    knopf.setAttribute('data-rb-halt', '');
    rahmen.appendChild(knopf);
  }
  /* ⚠️ `nurBeschriften` beim ersten Aufruf ist kein Schoenheitsschalter.
     Ohne ihn ruft das Anlegen des Knopfes sofort `umschalten(true)` auf --
     und das Hintergrundvideo laedt damit beim Seitenaufbau statt beim
     Sichtbarwerden. Gemessen am 21.08.2026: 7,4 MB, die niemand sieht. */
  const setzen = (laeuftJetzt, nurBeschriften) => {
    rahmen.classList.toggle('is-halt', !laeuftJetzt);
    knopf.setAttribute('aria-pressed', String(!laeuftJetzt));
    knopf.setAttribute('aria-label', laeuftJetzt ? was + ' anhalten' : was + ' weiterlaufen lassen');
    knopf.textContent = laeuftJetzt ? 'Pause' : 'Start';
    if (umschalten && !nurBeschriften) umschalten(laeuftJetzt);
  };
  knopf.addEventListener('click', () => setzen(rahmen.classList.contains('is-halt')));
  setzen(true, true);
  return setzen;
}

/* ==========================================================================
   17b - Ein Film, der von selbst laeuft. Das Bauteil dahinter.

   Auftrag vom 21.08.2026, woertlich: "videos usw. muessen autoplay sein!
   keine pause buttons verfuegbar machen usw! kein ton!"

   Vier Zustaende sind gemessen und nicht verhandelbar:

   a) OHNE `muted` weist JEDER Browser das Selbstanlaufen ab. Das ist kein
      Geschmack, das ist die Autoplay-Richtlinie. `muted` wird deshalb
      dreifach gesetzt: als Eigenschaft, als Attribut und als
      `defaultMuted`. Aeltere WebKit-Fassungen lesen nur das Attribut, und
      `defaultMuted` ist das, was ein spaeteres load() uebrig laesst.

   b) `playsinline` ebenfalls doppelt. Ohne das Attribut reisst iOS jedes
      startende Video in den Vollbildspieler -- mit Bedienleiste, also
      genau dem, was hier weg soll.

   c) AUSSERHALB DES BILDES WIRD ANGEHALTEN. Ein dekodierendes Video kostet
      auf einem Handy messbar Akku, ohne dass es jemand sieht. Der
      Beobachter dafuer ist schon da (`beiSichtDauernd`). Es kommt KEIN
      zweiter dazu.

   d) prefers-reduced-motion. Wer eine vestibulaere Stoerung hat, dem wird
      von selbstlaufendem Bewegtbild schlecht. Dann laeuft NICHTS von
      selbst: das Standbild bleibt stehen, die Datei wird nicht geholt, und
      es gibt einen Knopf -- die native Bedienleiste des Browsers. Sie ist
      mit der Tastatur erreichbar, in jeder Sprache beschriftet und braucht
      keine eigene Pflege.

   DER PREIS DIESER ENTSCHEIDUNG STEHT HIER UND WIRD NICHT VERSCHWIEGEN.
   Ohne Halteknopf verlaesst sich der Shop bei WCAG 2.2.2 (Pause, Stop,
   Hide) allein auf prefers-reduced-motion. Wer die Bewegung anhalten will,
   ohne diese Einstellung zu kennen, hat keine Moeglichkeit mehr dazu. Das
   ist eine Anweisung des Auftraggebers vom 21.08.2026 ("keine pause
   buttons verfuegbar machen usw!"), keine Messung und keine Empfehlung.
   ========================================================================== */

/* Datensparmodus und langsames Netz -- derselbe Test, den Teil 19 schon
   fuer die Hintergrundflaechen gebraucht hat, jetzt einmal statt dreimal.

   Er ist die zweite Ausnahme neben `ruhig`: wer saveData gesetzt hat, hat
   ausdruecklich gesagt, dass er Bytes sparen will. Sechs selbstlaufende
   Videos gegen diese Ansage zu starten ist kein Dienst am Besucher. */
function bytesSparen() {
  const netz = navigator.connection || {};
  return netz.saveData === true || /(^|-)2g$|^3g$/.test(netz.effectiveType || '');
}

/* Ein <video> auf Selbstlauf stellen. Setzt nur Zustand, startet nichts. */
function filmRuesten(film, name) {
  film.muted = true;
  film.defaultMuted = true;
  film.loop = true;
  film.playsInline = true;
  film.setAttribute('muted', '');
  film.setAttribute('loop', '');
  film.setAttribute('playsinline', '');
  film.controls = false;
  film.removeAttribute('controls');
  /* Bild-im-Bild und die Fernbedienung sind zwei weitere Wege zu einer
     Bedienleiste. Wer sie nicht abbestellt, bekommt in Chrome einen
     schwebenden Knopf ueber dem Video zurueck. */
  film.setAttribute('disablepictureinpicture', '');
  film.setAttribute('controlslist', 'nodownload noplaybackrate noremoteplayback');
  if (name) film.setAttribute('aria-label', name);
  film.dataset.rbFilm = '1';
  return film;
}

/* Ein <video> in die eine Dauerbeobachtung haengen: laeuft im Bild,
   steht ausserhalb.

   `quelle` ist freiwillig. Fehlt sie, bringt das <video> seine <source>
   selbst mit und wird nur gestartet. Steht sie da, faellt vor dem ersten
   Sichtkontakt kein einziges Byte -- die Adresse wird erst gesetzt, wenn
   das Bild in Sichtweite kommt.

   Beobachtet wird das <video> SELBST und nicht sein Rahmen. Der Beobachter
   fuehrt seine Rueckrufe in einer WeakMap ueber dem Element; zwei Videos in
   einem gemeinsamen Rahmen wuerden einander dort ueberschreiben, und das
   zweite liefe nie an. */
function filmLaufenLassen(film, quelle) {
  let geholt = false;
  const spielen = () => {
    if (quelle && !geholt) { geholt = true; film.preload = 'auto'; film.src = quelle; film.load(); }
    const p = film.play();
    /* Ein abgewiesenes play() ist kein Fehler -- der Browser darf das.
       Ohne dieses catch steht die Abweisung als unbehandelte Ablehnung in
       der Konsole und sieht nach einem Bruch aus. */
    if (p && p.catch) p.catch(() => {});
  };
  beiSichtDauernd(film, (_el, drin) => { if (drin) spielen(); else film.pause(); });
}

/* Der Gegenfall: nichts laeuft von selbst, aber es gibt einen Knopf.
   Gilt bei reduzierter Bewegung und im Datensparmodus. */
function filmStehenLassen(film) {
  film.dataset.rbFilm = 'ruhig';
  film.autoplay = false;
  film.removeAttribute('autoplay');
  /* ⚠️ 07.09.2026 STILLGELEGT. Auftrag: "was ist das fuer ein start stop btn?
     weg damit". Hier stand film.controls = true -- die Bedienleiste des
     Browsers. Sie erschien NUR bei reduzierter Bewegung; gemessen trugen ohne
     die Einstellung 0 von 18 Videos eine Leiste, mit ihr 11 von 18.
  
     Der Einwand vom 01.09.2026 ("schwarze Kaesten ohne Ausweg") gilt nicht
     mehr: ohne Leiste zeigt die Kachel das erste Videobild, gemessen
     Helligkeit 107 statt 78 und 64 statt 27 Prozent bunte Bildpunkte.
  
     ⚠️ Der Halt bleibt -- autoplay wird weiter zurueckgenommen und pausiert.
     Der Preis: wer reduzierte Bewegung nutzt, kann das Video nicht mehr
     starten. Zurueckholen heisst: die Zeile darunter wieder freigeben. */
  /* film.controls = true; */
  film.preload = 'metadata';
  film.setAttribute('controlslist', 'nodownload noremoteplayback');
  return film;
}

/* ==========================================================================
   18 - Videokacheln. Vor dem Klick faellt kein Byte.

   ⚠️ Gemessen am 21.08.2026 an der Ernte vom Hersteller: 31 Videos, das
   groesste 7,4 MB. Eine Sektion mit sechs Kacheln, die ihre Filme
   mitbringt, laedt im schlimmsten Fall ueber 40 MB, bevor der erste Satz
   lesbar ist. Deshalb steht in der Kachel ein Standbild und sonst nichts.
   Das <video> entsteht erst beim Klick.

   Der Knopf wird angelegt, wenn die Sektion keinen mitbringt: eine Kachel,
   die nur als Ganzes klickbar ist, laesst sich mit der Tastatur nicht
   bedienen und faellt keinem auf, der eine Maus hat.
   ========================================================================== */
function videokacheln(wurzel = document) {
  alle('[data-rb-video]', wurzel).forEach((kachel) => {
    if (kachel.dataset.rbBereit) return;
    kachel.dataset.rbBereit = '1';
    const quelle = kachel.dataset.rbVideo;
    if (!quelle) return;
    const titel = kachel.dataset.rbVideoTitel || 'Video';

    let knopf = eins('[data-rb-video-knopf]', kachel);
    if (!knopf) {
      knopf = document.createElement('button');
      knopf.type = 'button';
      knopf.className = 'rb-videokachel__knopf';
      knopf.setAttribute('data-rb-video-knopf', '');
      kachel.appendChild(knopf);
    }
    knopf.setAttribute('aria-label', titel + ' abspielen');

    knopf.addEventListener('click', () => {
      if (kachel.classList.contains('is-laeuft')) return;
      const film = document.createElement('video');
      film.className = 'rb-videokachel__film';
      film.src = quelle;
      film.preload = 'auto';
      /* Seit dem 21.08.2026 laeuft auch dieser Film ohne Bedienleiste und
         in Schleife -- nur der Einstieg bleibt der Klick, denn genau das
         ist der Zweck dieses Bauteils: eine Kachel, die vor dem Klick
         nichts laedt. Bei reduzierter Bewegung bekommt der Besucher die
         Bedienleiste, damit er ueberhaupt etwas in der Hand hat. */
      if (ruhig) { filmStehenLassen(film); film.setAttribute('aria-label', titel); }
      else { filmRuesten(film, titel); }
      /* Faellt das Laden aus -- Netz weg, Datei umbenannt --, muss die
         Kachel zurueckfallen. Ein schwarzes Rechteck ohne Erklaerung ist
         schlechter als das Standbild, das vorher da war. */
      film.addEventListener('error', () => {
        console.error('[robbytoys] Video laedt nicht:', quelle);
        kachel.classList.remove('is-laeuft');
        film.remove();
      });
      kachel.appendChild(film);
      kachel.classList.add('is-laeuft');
      const versuch = film.play();
      /* Der Browser darf das Abspielen verweigern. Dann steht die
         Bedienleiste da und der Besucher drueckt selbst -- kein Fehler. */
      if (versuch && versuch.catch) versuch.catch(() => {});
      /* Ausserhalb des Bildes anhalten -- derselbe Beobachter wie ueberall,
         kein zweiter. Bei reduzierter Bewegung nicht: dort entscheidet der
         Besucher ueber die Bedienleiste, und ein Skript, das ihm das Video
         beim Scrollen anhaelt, nimmt ihm diese Entscheidung wieder ab. */
      if (!ruhig) beiSichtDauernd(film, (_el, drin) => { if (!drin) film.pause(); });
      try { film.focus({ preventScroll: true }); } catch (_) {}
    });
  });
}

/* ==========================================================================
   19 - Vollflaechige Hintergrundvideos.

   Das Vorbild legt Bewegtbild unter ganze Sektionen und schreibt den Text
   darauf. Hier gilt dabei dreierlei, und alle drei sind gemessene Zustaende
   des Geraets, keine Vermutung:

   - reduzierte Bewegung: eine Schleife im Hintergrund ist genau das, was
     dabei wegbleiben soll.
   - Datensparmodus (navigator.connection.saveData): der Besucher hat
     ausdruecklich gesagt, dass er Bytes sparen will.
   - 2g oder 3g: das Video kaeme nach dem Text an und ruckelt dann.

   In allen drei Faellen bleibt das Standbild stehen und es wird gar nichts
   geladen. Die Sektion verliert Bewegung, nicht Inhalt.

   Ausserhalb des Bildes wird angehalten. Ein dekodierendes Video kostet
   auf einem Handy messbar Akku, auch wenn niemand hinsieht.
   ========================================================================== */
function videoflaechen(wurzel = document) {
  const sparen = bytesSparen();

  alle('[data-rb-videoflaeche]', wurzel).forEach((flaeche) => {
    if (flaeche.dataset.rbBereit) return;
    flaeche.dataset.rbBereit = '1';
    const film = eins('video[data-rb-src]', flaeche);
    if (!film) return;
    const quelle = film.dataset.rbSrc;
    if (!quelle) return;

    /* Reduzierte Bewegung oder Datensparmodus: das Standbild bleibt stehen,
       und der Besucher bekommt einen Knopf statt gar nichts.

       Bis zum 21.08.2026 stand hier ein `return` -- dann gab es zwar keine
       Bewegung, aber auch keinen Weg, das Video ueberhaupt zu sehen. Mit
       preload="metadata" und ohne gesetztes src kostet der Knopf nichts,
       bis jemand ihn drueckt. */
    if (ruhig || sparen) {
      film.src = quelle;
      filmStehenLassen(film);
      film.removeAttribute('aria-hidden');
      film.tabIndex = 0;
      return;
    }

    /* Selbst setzen statt auf das Markup vertrauen: ohne muted verweigert
       jeder Browser das Abspielen ohne Klick, und dann steht ein schwarzes
       Rechteck ueber dem Standbild. */
    filmRuesten(film, null);
    film.setAttribute('aria-hidden', 'true');
    film.tabIndex = -1;
    film.addEventListener('playing', () => flaeche.classList.add('is-film'), { once: true });

    /* Bis zum 21.08.2026 hing hier ein Halteknopf (WCAG 2.2.2). Er ist auf
       Anweisung des Auftraggebers vom 21.08.2026 entfallen -- "keine pause
       buttons verfuegbar machen usw!". Die Begruendung und der Preis dafuer
       stehen vollstaendig in Teil 17b. Der Knopf selbst bleibt als Bauteil
       bestehen; das Bilderband in Teil 20 benutzt ihn weiter. */
    filmLaufenLassen(film, quelle);
  });
}

/* ==========================================================================
   19c - Die uebrigen Filme des Ladens.

   Dies ist ein NETZ, kein Hauptweg -- und es ist ausdruecklich so gemeint.

   Gemessen am 21.08.2026 um 18:26 im Baum: alle fuenf <video> der
   robby-Sektionen (buehne, bento, videowand, textbild, kleiderschrank)
   tragen `data-rb-neu-auto`, laufen stumm von selbst und werden von einem
   eigenen Skript in ihrer eigenen Sektionsdatei angehalten. Diese Funktion
   findet dort also NICHTS -- und das ist richtig so. Sie greift genau dann,
   wenn irgendwo ein <video> in den Laden kommt, um das sich niemand
   kuemmert: aus einer App, aus einem Rich-Text-Feld, aus einer Sektion, die
   ihr Skript beim naechsten Shrine-Update verliert. Ein solches Video haette
   sonst eine Bedienleiste und liefe nie an.

   AUSGENOMMEN sind drei Gruppen, jede mit Grund:

   - `video[data-rb-neu-auto]`. Diese Videos haben bereits einen Besitzer:
     das Skript ihrer Sektion. Ein zweiter Beobachter von hier aus wuerde
     dasselbe Video von zwei Stellen starten und anhalten, und zwar mit
     unterschiedlichen Schwellen (die Sektionen rechnen mit threshold 0,25,
     dieser Beobachter mit 0 und rootMargin -8 Prozent). Zwei Rueckrufe,
     zwei Wahrheiten.

     ⚠️ Gemessen am 21.08.2026: SECHS Sektionsdateien bringen einen eigenen
     `new IntersectionObserver` mit (buehne, bento, videowand, textbild,
     kleiderschrank, zahlen). Zusammen mit dem einen hier sind das sieben
     Beobachter auf einer Seite. Der Auftrag an diese Bahn lautet "EIN
     IntersectionObserver" -- er ist damit NICHT erfuellt, und er ist von
     hier aus auch nicht erfuellbar: die sechs Skripte stehen in fremden
     Dateien. Gemeldet am 21.08.2026. Sobald sie entfallen, faellt in der
     Zeile darunter das `:not([data-rb-neu-auto])` weg und rb-ui.js
     uebernimmt alle fuenf mit demselben einen Beobachter.

   - Alles in der Produktgalerie von Shrine. Die hat einen eigenen Spieler
     mit eigener Einstellung (`video_player`), und zwei Haende an einem
     Spieler heisst, dass keine von beiden weiss, welcher Zustand gilt.

   - Die Bauteile, die hier eine eigene Funktion haben (Videokachel Teil 18,
     Hintergrundflaeche Teil 19). Sie sind schon versorgt.
   ========================================================================== */
const FILM_FREMD = '.product__media-wrapper, .media-gallery, deferred-media, ' +
                   'product-model, .rb-videokachel, [data-rb-videoflaeche]';

function filmeUebernehmen(wurzel = document) {
  const sparen = bytesSparen();

  alle('video:not([data-rb-neu-auto]):not([data-rb-film])', wurzel).forEach((film) => {
    if (film.closest(FILM_FREMD)) return;

    if (ruhig || sparen) { filmStehenLassen(film); return; }

    filmRuesten(film, film.getAttribute('aria-label'));
    /* Kein `quelle`: diese Filme bringen ihre <source> selbst mit, samt
       der Unterscheidung zwischen Handy- und Bildschirmfassung. Sie stehen
       ohnehin auf preload="metadata", es faellt also vor dem Sichtkontakt
       nur der Dateikopf. */
    filmLaufenLassen(film, null);
  });
}

/* ==========================================================================
   20 - Die Kundenbild-Collage.

   Zwei bis drei Spuren, gegenlaeufig, langsam. Sie ist die einzige
   Endlosschleife, die im ersten Bildschirm stehen darf -- sie IST der
   Inhalt, den der Hersteller dort zeigt.

   Angehalten wird bei Hover, bei Tastaturfokus, bei Beruehrung, ueber den
   Halteknopf und ausserhalb des Bildes. Die ersten vier Faelle stehen in
   rb-motion.css, hier haengt nur die Beruehrung: auf dem Handy gibt es
   kein Hover, und wer ein Foto genauer ansehen will, tippt darauf.
   ========================================================================== */
function collagen(wurzel = document) {
  alle('[data-rb-collage]', wurzel).forEach((collage) => {
    if (collage.dataset.rbBereit) return;
    collage.dataset.rbBereit = '1';
    const spuren = alle('.rb-collage__spur', collage);
    if (!spuren.length) return;

    spuren.forEach((spur, i) => {
      /* Gemessen an den Vorlagen: 26 Pixel je Sekunde lassen ein 220px
         breites Foto in gut acht Sekunden durchlaufen. Schneller wird es
         zum Flimmern, langsamer sieht es nach Stillstand aus. Jede zweite
         Spur laeuft ein Stueck langsamer, sonst wirken zwei gegenlaeufige
         Reihen wie ein einziges Gitter. */
      const tempo = Number(spur.dataset.rbTempo || collage.dataset.rbTempo || (i % 2 ? 21 : 26));
      laufschleife(collage, spur, tempo, '--rb-collage-dur');
    });

    /* Dieselbe Begruendung wie beim Laufband, siehe `spurBilderHolen`: die
       Collage ist die einzige Endlosschleife, die schon im ersten
       Bildschirm stehen darf -- und genau dort waeren traege Bilder am
       sichtbarsten. */
    beiSichtDauernd(collage, (_el, drin) => {
      if (drin && !collage.dataset.rbBildGeholt) {
        collage.dataset.rbBildGeholt = '1';
        spuren.forEach(spurBilderHolen);
      }
    });
    halteknopf(collage, 'Bilderband', null);

    collage.addEventListener('pointerdown', (e) => {
      if (e.pointerType === 'mouse') return;    /* die Maus haelt ueber Hover */
      collage.classList.add('is-tipp');
    }, { passive: true });
    ['pointerup', 'pointercancel', 'pointerleave'].forEach((art) => {
      collage.addEventListener(art, () => collage.classList.remove('is-tipp'), { passive: true });
    });
  });
}

/* ==========================================================================
   21 - Ganze Bildergruppen nachladen.

   `loading="lazy"` deckt den Normalfall ab. Es deckt NICHT ab, was in
   einem geschlossenen Reiter oder hinter `hidden` steht: so ein Bild
   erreicht das Sichtfenster nie, der Browser laedt es nie, und beim
   Aufklappen steht ein Loch.

   Deshalb haengt das Nachladen hier nicht am Bild, sondern am Kasten
   darum: `data-rb-nachladen` auf die Gruppe, `data-rb-src` an die Bilder.
   Wird der Kasten sichtbar, kommen alle Bilder darin -- auch die
   verborgenen. Gedacht fuer die acht bewegten Gesichter und die
   Kleiderschrank-Ansichten, die sonst 36 Bilder im ersten Aufruf waeren.
   ========================================================================== */
function nachladen(wurzel = document) {
  alle('[data-rb-nachladen]', wurzel).forEach((kasten) => {
    const bilder = alle('img[data-rb-src]', kasten);
    if (!bilder.length) return;
    beiSicht(kasten, () => bilder.forEach((bild) => {
      if (bild.dataset.rbSrcset) { bild.srcset = bild.dataset.rbSrcset; bild.removeAttribute('data-rb-srcset'); }
      bild.src = bild.dataset.rbSrc;
      bild.removeAttribute('data-rb-src');
    }));
  });
}

/* ==========================================================================
   22 - Schwebende Figuren.

   Die zehn freigestellten Comicfiguren und die Streuobjekte sollen ueber
   der Farbflaeche schweben, nicht darauf kleben. Zehn Figuren im
   Gleichtakt sehen allerdings aus wie ein Fehler im Stilblatt -- deshalb
   bekommt jede eine eigene Dauer, einen eigenen Weg und einen negativen
   Versatz: sie steht damit schon mitten in ihrer Schleife, wenn die
   Sektion auftaucht, statt gemeinsam mit allen anderen unten anzufangen.

   ⚠️ Im ersten Bildschirm schwebt nichts. Das ist gemessen, nicht
   geraten: liegt die Figur beim Start ueber der Falzkante, bekommt sie
   statt der Schleife eine einmalige Einblendung. Dauerbewegung im ersten
   Bildschirm zieht das Auge vom Kaufknopf weg und laesst die Seite auf
   einem schwachen Geraet zaeh anlaufen.
   ========================================================================== */
function schweben(wurzel = document) {
  if (ruhig) return;
  alle('.rb-schweben', wurzel).forEach((el) => {
    if (el.dataset.rbBereit) return;
    el.dataset.rbBereit = '1';
    const oben = el.getBoundingClientRect().top;
    if (el.closest('[data-rb-boot]') || (oben > 0 && oben < innerHeight * 0.9)) {
      el.classList.add('rb-schweben--einmal');
      return;
    }
    el.style.setProperty('--rb-schweb-dur', zwischen(4.5, 7.5).toFixed(2) + 's');
    el.style.setProperty('--rb-schweb-delay', '-' + zwischen(0, 7.5).toFixed(2) + 's');
    el.style.setProperty('--rb-schweb-weg', zwischen(6, 14).toFixed(0) + 'px');
    el.style.setProperty('--rb-schweb-dreh', zwischen(-2.5, 2.5).toFixed(2) + 'deg');
    beiSichtDauernd(el);
  });
}

/* ==========================================================================
   23 - Die scrollgebundene Ebene: Parallaxe der Buehnen und der Kopf.

   Neu am 21.08.2026. Zwei Aufgaben, ein Motor.

   ⚠️ ES GIBT KEIN ZWEITES GERAET. Gerechnet wird in demselben
   requestAnimationFrame wie die Pupillen -- ueber `anhaengen` aus Teil 2 --
   und beobachtet wird mit demselben IntersectionObserver wie die
   Einblendungen, ueber `beiSichtDauernd` aus Teil 1. Ein eigener
   Bildtakt neben dem vorhandenen rechnet nicht nur doppelt, er landet
   auch in anderen Bildern: Kopf und Buehnenbild wuerden sichtbar
   auseinanderlaufen.

   ⚠️ DER BILDTAKT LAEUFT NICHT DAUERHAFT. `scrollTakt` meldet sich selbst
   ab, sobald ein Bild lang kein Scrollen mehr gemeldet wurde -- genau das
   Muster, mit dem der Zeiger schon arbeitet (`mausNeu`). Eine Rechnung,
   die immer `true` liefert, haelt den Bildtakt fuer die ganze Sitzung am
   Leben und kostet Akku, auch wenn niemand scrollt.

   ⚠️ prefers-reduced-motion WIRD HIER VORHER GEPRUEFT, NICHT NACHTRAEGLICH
   ABGESCHALTET. Bei reduzierter Bewegung wird keine einzige Bahn
   eingesammelt, kein `rb-par` gesetzt und kein `rb-kopf-weg` je geschaltet.
   Wer eine vestibulaere Stoerung hat, dem wird von einer wandernden
   Bildflaeche schlecht -- eine Bewegung, die erst laeuft und dann per
   Stilblatt gekuerzt wird, ist fuer diesen Menschen bereits passiert.

   Teure Eigenschaften kommen nicht vor. Geschrieben wird ausschliesslich
   die Variable --rb-par-y, und die landet in rb-motion.css in einem
   translate3d. Kein top, kein height, kein background-position: das waeren
   drei Wege, bei jedem Bild das Layout der ganzen Seite neu rechnen zu
   lassen. Gemessen ist die Bildrate NICHT -- das geht ohne laufenden
   Browser am Shop nicht.
   ========================================================================== */

/* --- Die Grenzwerte des Kopfes ----------------------------------------
   Vier Paare, und jedes Paar ist absichtlich ungleich. DAS ist die
   Hysterese: waere Ein- und Ausschaltpunkt dieselbe Zahl, wuerde der
   Kopf an genau dieser Zahl bei jedem Zittern des Rades umspringen --
   auf einem Trackpad mehrmals je Sekunde.

   KOPF_AB / KOPF_ZURUECK: er darf erst ab 160 px verschwinden, kommt aber
   schon unter 96 px unbedingt zurueck. Die 64 px dazwischen sind der
   Bereich, in dem gar nichts geschieht.

   KOPF_RUNTER / KOPF_HOCH: nach unten muss man 64 px ziehen, damit er
   geht; nach oben genuegen 24 px, damit er kommt. Absichtlich ungleich --
   ein Kopf, der zoegerlich zurueckkommt, fuehlt sich kaputt an, ein Kopf,
   der zu leicht verschwindet, ebenso.

   SPRUNG: ein einzelner Schritt von mehr als 400 px ist kein Ziehen,
   sondern ein Sprung -- ein Ankerklick, ein "nach oben"-Knopf, eine
   wiederhergestellte Scrollstellung. Er zaehlt nicht mit, sonst schoebe
   ein Ankersprung den Kopf weg und das Sprungziel liefe unter ihm
   hindurch.

   ⚠️ Gemessen wird je BILD, nicht je Scroll-Ereignis. Deshalb stand hier
   zuerst 240, und deshalb ist es falsch: ein schneller Wisch auf einem
   Trackpad legt bei 60 Bildern je Sekunde ohne Weiteres 300 px je Bild
   zurueck. Mit 240 haette der Kopf ausgerechnet beim schnellen Scrollen
   nicht nachgegeben. 400 px je Bild sind 24.000 px je Sekunde -- das
   erreicht kein Ziehen mehr, aber jeder Ankersprung liegt darueber.
   Bewusst in Kauf genommen: ein Tastendruck auf Bild-ab (rund 810 px)
   gilt damit als Sprung und laesst den Kopf stehen. Lieber ein Kopf, der
   einmal zu viel steht, als einer, der bei jedem Tastendruck springt. */
const KOPF_AB        = 160;
const KOPF_ZURUECK   = 96;
const KOPF_KLEIN_AN  = 96;
const KOPF_KLEIN_AUS = 40;
const KOPF_RUNTER    = 64;
const KOPF_HOCH      = 24;
const SPRUNG         = 400;

/* Der Weg der Parallaxe je Richtung, als Anteil der Bahnhoehe. 5,5 Prozent
   passen genau in die Reserve, die rb-motion.css mit scale(1.12) anlegt --
   6 Prozent oben, 6 Prozent unten. Wer hier hochgeht, MUSS dort mitgehen,
   sonst laeuft an der Kante ein Streifen Hintergrund ins Bild.
   Der Deckel von 64 px haelt eine sehr hohe Buehne im Rahmen: 5,5 Prozent
   von 1400 px waeren 77 px, und das ist kein Nebenbei mehr. */
const PAR_ANTEIL = 0.055;
const PAR_MAX    = 64;

/* ALLE Bahnen der Seite, nicht nur die sichtbaren.

   ⚠️ Hier stand zuerst eine Liste, die der Dauerbeobachter fuellt und
   leert -- gerechnet wurde nur fuer das, was im Bild steht. Gemessen am
   21.08.2026 in der oertlichen Probe ist das falsch: springt man von
   Scrollstellung 2500 zurueck auf 0, ist die Buehne sofort wieder da,
   die Liste aber noch leer. Ihr Bild stand dann mit dem Wert von vorher
   (-35,0 px) im Bild, bis der Beobachter Bilder spaeter meldete -- ein
   Ruck genau in dem Augenblick, in dem der Besucher hinsieht.

   Jetzt wird immer fuer alle gerechnet. Das kostet je Bild eine
   Vermessung je Bahn, und Bahnen gibt es wenige: gemessen am 21.08.2026
   am ausgelieferten HTML zwei auf der Startseite, eine auf
   /products/eilik. Wer diese Zahl einmal deutlich erhoeht, sollte die
   Rechnung wieder an `is-sicht` haengen -- bei zwei Elementen ist das
   eine Optimierung, die nur einen Fehler einbaut. */
const bahnen = new Set();

let scrollNeu = true;
let kopfEl    = null;
let kopfWeg   = false;
let letzteY   = -1;
let runter    = 0;
let hoch      = 0;
/* Laeuft gerade ein Ankersprung? Gesetzt in ankerWeich(), gelesen in
   kopfGebunden(). Begruendung dort. */
let sprungLaeuft = false;
let werkLaeuft = false;

/* Eine einzelne Bahn VERMESSEN. Ergebnis ist genau eine Zahl als Text:
   der senkrechte Weg der Bildschicht. Geschrieben wird hier nichts --
   Messen und Schreiben sind getrennt, siehe `scrollTakt`. */
function bahnMessen(b, h) {
  /* Eine Sektion, die der Theme-Editor ausgetauscht hat, haengt sonst bis
     zum Seitenwechsel in der Liste und wird bei jedem Bild vermessen. */
  if (!b.sek.isConnected) { bahnen.delete(b); return null; }

  const r = b.sek.getBoundingClientRect();

  /* 0 heisst: die Bahn steht mittig im Fenster. +1 heisst: sie kommt
     gerade von unten herein, -1: sie geht oben hinaus. Der Nenner ist die
     ganze Strecke, die sie dabei zuruecklegt -- Fensterhoehe plus eigene
     Hoehe. Ohne diesen Nenner liefe eine hohe Sektion viel weiter als eine
     flache, und zwei Buehnen untereinander waeren verschieden schnell. */
  let p = ((r.top + r.height / 2) - h / 2) / ((h + r.height) / 2);
  if (p > 1) p = 1; else if (p < -1) p = -1;

  const weg = Math.min(r.height * PAR_ANTEIL, PAR_MAX);

  /* ⚠️ DAS MINUS IST DER GANZE EFFEKT. Es ist am 21.08.2026 dazugekommen,
     und es ist keine Geschmacksfrage.

     GEMESSEN am 21.08.2026, headless Chrome 151.0.7922.173, Live-Seite
     /products/eilik, Buehne 532,2 px hoch, 153 px gescrollt:

       vorher   Sektion wandert auf dem Schirm  -153,0 px
                Bildschicht wandert             -161,8 px   = 8,8 px MEHR
       nachher  Bildschicht wandert             -144,2 px   = 8,8 px WENIGER

     Vorher lief die Bildschicht also SCHNELLER als die Seite. Das ist die
     Bewegung eines Vordergrunds, der auf den Betrachter zufliegt -- nicht
     die eines Hintergrunds, der zurueckbleibt. Der Auftrag vom 21.08.2026
     verlangt woertlich das Gegenteil: "Ein vollflaechiges Hintergrundbild
     darf sich LANGSAMER bewegen als der Text davor." Der Kommentar in
     rb-motion.css Abschnitt 16 sagte seit dem 21.08.2026 dasselbe
     ("wandert ein Stueck langsamer als die Seite") -- die Rechnung tat es
     nicht. Beschreibung und Messung stimmen jetzt ueberein.

     Warum es niemandem auffiel: 8,8 px auf 153 px sind 5,75 Prozent. In
     beiden Richtungen sieht das nach Tiefe aus. Der Unterschied ist, in
     welche. Wer diesen Effekt einmal falsch herum sieht, nennt ihn
     "irgendwie unruhig", ohne sagen zu koennen, warum -- der Hintergrund
     ueberholt den Text, den er tragen soll.

     Der WEG aendert sich dadurch nicht, nur seine Richtung. Die Reserve
     aus scale(1.12) traegt ihn unveraendert: gemessen 596,1 px Bildhoehe
     auf 532,2 px Sektionshoehe, also 31,9 px Reserve je Seite gegen
     hoechstens 29,3 px Weg. */
  return (-p * weg).toFixed(1);
}

function bahnSchreiben(b) {
  /* Derselbe Wert wie im Bild davor: nicht schreiben. Jedes Schreiben an
     style stoesst eine Neuberechnung an, auch wenn sich nichts aendert. */
  if (b.wert === null || b.wert === b.letzte) return;
  b.letzte = b.wert;
  b.schicht.style.setProperty('--rb-par-y', b.wert + 'px');
}

/* VIER Faelle, in denen der Kopf stehen bleibt, obwohl gescrollt wird.
   Der vierte ist der laufende Ankersprung und kam am 26.08.2026 dazu;
   warum, steht bei ankerWeich().
   Der Zeiger darauf und der Fokus darin stehen NICHT hier, sondern als
   :hover und :focus-within in rb-motion.css -- das weiss der Browser
   ohnehin, dafuer muss kein Skript bei jedem Bild nachsehen. Hier steht
   nur, was CSS nicht sieht: ein offenes Schubfach macht der Rumpf mit
   `overflow-hidden` kenntlich, und das steht nicht im Kopf. */
function kopfGebunden() {
  return sprungLaeuft
      || document.body.classList.contains('overflow-hidden')
      || !!kopfEl.querySelector('details[open]')
      || kopfEl.contains(document.activeElement);
}

/* ==========================================================================
   Die Kopfhoehe, die nicht mehr luegt.

   GEMESSEN am 21.08.2026 in Chrome bei 1440 x 900 auf der Startseite:

     Zustand        Kopfkasten   Token --header-height   Abweichung
     in Ruhe          82,8 px            83 px             0,2 px
     geschrumpft      70,8 px            83 px            12,2 px

   Shrine schreibt den Token EINMAL beim Seitenaufbau auf das <html> und
   misst dabei den Kopf in Ruhe. Der Kopf schrumpft danach aber:
   robby-kopf.liquid Abschnitt 4 nimmt ihm ab 96 px Scrollweg den
   Innenabstand (gemessen 8 px -> 2 px je Seite). Ab da behauptet der Token
   12,2 px Kopf, die es nicht gibt.

   Das ist kein Schoenheitsfehler, denn vier Dinge rechnen mit dem Wert:
   scroll-padding-top (rb-overrides.css Abschnitt 18, gemessen 107 px),
   der Klebeabstand der Produktspalten (Abschnitt 19), die Hoehe der
   Mega-Menues und Shrines eigener Fortschrittsbalken. Ein Ankersprung
   landet damit dauerhaft 12 px zu tief -- und zwar IMMER, denn ein
   Ankersprung findet praktisch nie im Ruhezustand statt, sondern stets bei
   bereits geschrumpftem Kopf.

   Nachgemessen wird NUR, wenn sich etwas geaendert haben kann: beim
   Wechsel zwischen gross und klein, bei Groessenaenderung des Fensters und
   einmal nach dem Uebergang. NICHT bei jedem Bild -- ein
   getBoundingClientRect je Bild erzwingt je Bild eine Layout-Rechnung, und
   genau davor warnt der Kommentar ueber `scrollTakt`.

   Nicht gemessen wird, solange ein Schubfach offen ist: der Rumpf traegt
   dann `overflow-hidden`, im Kopf steht ein aufgeklapptes Menue, und
   dessen Hoehe ist nicht die Hoehe der Leiste.

   Der Wert wird als `--header-height` geschrieben und nicht unter eigenem
   Namen. Ein eigener Name waere ehrlicher, haette aber keinen einzigen
   Leser: alle vier Rechnungen oben stehen in fremden Dateien und lesen
   Shrines Namen. Ein zweiter Token daneben waere ein zweiter Wert, den man
   pflegen muss, ohne dass der erste aufhoert zu luegen. */
let kopfHoehe = -1;
let kopfNachschlag = 0;

function kopfHoeheMessen() {
  if (!kopfEl || !document.documentElement.contains(kopfEl)) return;
  if (document.body && document.body.classList.contains('overflow-hidden')) return;
  const h = kopfEl.getBoundingClientRect().height;
  if (!h) return;
  /* Unter einem Pixel Unterschied ist kein Unterschied. Jedes Schreiben an
     einer Variablen des Wurzelelements macht das Layout ungueltig. */
  if (Math.abs(h - kopfHoehe) < 1) return;
  kopfHoehe = h;
  document.documentElement.style.setProperty('--header-height', Math.round(h) + 'px');
}

/* Zweimal messen: jetzt und nach dem Uebergang. Der Innenabstand des
   Kopfes laeuft ueber --rb-t (320 ms, rb-tokens.css). Wer nur sofort
   misst, misst den Anfang der Bewegung und schreibt den alten Wert. */
function kopfHoeheNachtragen() {
  kopfHoeheMessen();
  clearTimeout(kopfNachschlag);
  kopfNachschlag = setTimeout(kopfHoeheMessen, 400);
}

function kopfSetzen(weg) {
  if (weg === kopfWeg) return;
  if (weg && kopfGebunden()) return;
  kopfWeg = weg;
  document.documentElement.classList.toggle('rb-kopf-weg', weg);
}

function kopfRechnen() {
  if (!kopfEl) return;
  const y = Math.max(0, window.scrollY || 0);
  /* Beim ersten Aufruf gibt es kein Davor. Ohne diese Zeile waere der
     erste Schritt so gross wie die wiederhergestellte Scrollstellung. */
  if (letzteY < 0) letzteY = y;
  const d = y - letzteY;
  letzteY = y;

  /* Der Zustand "nicht mehr ganz oben". Er sagt nichts ueber die Richtung
     und wird deshalb auch bei reduzierter Bewegung gesetzt: er ist keine
     Bewegung, sondern eine Auskunft an das Stilblatt. */
  const w = document.documentElement.classList;
  const kleinVorher = w.contains('rb-kopf-klein');
  if (y > KOPF_KLEIN_AN) w.add('rb-kopf-klein');
  else if (y < KOPF_KLEIN_AUS) w.remove('rb-kopf-klein');
  /* Genau hier wechselt der Kopf seine Hoehe -- und nur hier wird deshalb
     nachgemessen. Das steht VOR dem Ausstieg bei reduzierter Bewegung,
     weil die Hoehe keine Bewegung ist, sondern eine Auskunft. */
  if (w.contains('rb-kopf-klein') !== kleinVorher) kopfHoeheNachtragen();

  if (ruhig) return;

  if (Math.abs(d) > SPRUNG) { runter = 0; hoch = 0; }
  else if (d > 0) { runter += d; hoch = 0; }
  else if (d < 0) { hoch -= d; runter = 0; }

  if (y < KOPF_ZURUECK) { kopfSetzen(false); return; }
  if (runter > KOPF_RUNTER && y > KOPF_AB) kopfSetzen(true);
  else if (hoch > KOPF_HOCH) kopfSetzen(false);
}

/* Die eine Rechnung im Bildtakt. Sie meldet sich ab, sobald nichts Neues
   mehr kam -- der Bildtakt steht dann still, bis wieder gescrollt wird. */
function scrollTakt() {
  if (!scrollNeu) return false;
  scrollNeu = false;
  kopfRechnen();
  /* ⚠️ ERST ALLE MESSEN, DANN ALLE SCHREIBEN. Wer im Wechsel misst und
     schreibt, zwingt den Browser zwischen je zwei Bahnen zu einer neuen
     Layout-Rechnung: das Schreiben macht das Layout ungueltig, die
     naechste Vermessung erzwingt es wieder. Bei zwei Bahnen faellt das
     nicht auf. Die Reihenfolge steht trotzdem richtig herum, damit es
     auch bei zehn nicht auffaellt. */
  const h = window.innerHeight || 1;
  for (const b of bahnen) b.wert = bahnMessen(b, h);
  for (const b of bahnen) bahnSchreiben(b);
  return true;
}

function scrollMerken() { scrollNeu = true; anhaengen(scrollTakt); }

/* Den Sektionsrahmen des Kopfes suchen und mit `rb-kopf` auszeichnen.
   Nicht `.section-header` fest verdrahtet: der Rahmen gehoert Shrine, und
   was Shrine gehoert, kann ein Update umbenennen. Vier Wege, der erste,
   der traegt, gewinnt.

   Der Theme-Editor baut den Kopf einzeln neu auf. Danach ist der alte
   Knoten aus dem Dokument, und `contains` sorgt dafuer, dass wir den
   neuen nehmen statt einen Knoten zu bewegen, den niemand mehr sieht. */
function kopfFinden() {
  if (kopfEl && document.documentElement.contains(kopfEl)) return kopfEl;
  const klebend = eins('sticky-header');
  const marke   = eins('header');
  kopfEl = eins('.section-header')
        || (klebend && klebend.closest('.shopify-section'))
        || (marke && marke.closest('.shopify-section'))
        || marke;
  if (kopfEl) kopfEl.classList.add('rb-kopf');
  return kopfEl;
}

/* Die Bahnen einsammeln. Eine Bahn ist eine vollflaechige Buehne oder
   irgendetwas, das sich mit data-rb-parallax selbst dazu erklaert.

   ⚠️ Kachelraster und Videowand sind ABSICHTLICH nicht dabei, obwohl sie
   dieselbe .rb-neu-med tragen. Elf wandernde Kacheln nebeneinander sind
   genau das "erschlagen", das der Auftraggeber nicht will. Gemessen am
   21.08.2026 am ausgelieferten HTML: 14 Medienflaechen auf der Startseite,
   davon 2 in einer Buehne. Es bewegen sich also 2 von 14. */
function bahnenSammeln(wurzel) {
  alle('.rb-neu-buehne, [data-rb-parallax]', wurzel).forEach((sek) => {
    if (sek.dataset.rbBahn) return;
    sek.dataset.rbBahn = '1';

    const schicht = eins('[data-rb-parallax-schicht], .rb-neu-med__bild, .rb-neu-med__video', sek);
    /* Eine Buehne ohne Bild ist eine Farbflaeche. Da gibt es nichts zu
       verschieben, und ein leerer Eintrag in der Liste kostet bei jedem
       Bild eine Vermessung. */
    if (!schicht) return;

    /* Der Eingang haengt an der HUELLE, die Parallaxe an der SCHICHT darin.
       Zwei Elemente, zwei transform. Beides auf dasselbe Element zu legen
       hiesse, dass die letzte Zuweisung die andere loescht -- und das
       faellt erst im Betrieb auf, weil beide fuer sich richtig aussehen. */
    const huelle = schicht.closest('.rb-neu-med') || schicht.parentElement;
    if (huelle) { huelle.classList.add('rb-med-auf'); beiSicht(huelle); }

    schicht.classList.add('rb-par');
    sek.classList.add('rb-par-bahn');

    bahnen.add({ sek: sek, schicht: schicht, letzte: '', wert: null });

    /* Der Dauerbeobachter setzt hier nur noch `is-sicht`, und `is-sicht`
       schaltet in rb-motion.css allein das will-change. Die Rechnung
       haengt NICHT mehr daran -- siehe die Begruendung ueber `bahnen`.
       Beobachtet wird trotzdem, denn will-change auf einer Buehne, die
       zehn Bildschirme entfernt liegt, ist eine Bildebene im Speicher,
       die niemand sieht. */
    beiSichtDauernd(sek);
  });
}

function scrollWerk(wurzel = document) {
  kopfFinden();
  /* Einmal gleich zu Anfang. Shrine hat den Token da schon geschrieben,
     der Wert stimmt also meist -- aber nur meist: der Theme-Editor baut
     den Kopf neu auf, und ein Logo, das erst nach dem Token geladen wurde,
     aendert die Hoehe. */
  kopfHoeheNachtragen();
  if (!ruhig) bahnenSammeln(wurzel);

  /* Die Zuhoerer haengen genau einmal. `start` laeuft bei jedem
     shopify:section:load erneut -- ohne diesen Riegel haette der Shop nach
     zehn Sektionswechseln im Editor zehn Scroll-Zuhoerer. */
  if (werkLaeuft) { scrollMerken(); return; }
  werkLaeuft = true;
  window.addEventListener('scroll', scrollMerken, { passive: true });
  window.addEventListener('resize', scrollMerken, { passive: true });
  /* Bei Groessenaenderung wechselt der Kopf zwischen drei Fassungen
     (gemessen: unter 750 px, 750 bis 989 px, ab 990 px). Die Hoehe aendert
     sich dabei, ohne dass gescrollt wird -- kopfRechnen wuerde es also
     nicht bemerken. Ein Zuhoerer mehr, kein Beobachter und kein Bildtakt
     mehr; er haengt wie die beiden darueber genau einmal. */
  window.addEventListener('resize', kopfHoeheNachtragen, { passive: true });
  scrollMerken();
}

/* ==========================================================================
   23b - Weiches Scrollen nur bei einem echten Klick auf einen Anker der
   laufenden Seite, niemals beim Laden.

   Befund 22.08.2026, woertlich vom Auftraggeber: ein Klick auf "Eilik"
   laesst die Seite "sofort runterfliegen". Ursache: base.css setzt
   html{scroll-behavior:smooth} fuer das GANZE Dokument, also auch fuer den
   Sprung, den der Browser beim Aufbau einer Seite mit #anker in der
   Adresse selbst ausfuehrt -- gemessen faehrt die Seite dann sichtbar von
   oben bis zu 53,6 Prozent des Dokuments herunter, statt sofort dort zu
   stehen.

   Ganz oben in dieser Datei steht deshalb `scrollBehavior = 'auto'` als
   Grundzustand (Inline-Stil, schlaegt jede Stilblatt-Regel gleicher
   Gewichtung). Dieser Zuhoerer schaltet weich NUR fuer den einen Sprung
   ein, den ein echter Klick ausloest, und schaltet direkt danach wieder
   zurueck -- sonst bliebe jeder KUENFTIGE Ladevorgang auf dieser Seite
   ebenfalls weich, ohne dass hier ein Klick stattfand.

   Nur Anker der LAUFENDEN Seite zaehlen: ein Link auf eine andere Seite
   mit #anker soll dort weich ankommen koennen, laedt hier aber ohnehin neu
   -- diese Datei muss dafuer nichts tun. */
function ankerWeich() {
  document.addEventListener('click', (e) => {
    if (ruhig) return;
    const a = e.target.closest('a[href*="#"]');
    if (!a) return;
    let ziel_url;
    try { ziel_url = new URL(a.href, location.href); } catch (_) { return; }
    if (ziel_url.pathname !== location.pathname || ziel_url.search !== location.search || !ziel_url.hash) return;
    if (!document.getElementById(decodeURIComponent(ziel_url.hash.slice(1)))) return;

    /* ⚠️ UND DER KOPF MUSS WAEHREND DES SPRUNGS STEHEN BLEIBEN.

       Der Schutz dafuer steht schon in kopfRechnen(): ein Schritt von mehr
       als SPRUNG (400px) gilt als Sprung und zaehlt nicht mit. Gemessen wird
       aber je BILD -- und genau das macht ihn hier blind. Ein WEICHER Sprung
       legt je Bild deutlich weniger als 400px zurueck, also greift
       Math.abs(d) > SPRUNG nie, `runter` laeuft ueber KOPF_RUNTER, und der
       Kopf faehrt mitten im Sprung weg. scroll-padding-top reserviert dann
       Platz fuer einen Kopf, der nicht mehr da ist: gemessen am 26.08.2026
       auf /products/eiliko rund 99px sichtbare Luft ueber dem Sprungziel.

       Der Zustand sperrt kopfSetzen(true) fuer die Dauer des Sprungs.
       Zurueckkommen darf der Kopf weiter -- kopfSetzen prueft die Sperre nur
       bei weg === true.

       ⚠️ DIE RUECKFALLFRIST STEHT JETZT IMMER, nicht nur ohne scrollend.
       Feuert scrollend einmal nicht -- etwa weil das Ziel schon im Bild steht
       und gar nicht gescrollt wird --, bliebe der Kopf sonst FUER IMMER
       gesperrt. Bei scrollBehavior war dieselbe Luecke harmlos, bei einer
       Kopfsperre waere sie sichtbar. `erledigt` macht den Aufruf einmalig,
       gleich welcher Weg zuerst kommt.

       runter und hoch werden mit zurueckgesetzt: nach einem Sprung ueber
       1000px stuende runter weit ueber KOPF_RUNTER, und der naechste kleine
       Schritt liesse den Kopf sofort verschwinden. */
    document.documentElement.style.scrollBehavior = 'smooth';
    sprungLaeuft = true;
    let erledigt = false;
    const zuruecksetzen = () => {
      if (erledigt) return;
      erledigt = true;
      document.documentElement.style.scrollBehavior = 'auto';
      sprungLaeuft = false;
      runter = 0;
      hoch = 0;
      document.removeEventListener('scrollend', zuruecksetzen);
    };
    if ('onscrollend' in window) document.addEventListener('scrollend', zuruecksetzen);
    /* 1000ms deckt jeden Sprung auf dieser Seite bequem ab -- laenger als die
       laengste eigene Uebergangsdauer (--rb-t-lg, 640ms). */
    setTimeout(zuruecksetzen, 1000);
  }, { passive: true });
}

/* ==========================================================================
   24 - Der Antrieb der Welle zwischen zwei Sektionen.

   Neu am 21.08.2026. Die WELLE selbst -- ihre Form, ihre Farbe, ihr SVG --
   gehoert der Bahn "uebergaenge" und steht in deren Dateien. Hier steht
   nur, was sie bewegt. Zwei Dinge sind daran wichtig:

   ⚠️ ES GIBT KEINEN ZWEITEN BILDTAKT. Eine Welle, die sich ihr eigenes
   requestAnimationFrame nimmt, rechnet nicht nur doppelt -- sie landet in
   anderen Bildern als die Parallaxe und der Kopf. Zwei Bewegungen, die
   nebeneinander laufen sollen, laufen dann sichtbar auseinander. Wer eine
   Welle baut, ruft `window.rbUI.anhaengen(fn)` oder gar nichts.

   ⚠️ DER REGELFALL BRAUCHT UEBERHAUPT KEIN SKRIPT. Eine wandernde Welle
   ist eine CSS-Animation auf transform. Die laeuft im Compositor, kostet
   den Hauptthread nichts und ist mit `animation-play-state` anzuhalten.
   Genau das macht `data-rb-welle` ohne weiteren Wert: das Element kommt in
   die EINE Dauerbeobachtung und traegt `is-sicht`, solange es im Bild
   steht. rb-motion.css Abschnitt 21 haelt es ausserhalb an.

   Der Sonderfall `data-rb-welle="takt"` ist fuer eine Welle, die sich in
   Keyframes nicht ausdruecken laesst -- ein SVG-Pfad, der je Bild neu
   gezeichnet wird. Sie bekommt dann `--rb-welle-t`, eine Zahl, die in
   `data-rb-welle-dauer` Millisekunden einmal von 0 auf 1 laeuft und wieder
   bei 0 anfaengt.

   ⚠️ DER TAKT MELDET SICH AB, SOBALD DIE WELLE AUS DEM BILD IST. Eine
   Rechnung, die immer `true` liefert, haelt den Bildtakt fuer die ganze
   Sitzung am Leben und kostet Akku, auch wenn niemand hinsieht -- dieselbe
   Regel wie bei `scrollTakt` in Teil 23. Wieder angehaengt wird sie vom
   Dauerbeobachter, der ohnehin schon meldet.

   ⚠️ prefers-reduced-motion WIRD VORHER GEPRUEFT, NICHT NACHTRAEGLICH
   ABGESCHALTET. Bei reduzierter Bewegung wird keine einzige Welle
   eingesammelt, keine beobachtet und keine gerechnet. Eine Bewegung, die
   erst laeuft und dann per Stilblatt gekuerzt wird, ist fuer den Menschen,
   den sie krank macht, bereits passiert.
   ========================================================================== */

/* 9 Sekunden je Durchlauf. Gewaehlt, nicht gemessen: eine Welle, die
   schneller laeuft, zieht das Auge von der Ueberschrift daneben weg --
   und genau dafuer steht sie nicht da. Ueberschreibbar je Element mit
   data-rb-welle-dauer. */
const WELLE_DAUER = 9000;

function wellen(wurzel = document) {
  if (ruhig) return;

  alle('[data-rb-welle]', wurzel).forEach((welle) => {
    if (welle.dataset.rbWelleBereit) return;
    welle.dataset.rbWelleBereit = '1';

    /* ⚠️ DIESE KLASSE IST DIE UEBERNAHME DER VERANTWORTUNG. Erst mit ihr
       greift in rb-motion.css Abschnitt 21 das Anhalten ausserhalb des
       Bildes. Ohne sie -- also wenn dieses Skript nie ankommt -- laeuft die
       Welle einfach durch, statt eingefroren dazustehen. Dieselbe Regel
       wie ganz oben: ohne Skript ist alles sichtbar und alles laeuft. */
    welle.classList.add('rb-welle-bereit');

    /* Der Regelfall: nur beobachten. `is-sicht` schaltet in rb-motion.css
       die Animation an und aus, gerechnet wird hier nichts. */
    if (welle.dataset.rbWelle !== 'takt') { beiSichtDauernd(welle); return; }

    const dauer = Math.max(1000, Number(welle.dataset.rbWelleDauer) || WELLE_DAUER);
    /* Ein zufaelliger Versatz je Welle. Ohne ihn stehen zwei Wellen auf
       derselben Seite im Gleichschritt, und zwei gleiche Bewegungen
       nebeneinander sehen aus wie ein Gitter, nicht wie Wasser. */
    const versatz = Math.random() * dauer;
    let letzte = '';

    const takt = (zeit) => {
      /* Der Theme-Editor tauscht Sektionen aus. Ein Knoten, den niemand
         mehr sieht, wird nicht weitergerechnet. */
      if (!welle.isConnected) return false;
      if (!welle.classList.contains('is-sicht')) return false;
      /* Auf Tausendstel gerundet: das sind bei 9 Sekunden 9ms Schrittweite,
         feiner als ein Bild. Jedes Schreiben an style macht den Stil
         ungueltig -- derselbe Wert wird deshalb nicht zweimal geschrieben. */
      const t = (((zeit + versatz) % dauer) / dauer).toFixed(3);
      if (t !== letzte) { letzte = t; welle.style.setProperty('--rb-welle-t', t); }
      return true;
    };

    beiSichtDauernd(welle, (_el, drin) => { if (drin) anhaengen(takt); });
  });
}

/* ==========================================================================
   25 - Was rb-ui.js nach aussen anbietet.

   ⚠️ WOZU ES DAS GIBT -- die Zahl steht im Auftrag vom 21.08.2026:
   SIEBEN IntersectionObserver auf einer Seite. Einer hier, sechs in
   einzelnen Sektionsdateien (buehne, bento, videowand, textbild,
   kleiderschrank, zahlen). Jeder von ihnen arbeitet beim Scrollen eine
   eigene Rueckrufliste ab, und fuenf der sechs tun dasselbe: ein <video>
   anhalten, das aus dem Bild gelaufen ist.

   Diese Datei kann die sechs nicht selbst abschaffen -- sie stehen in
   fremden Dateien. Sie kann aber den einen Beobachter anbieten, den es
   ohnehin schon gibt. Der genaue Wortlaut, wie eine Sektion ihn
   anspricht, ist am 21.08.2026 an die uebrigen Bahnen gemeldet worden.

   ⚠️ DIE WARTESCHLANGE IST KEIN SCHMUCK. Ein <script> im Rumpf einer
   Sektion laeuft WAEHREND des Parsens, dieses Modul erst DANACH. Wer sich
   auf `window.rbUI` verlaesst, greift also verlaesslich ins Leere.
   Deshalb `window.rbQ`: davor ein gewoehnliches Array, das jede Sektion
   befuellen kann, danach ein Objekt, dessen `push` sofort ausfuehrt. Beide
   Reihenfolgen fuehren zum selben Ergebnis, und eine Sektion muss nicht
   wissen, welche gerade gilt.
   ========================================================================== */

/* Ein <video> im Bild laufen lassen, ohne einen zweiten Beobachter.
   Rueckgabe: true, wenn es von selbst laeuft. false, wenn es stehen
   bleibt -- bei reduzierter Bewegung und im Datensparmodus. Die Sektion
   weiss daran, ob sie ihren eigenen Abspielknopf aufdecken muss. */
function filmImBild(film) {
  if (!film) return false;
  if (ruhig || bytesSparen()) { filmStehenLassen(film); return false; }
  filmRuesten(film, film.getAttribute('aria-label'));
  filmLaufenLassen(film, null);
  return true;
}

const rbUI = {
  /* Der eine Beobachter. `beiSicht` meldet einmal, `beiSichtDauernd` bei
     jedem Wechsel und setzt dabei `is-sicht`. */
  beiSicht,
  beiSichtDauernd,
  /* Der eine Bildtakt. fn(zeit) laeuft, bis sie false liefert. */
  anhaengen,
  /* Der Regelfall fuer ein Video in einer Sektion -- ersetzt sechs Zeilen
     eigenen Beobachter durch eine. */
  film: filmImBild,
  standbild: filmStehenLassen,
  /* Die zwei Fragen, die jede Sektion sonst selbst an matchMedia stellt. */
  ruhig,
  zeiger,
  stand: '21.08.2026',
};

/* Erst die Reihe abarbeiten, die vor diesem Modul entstanden ist, dann den
   Platz gegen ein Objekt tauschen, das sofort ausfuehrt. */
{
  const warteten = Array.isArray(window.rbQ) ? window.rbQ : [];
  window.rbUI = rbUI;
  window.rbQ = {
    push(fn) {
      if (typeof fn !== 'function') return;
      /* Ein Fehler in einer Sektion darf die naechste nicht mitreissen --
         dieselbe Regel wie bei `sicher` weiter unten. */
      try { fn(rbUI); }
      catch (e) { console.error('[robbytoys] rbQ ist ausgefallen:', e); }
    },
  };
  warteten.forEach((fn) => window.rbQ.push(fn));
}

/* ==========================================================================
   26 - Der Eintritt fuer alles, und die Anmeldung der Schleifen.
   Angelegt 31.08.2026, Bahn "bewegungssystem".

   ⚠️ WOZU. Gemessen am 31.08.2026 am ausgelieferten HTML von
   www.robbytoys.com: die Startseite traegt 17 Elemente mit der Klasse
   .rb-sec__kopf, aber nur SIEBEN [data-rb-rev]-Gruppen. Der Anschluss fuer
   die Einblendung ist also fast ueberall da, er ist nur nirgends gesteckt.
   Auf /products/eiliko sind es 9 Koepfe gegen 5 Gruppen, auf
   /products/eilik 14 gegen 9.

   Dieser Teil steckt ihn -- OHNE eine einzige Sektionsdatei anzufassen. Er
   laeuft VOR revealsStarten (Reihenfolge in TEILE) und schreibt nur
   Attribute; die Arbeit macht danach die vorhandene Maschine.

   ⚠️ ER GREIFT NUR, WO NICHTS IST. Wer in seiner Sektion selbst ein
   data-rb-rev oder ein .rb-rev-einzeln gesetzt hat, hat sich etwas dabei
   gedacht, und das gilt. data-rb-kein-eintritt an der Sektion schaltet ihn
   ausdruecklich ab.

   ⚠️ DIE BUEHNE BEKOMMT NICHTS. Sie hat mit .rb-med-auf (1100ms) und der
   Parallaxe bereits ihren Eingang. Ein zweiter darueber waere Laerm.

   RUECKWEG: die eine Zeile ['eintrittNachruesten', ...] aus TEILE nehmen.
   ========================================================================== */
const EINTRITT_SEKTION = '.rb-sec, .rb-neu';
const EINTRITT_KOPF    = '.rb-sec__kopf';
/* Die Raster des Hauses. Die Liste ist GESCHLOSSEN: ein automatisch
   vergebener Auftritt an einem unbekannten Behaelter waere eine Bewegung,
   die niemand bestellt hat, an einer Stelle, die niemand vorhergesehen
   hat. Wer ein neues Raster baut, traegt es hier ein oder setzt sein
   data-rb-rev selbst. */
/* ⚠️ DIE NAMEN SIND AM 31.08.2026 AM AUSGELIEFERTEN HTML NACHGEZAEHLT und
   nicht aus dem Entwurf uebernommen -- der nannte .rb-neu-bento__raster,
   .rb-neu-videowand__raster und .rb-set-raster, und die gibt es in diesem
   Shop nicht (0 Treffer in sections/ und snippets/). Richtig sind:

     .rb-grid                 5 auf der Startseite, 3 auf /eiliko, 5 auf /eilik
     .rb-neu-bento            2 auf der Startseite (mit 11 .rb-neu-bento__k)
     .rb-neu-vid              die Videowand
     .rb-neu-zahlen__raster   1 auf der Startseite

   Ein falscher Name in dieser Liste faellt nirgends auf: der Nachruester
   findet dann einfach nichts und meldet nichts. */
const EINTRITT_RASTER  = '.rb-grid, .rb-neu-bento, .rb-neu-vid, .rb-neu-zahlen__raster';

function eintrittNachruesten(wurzel = document) {
  alle(EINTRITT_SEKTION, wurzel).forEach((sek) => {
    if (sek.hasAttribute('data-rb-kein-eintritt')) return;
    /* Die Buehne regelt ihren Eingang selbst. */
    if (sek.classList.contains('rb-neu-buehne') || sek.closest('.rb-neu-buehne')) return;
    /* Regelt die Sektion es sonst selbst? Dann Finger weg. */
    if (eins('[data-rb-rev], .rb-rev-einzeln', sek)) return;

    /* Der Kopf ist die Ansage. Der Servo-Ruck macht daraus einen
       Roboterarm, der das Schild absetzt. */
    const kopf = eins(EINTRITT_KOPF, sek);
    if (kopf && !kopf.hasAttribute('data-rb-rev') && kopf.children.length) {
      kopf.setAttribute('data-rb-rev', 'servo');
    }
    /* Kacheln duerfen froehlich sein: 'pop' schwingt ueber. */
    const raster = eins(EINTRITT_RASTER, sek);
    if (raster && !raster.hasAttribute('data-rb-rev') && raster.children.length) {
      raster.setAttribute('data-rb-rev', 'pop');
    }
  });

  /* --- Der Sektionsschein braucht `is-da`, auch ohne Einblendung --------
     rb-motion.css Abschnitt 29 haengt den Schein an .rb-sec__kopf.is-da.
     Wird der Kopf zur Einblendungsgruppe, setzt revealsStarten die Klasse
     gleich mit. Wird er es NICHT -- weil seine Sektion sich selbst regelt
     oder weil sie eine Buehne ist --, bekaeme er sie nie, und der Schein
     bliebe dort auf Deckung null stehen. Gemessen am 31.08.2026 traegt die
     Startseite 17 .rb-sec__kopf; nach dem Nachruesten oben wuerden nur
     wenige davon zur Gruppe. Die uebrigen werden hier einzeln angemeldet.

     Der Beobachter meldet einmal und meldet das Element danach wieder ab.
     Eine Einblendung entsteht dadurch nicht: dazu gehoerte die Klasse
     .rb-rev, und die vergibt allein revealsStarten. */
  alle(EINTRITT_KOPF, wurzel).forEach((kopf) => {
    if (kopf.hasAttribute('data-rb-rev')) return;
    /* ⚠️ NICHT data-rb-schein nennen: diesen Namen belegt rb-motion.css
       Abschnitt 29 bereits als Notausgang [data-rb-schein="aus"] an der
       SEKTION. Zwei Bedeutungen unter einem Namen sind ein Fehler, den
       niemand sucht. */
    if (kopf.dataset.rbKopfGemeldet) return;
    kopf.dataset.rbKopfGemeldet = '1';
    beiSicht(kopf);
  });
}

/* --- will-change abraeumen ------------------------------------------------
   EIN delegierter Horcher fuer den ganzen Shop statt einem je Element.
   transitionend blaest nach oben durch, deshalb genuegt das Dokument. Er
   feuert je Element zweimal (opacity und transform) -- classList.add ist
   idempotent, das kostet nichts.

   ⚠️ NICHT an .is-da haengen. Die Klasse wird im selben Bild gesetzt, in
   dem die Bewegung anlaeuft; die Compositor-Ebene mittendrin einzuziehen
   ist genau der Ruckler, den will-change verhindern sollte. */
function willChangeAbraeumen() {
  document.addEventListener('transitionend', (e) => {
    const el = e.target;
    if (el && el.classList && el.classList.contains('rb-rev')) {
      el.classList.add('is-fertig');
    }
  }, { passive: true });
}

/* --- Die Gesichter an den einen Beobachter ------------------------------
   Das Displayflackern (rb-motion.css Abschnitt 25) haengt an .is-sicht.
   Gesetzt wird die Klasse vom vorhandenen Dauerbeobachter -- kein zweites
   Geraet, keine Rueckruffunktion, nur die Anmeldung.

   Die Streuung der Flackerdauer folgt derselben Ueberlegung wie beim
   Blinzeln: vier Displays im Gleichtakt sehen aus wie ein Fehler im
   Stilblatt, vier versetzte sehen aus wie vier Geraete. Die negative
   Verzoegerung setzt jedes Display an eine andere Stelle des Takts, ohne
   dass eines von ihnen erst warten muesste.

   GEMESSEN 31.08.2026: 4 .rb-face auf der Startseite, 4 auf
   /products/eilik, 0 auf /products/eiliko. */
function gesichterAnmelden(wurzel = document) {
  alle('.rb-face', wurzel).forEach((el) => {
    if (el.dataset.rbFlacker) return;
    el.dataset.rbFlacker = '1';
    if (!ruhig) {
      el.style.setProperty('--rb-flacker-dur', zwischen(7, 11).toFixed(2) + 's');
      el.style.setProperty('--rb-flacker-delay', '-' + zwischen(0, 11).toFixed(2) + 's');
    }
    beiSichtDauernd(el);
  });
}

/* --- Kaufknopf und Glow-Puls an den einen Beobachter ---------------------
   Regel 1 im Kopf von rb-motion.css: jede Endlosschleife steht still,
   solange sie nicht im Bild ist. Der Herzschlag des grossen Kaufknopfs ist
   eine, der Glow-Puls aus Abschnitt 6 war bis heute eine, die niemand
   angehalten hat.

   GEMESSEN 31.08.2026: 1 .main-product-atc je Produktseite, 1 .rb-pulse
   auf der Startseite und 1 auf /products/eilik, 0 auf /products/eiliko. */
function schleifenAnmelden(wurzel = document) {
  alle('.main-product-atc, .rb-pulse', wurzel).forEach((el) => {
    if (el.dataset.rbSchleife) return;
    el.dataset.rbSchleife = '1';
    beiSichtDauernd(el);
  });
}

/* --- Die Scanline auf jeder Buehne --------------------------------------
   ⚠️ GEAENDERT gegenueber Teil 4: nicht mehr einmal je SITZUNG, sondern
   einmal, wenn eine Buehne zum ersten Mal ins Bild kommt. Eine Bewegung,
   die nur der allererste Besuch einer Sitzung sieht, sieht praktisch
   niemand -- und gemessen am 31.08.2026 laeuft sie ohnehin auf null
   Seiten: [data-rb-boot] steht in keiner ausgelieferten Sektion.

   ⚠️ HIER WIRD NUR beiSichtDauernd BENUTZT, NICHT beiSicht. Der eine
   Beobachter prueft in seiner Schleife ZUERST, ob ein Dauerhandler am
   Element haengt, und steigt dann aus (`continue`). Wer beides am selben
   Element anmeldet, bekommt seinen beiSicht-Rueckruf NIE. Der Entwurf sah
   genau das vor; hier steht deshalb eine Anmeldung mit eigener Sperre.

   ⚠️ REIHENFOLGE: dieser Teil steht in TEILE hinter scrollWerk.
   bahnenSammeln meldet dieselbe Buehne mit einer leeren Rueckruffunktion
   an; liefe unserer zuerst, wuerde er ueberschrieben. Andersherum
   ueberschreiben wir eine leere Funktion -- und `is-sicht`, das
   bahnenSammeln allein braucht, setzt der Beobachter unabhaengig davon.

   .rb-neu-buehne traegt gemessen position:relative und overflow:hidden
   (rb-neu.css:538) -- die Linie sitzt und wird an der Kante beschnitten.

   Die Hoehe wird EINMAL gemessen, beim Sichtbarwerden, und danach nie
   wieder. Das ist ein Layoutzugriff je Buehne je Seitenaufruf. */
function buehnenScan(wurzel = document) {
  if (ruhig) return;
  alle('.rb-neu-buehne', wurzel).forEach((buehne) => {
    if (buehne.dataset.rbScan) return;
    buehne.dataset.rbScan = '1';
    let gelaufen = false;
    beiSichtDauernd(buehne, (el, drin) => {
      if (!drin || gelaufen) return;
      gelaufen = true;
      const linie = document.createElement('span');
      linie.className = 'rb-scanline';
      linie.setAttribute('aria-hidden', 'true');
      el.style.setProperty('--rb-scan-h', el.offsetHeight + 'px');
      el.appendChild(linie);
      el.classList.add('rb-boot');
      /* Danach hat das Element seine Aufgabe erfuellt. Es bleibt stehen --
         es ist 2 Pixel hoch, durchsichtig und ohne laufende Animation. */
    });
  });
}

/* --- Der Blockcursor ----------------------------------------------------
   Zwei Aufgaben, und die zweite ist die wichtigere.

   (a) Wo ein Element [data-rb-cursor] traegt, wird ein Cursor GEBAUT.
       Das ist der Haken fuer jede Bahn, die kein eigenes Markup schreiben
       will.

   (b) JEDER Cursor -- der gebaute wie der aus einer Sektionsdatei -- wird
       an den einen Beobachter gehaengt. ⚠️ Ohne das liefe er als
       Endlosschleife der Stufe 1 und damit gegen Regel 1 im Kopf von
       rb-motion.css.

   ⚠️ GEMESSEN 31.08.2026: sections/robby-neu-buehne.liquid bringt seit
   heute selbst einen <span class="rb-cursor"> mit, ueber die Einstellung
   "cursor" (Vorgabe aus). Er traegt KEIN data-rb-cursor. Wer hier nur nach
   dem Attribut suchte, haette den einzigen Cursor des Shops uebersehen und
   ihn dauerlaufen lassen -- deshalb sucht (b) nach der Klasse.

   Der Traeger bekommt die Klasse .rb-cursor-traeger. Die Pausenregel in
   rb-motion.css Abschnitt 31 haengt daran und nicht an einer fremden
   Klasse, deren Bedeutung sich aendern kann. */
function cursorSetzen(wurzel = document) {
  alle('[data-rb-cursor]', wurzel).forEach((el) => {
    if (eins('.rb-cursor', el)) return;
    const z = document.createElement('span');
    z.className = 'rb-cursor';
    z.setAttribute('aria-hidden', 'true');
    z.textContent = '▮';          /* Vollflaechiges Rechteck, U+25AE */
    el.appendChild(z);
  });

  alle('.rb-cursor', wurzel).forEach((z) => {
    const traeger = z.closest('[data-rb-cursor], .rb-neu-buehne, .rb-sec, .rb-neu')
                 || z.parentElement;
    if (!traeger || traeger.dataset.rbCursorWacht) return;
    traeger.dataset.rbCursorWacht = '1';
    traeger.classList.add('rb-cursor-traeger');
    /* ⚠️ Auf einer .rb-neu-buehne meldet spaeter buehnenScan seine eigene
       Rueckruffunktion an und ueberschreibt die leere hier. Das ist
       gewollt: `is-sicht` setzt der Beobachter unabhaengig von jeder
       Rueckruffunktion, und mehr braucht die Pausenregel nicht. */
    beiSichtDauernd(traeger);
  });
}

/* ==========================================================================
   27 - Das Augenpaar. DIE ERSTE DER DREI ROBOTERBEWEGUNGEN.

   ⚠️ DER BEFUND, gemessen am 31.08.2026 am ausgelieferten HTML:

     Startseite        2 .rb-eye__lid -- BEIDE in <template id="rb-ladegesicht">
     /products/eiliko  2 -- ebenfalls beide in demselben <template>
     /products/eilik   3 -- zwei im <template>, eines in robby-hoehenangst

   Ein <template> wird weder gerendert noch animiert, und
   querySelectorAll findet seinen Inhalt nicht. Auf der Startseite lief das
   Markenzeichen des Ladens also auf NULL sichtbaren Elementen. Die vier
   .rb-face bekamen zwar --rb-blink-dur und --rb-blink-delay gesetzt,
   enthalten aber ein <img> und kein einziges Augenlid.

   ⚠️ WARUM DAS SVG HIER STEHT UND NICHT IN EINEM SCHNIPSEL. Die Bahn
   "bewegungssystem" verfuegt ueber assets/rb-motion.css und assets/rb-ui.js
   und ueber nichts sonst. snippets/robby-logo-augen.liquid,
   snippets/robby-ladegesicht.liquid und die Sektionsdateien gehoeren
   anderen Haenden; zwei Haende in einer Datei heisst, dass eine von beiden
   ihre Arbeit verliert. Das Augenpaar wird deshalb hier gebaut. Die Form
   ist wortgleich aus snippets/robby-logo-augen.liquid uebernommen, das
   unveraendert bleibt -- ohne dessen Schriftzug.

   ⚠️ ES IST ZIERRAT, UND DAS IST DER PUNKT. Faellt dieses Skript aus,
   fehlt ein Augenpaar. Kein Text, kein Preis, kein Knopf. aria-hidden, kein
   role, kein Label: ein Screenreader soll hier nichts vorlesen, weil es
   nichts zu lesen gibt -- der Name des Ladens steht im Kopf, die
   Ueberschrift steht daneben.

   ⚠️ Ohne Zeigergeraet stehen die Pupillen still und die Augen blinzeln
   trotzdem: das Blinzeln ist reines CSS. Ohne CSS-Animationen bleibt das
   Lid auf scaleY(0), also offen. Es gibt keinen Zustand, in dem hier ein
   schwarzer Kasten steht -- genau das war bis heute der Fehler.

   FARBRECHNUNG, selbst gerechnet am 31.08.2026:
     Pupille --rb-aqua      #0EC3CE auf --rb-oled #070B12   9,12 : 1
     Glanz   --rb-aqua-kern #B9EEF1 auf --rb-oled #070B12  15,5  : 1
   ========================================================================== */
function augenSvg() {
  return ''
    + '<svg viewBox="0 0 56 34" fill="none" aria-hidden="true" focusable="false">'
    +   '<g class="rb-eye rb-eye--links">'
    +     '<rect x="1" y="3" width="24" height="28" rx="8" fill="var(--rb-oled)"/>'
    +     '<g class="rb-eye__pupil">'
    +       '<circle cx="13" cy="17" r="6.5" fill="var(--rb-aqua)"/>'
    +       '<circle cx="15.2" cy="14.6" r="2" fill="var(--rb-aqua-kern)"/>'
    +     '</g>'
    /* ⚠️ Das Lid steht ZULETZT. Es ist ein deckender Pfad in der
       Displayfarbe UEBER der Pupille -- dieselbe Malreihenfolge wie an den
       vier vorhandenen Fundstellen des Shops. Wer es davor setzt, dreht
       die Wirkung von rb-blink um, und das Auge waere dauerhaft offen,
       waehrend das Lid unsichtbar unter der Pupille zuckt. */
    +     '<rect class="rb-eye__lid" x="1" y="3" width="24" height="28" rx="8" fill="var(--rb-oled)"/>'
    +   '</g>'
    +   '<g class="rb-eye rb-eye--rechts">'
    +     '<rect x="31" y="3" width="24" height="28" rx="8" fill="var(--rb-oled)"/>'
    +     '<g class="rb-eye__pupil">'
    +       '<circle cx="43" cy="17" r="6.5" fill="var(--rb-aqua)"/>'
    +       '<circle cx="45.2" cy="14.6" r="2" fill="var(--rb-aqua-kern)"/>'
    +     '</g>'
    +     '<rect class="rb-eye__lid" x="31" y="3" width="24" height="28" rx="8" fill="var(--rb-oled)"/>'
    +   '</g>'
    + '</svg>';
}

/* Ein Augenpaar bauen. `hoehe` in Pixeln, die Breite folgt dem Verhaeltnis
   56:34 des Bildfensters. `weg` ist der Pupillenradius in Pixeln;
   zeigerEffekte liest ihn aus data-rb-augenweg und rastert auf ganze
   Pixel -- die Bewegung soll ruckeln, nicht gleiten. */
function augenBauen(hoehe, weg) {
  const h = Math.max(14, Math.round(hoehe) || 40);
  const b = Math.round(h * 56 / 34);
  const w = Math.min(8, Math.max(0, Math.round(weg) || 4));
  const span = document.createElement('span');
  /* .rb-eyes ist noetig, damit blinzelnVerteilen die Dauer streut und die
     Regel in rb-motion.css Abschnitt 2+3 sie liest. */
  span.className = 'rb-augen rb-eyes';
  span.setAttribute('aria-hidden', 'true');
  span.dataset.rbAugenweg = String(w);
  span.style.width = b + 'px';
  span.style.height = h + 'px';
  span.innerHTML = augenSvg();
  const svg = span.firstElementChild;
  if (svg) { svg.setAttribute('width', b); svg.setAttribute('height', h); }
  return span;
}

/* Wo das Augenpaar hinkommt. Zwei Faelle, in dieser Reihenfolge:

   1. Jedes Element mit [data-rb-augen] bekommt eines. Der Wert ist die
      Hoehe in Pixeln, data-rb-augenweg der Radius. Das ist der Haken fuer
      jede andere Bahn -- Kaufbox, Buehne, Kopf --, ohne dass sie diese
      Datei anfassen muss. GEMESSEN 31.08.2026: 0 solche Elemente heute.

   2. Sonst der Kopf der ersten Buehne der Seite, und zwar genau EINMAL je
      Seite. Die Startseite traegt gemessen zwei .rb-neu-buehne; zwei
      blinzelnde Paare untereinander waeren eine Wiederholung, kein
      Markenzeichen.

   ⚠️ WARUM NICHT IN DEN KOPF DES SHOPS. Der Entwurf sah die Augen neben
   dem PNG-Schriftzug in h1.header__heading vor. Gemessen ist dort ein
   <a class="media ratio"> mit --ratio-percent 22,6 und ein Logo von 260px
   auf dem Schreibtisch. NICHT gemessen ist, ob rechts davon Platz frei ist
   -- und der Kopf steht auf JEDER Seite des Shops. Eine falsch sitzende
   Zierde waere dort ein Fehler auf allen Seiten gleichzeitig, ohne dass
   ihn hier jemand sehen koennte. Wer es will, setzt data-rb-augen an ein
   Element im Kopf; der Weg steht damit offen und ist nicht gegangen. */
function augenEinsetzen(wurzel = document) {
  let gesetzt = false;
  alle('[data-rb-augen]', wurzel).forEach((ziel) => {
    if (eins('.rb-augen', ziel)) return;
    ziel.insertBefore(
      augenBauen(Number(ziel.dataset.rbAugen), Number(ziel.dataset.rbAugenweg)),
      ziel.firstChild
    );
    gesetzt = true;
  });
  if (gesetzt) return;

  /* Genau EIN Augenpaar je Seite. Die Pruefung geht ausdruecklich ueber das
     ganze Dokument und nicht ueber `wurzel`: im Theme-Editor laeuft dieser
     Teil je neu geladener Sektion erneut, und jede Sektion waere fuer sich
     genommen die erste. */
  if (eins('.rb-augen')) return;
  let kopf = eins('.rb-neu-buehne .rb-sec__kopf', wurzel);
  /* Hat die Seite gar keine Buehne, nimmt das Paar den ersten Sektionskopf
     ueberhaupt -- ABER NICHT AUF EINER PRODUKTSEITE. Gemessen am
     31.08.2026: /products/eilik traegt 0 .rb-neu-buehne und 14
     .rb-sec__kopf; der erste davon liegt irgendwo im Fliesstext der Seite,
     und ein blinzelndes Augenpaar ueber einer beliebigen Zwischen-
     ueberschrift ist keine Marke, sondern ein Versehen. Auf einer
     Produktseite gehoert es in die Kaufbox, und die gehoert einer anderen
     Bahn: sie setzt data-rb-augen an das Element, das die Augen tragen
     soll, und bekommt sie damit ohne eine Zeile hier.
     ⚠️ FOLGE, ausdruecklich: auf /products/eilik steht heute KEIN
     Augenpaar und nickt deshalb auch nichts beim Variantenwechsel. */
  if (!kopf && !eins('.product__info-container')) kopf = eins('.rb-sec__kopf', wurzel);
  if (!kopf) return;
  /* Hoehe 40, Radius 5. Der Kopf einer Sektion ist zentriert
     (rb-sections.css:517) und setzt `> * + * { margin-top:16px }` -- als
     erstes Kind bekommt das Paar keinen Abstand nach oben und schiebt die
     Augenbraue nur um seine eigene Hoehe nach unten. */
  kopf.insertBefore(augenBauen(40, 5), kopf.firstChild);
}

/* ==========================================================================
   28 - Der Servo-Ruck beim Variantenwechsel.
   DIE DRITTE ROBOTERBEWEGUNG -- und die einzige, die ANTWORTET.

   Der Besucher waehlt eine Ausfuehrung, und der Roboter nickt. Das ist der
   Unterschied zwischen einem Shop, in dem sich etwas bewegt, und einem, in
   dem etwas antwortet.

   ⚠️ KEIN void el.offsetWidth. Der uebliche Weg, eine CSS-Animation neu zu
   starten, erzwingt einen vollstaendigen Layoutdurchlauf. Zwei Bilder
   Wartezeit kosten stattdessen rund 33 Millisekunden und nichts vom
   Hauptfaden.

   ⚠️ WAS NICKT UND WAS NICHT. Genickt wird [data-rb-nick] und .rb-augen --
   NICHT .rb-eyes. Gemessen am 31.08.2026 tragen die vier Gesichterkacheln
   auf /products/eilik ebenfalls .rb-eyes; vier Kacheln, die bei einem
   Variantenwechsel weit unten auf der Seite gemeinsam nicken, waeren
   Zufallsbewegung und keine Antwort.

   ⚠️ HEUTE NICKT AUF /products/eilik NICHTS. Gemessen: dort steht keine
   .rb-neu-buehne, also auch kein Augenpaar. Auf /products/eiliko steht
   eine. Wer den Nick in der Kaufbox haben will, setzt data-rb-nick an das
   Element, das nicken soll -- das ist der ganze Anschluss.
   ========================================================================== */
function servoNicken() {
  if (ruhig) return;

  const nicken = (el) => {
    if (!el) return;
    el.classList.remove('rb-nick');
    requestAnimationFrame(() => requestAnimationFrame(() => el.classList.add('rb-nick')));
  };

  document.addEventListener('change', (e) => {
    const t = e.target;
    if (!t || !t.closest) return;
    /* Nur der Variantenwaehler, nicht jedes Formularfeld der Seite -- die
       Mengenwahl und der Newsletter feuern dasselbe Ereignis. */
    if (!t.closest('variant-selects, .product-form__input')) return;
    alle('[data-rb-nick], .rb-augen').forEach(nicken);
  }, { passive: true });
}

/* ==========================================================================
   29 - Der Warenkorb quittiert, und die Swatch darf klacken.

   Das Pixelherz fliegt seit dem 20.08.2026 (Teil 6). Was fehlte, war die
   Antwort am anderen Ende: es kommt an, und nichts passiert.

   Ausgeloest ueber animationend von rb-herz-flug und nicht ueber einen
   Zeitgeber: ein setTimeout muesste die Dauer der Herzanimation kennen und
   liefe auseinander, sobald jemand sie aendert.
   ========================================================================== */
function korbQuittung() {
  if (ruhig) return;
  document.addEventListener('animationend', (e) => {
    if (e.animationName !== 'rb-herz-flug') return;
    const symbol = eins('#cart-icon-bubble, .header__icon--cart');
    if (!symbol) return;
    symbol.classList.remove('rb-korb-ruck');
    requestAnimationFrame(() => requestAnimationFrame(() => {
      symbol.classList.add('rb-korb-ruck');
      /* Die Klasse wird nach dem Lauf wieder abgenommen. Bliebe sie
         stehen, traege das Warenkorbsymbol dauerhaft ein
         transform-origin, das es sonst nicht hat -- und der naechste Ruck
         liefe nicht mehr an, weil sich die Klasse nicht aendert. */
      symbol.addEventListener('animationend', function ab(ev) {
        if (ev.animationName !== 'rb-korb-ruck') return;
        symbol.classList.remove('rb-korb-ruck');
        symbol.removeEventListener('animationend', ab);
      });
    }));
  }, { passive: true });
}

/* --- Der Klack der Swatch-Auswahl ---------------------------------------
   ⚠️ WARUM ES DIESEN SCHALTER GIBT. Die Regel in rb-motion.css Abschnitt
   27 haengt an `input:checked + .color-swatch__image`. Beim Seitenaufbau
   ist bereits eine Variante gewaehlt -- ohne Schalter huepfte die Kachel
   also bei JEDEM Laden von selbst. Erst der erste echte Wechsel gibt sie
   frei.

   Der Schalter sitzt am Waehler und nicht am Dokument, damit die Regel
   ihre Auswahl (.product__info-container .rb-sw-klack .color-swatch …)
   behaelt und nicht auf eine Seite mit mehreren Formularen ueberspringt.

   ⚠️ GEMESSEN 31.08.2026: 0 Vorkommen von "color-swatch" im
   ausgelieferten HTML von /products/eiliko und /products/eilik. Der Umbau
   auf picker_types "swatches" steht in den Vorlagen, ist aber noch nicht
   veroeffentlicht. Diese Funktion findet heute nichts und schadet nichts. */
function swatchKlackFreigeben() {
  if (ruhig) return;
  document.addEventListener('change', (e) => {
    const t = e.target;
    if (!t || !t.closest) return;
    const waehler = t.closest('variant-selects');
    if (!waehler) return;
    waehler.classList.add('rb-sw-klack');
  }, { passive: true });
}

/* ==========================================================================
   29.2 - DIE SWATCH-SPUREN ZIEHEN BEIM VARIANTENWECHSEL NACH.

   Angelegt am 14.09.2026. Beanstandung: "beim eiliko bitte paket zwei
   geraete bitte bei der ausfuehrung alle 3 nebeneinander und dann beim
   deluxe packet gibts nur als paerchen hier bitte die ausfuehrung
   wegmachen".

   ⚠️ DIE SPALTENREGEL GIBT ES LAENGST, SIE GREIFT NUR NICHT NACH EINEM
   KLICK. rb-overrides.css Abschnitt 35.3 pinnt die Spaltenzahl fuer 1, 2, 3
   und 4 Kacheln und zaehlt dabei nur die sichtbaren:

       :has(> .color-swatch:nth-child(3 of .color-swatch:not(.non-existent))
                           :nth-last-child(1 of .color-swatch:not(.non-existent)))

   Gemessen am 14.09.2026 auf /products/eiliko, 1440 px, nach einem Klick
   auf "Zwei Geraete":

       Seite direkt mit ?variant= geladen        140px 140px 140px   ok
       nach Klick, 0,3 s   Selektor passt: true  140px 140px         falsch
       nach Klick, 5   s   Selektor passt: true  140px 140px         falsch
       nach Neu-Einhaengen des Elements          140px 140px 140px   ok

   ⚠️ DER BROWSER WERTET :has() MIT :nth-child(N of S) BEI EINER
   KLASSENAENDERUNG NICHT NEU AUS. element.matches() sagt true, die
   Stilberechnung laeuft trotzdem nicht an -- und zwar dauerhaft nicht, nicht
   nur einen Moment lang. Wer die Seite nur aufruft, sieht davon nie etwas;
   der Fehler entsteht erst, wenn jemand das Paket wechselt.

   ⚠️ HIER WIRD KEINE SPALTENZAHL GESETZT. Ein Inline-Stil laege ueber allen
   Media Queries, und unter 750 px gilt Abschnitt 43 mit einem anderen Deckel
   (12,5 statt 14 rem). Vier Kacheln nebeneinander auf einem 390-px-Geraet
   waeren das Ergebnis. Angestossen wird nur die Neuberechnung; welche Zahl
   dann gilt, entscheidet weiterhin das Blatt.

   Sechs Wege erprobt, fuenf wirken, keiner veraendert die Breite des
   Kastens. Genommen ist der zielgenaue.

   ⚠️ UND DIE ZWEITE HAELFTE DER BEANSTANDUNG: bleibt nach dem Filtern nur
   EINE Ausfuehrung uebrig, hat der Kunde nichts zu waehlen. Beim Eiliko
   trifft das "Deluxe" -- das Paket gibt es nur als Paar. Die Gruppe wird
   dann ausgeblendet, Ueberschrift und Kachel zusammen. Der Radioknopf bleibt
   im Markup und bleibt gewaehlt; es ist nichts zu entscheiden. Wechselt der
   Kunde zurueck, zeigt derselbe Horcher die Gruppe wieder.
   ========================================================================== */
function swatchSpurenNachziehen() {
  if (ruhig) return;

  function nachziehen() {
    const box = document.querySelector('product-info.product__info-container, .product__info-container');
    if (!box) return;
    const kaesten = box.querySelectorAll('variant-selects .color-swatches-container');
    for (const kasten of kaesten) {
      /* Nur die Kacheln, die es in dieser Paketwahl wirklich gibt. */
      const da = kasten.querySelectorAll(':scope > .color-swatch:not(.non-existent)').length;

      /* Die Neuberechnung anstossen -- siehe Kopf. */
      kasten.style.gridTemplateColumns = 'initial';
      void kasten.offsetWidth;
      kasten.style.gridTemplateColumns = '';

      const gruppe = kasten.closest('.product-form__input');
      if (!gruppe) continue;
      /* ⚠️ DAS ATTRIBUT ALLEIN REICHT NICHT. rb-overrides.css setzt
         ".product__info-container variant-selects .product-form__input--swatches
         { display: block; }" -- spezifischer als die Standardregel des
         Browsers fuer [hidden], also gewinnt sie. Gemessen am 14.09.2026:
         hidden gesetzt, und die Gruppe stand trotzdem 493 x 208 px gross da.
         ⚠️ Die erste Fassung der Probe fragte nur hasAttribute('hidden') und
         meldete deshalb gruen. Sie misst jetzt die Geometrie.
         Deshalb beides: das Attribut fuer Vorleseprogramme, der Inline-Stil
         fuer das Auge. */
      if (da <= 1) { gruppe.setAttribute('hidden', ''); gruppe.style.display = 'none'; }
      else { gruppe.removeAttribute('hidden'); gruppe.style.display = ''; }
    }
  }

  /* ⚠️ ZWEIMAL, UND DAS IST ABSICHT. Shrine tauscht beim Variantenwechsel
     Teile der Kaufbox aus; der erste Lauf faellt gelegentlich in den
     Zustand davor. Der zweite holt es nach. Beide sind billig -- sie lesen
     eine Zahl und fassen eine Eigenschaft an. */
  document.addEventListener('change', (e) => {
    const t = e.target;
    if (!t || !t.closest) return;
    if (!t.closest('variant-selects, .product-form__input')) return;
    setTimeout(nachziehen, 0);
    setTimeout(nachziehen, 260);
  }, { passive: true });

  /* Einmal beim Start: der Direktaufruf mit ?variant= steht sonst zwar
     richtig da, die EINZELNE Ausfuehrung waere aber noch sichtbar. */
  nachziehen();
}

/* ==========================================================================
   30 - DER SELBSTLAUF DER WISCHBAENDER.

   Angelegt am 01.09.2026. Der Auftrag steht woertlich in der Beanstandung
   vom selben Tag: "dann muss das kleiner gemacht werden das 3 hinpassen
   oder es muss zum AUTOSLIDE werden usw mit halber vorschau".

   Die halbe Vorschau steht seit dem 01.09.2026 in rb-sections.css
   Abschnitt 41 und in neun Sektionsdateien. Was dort NICHT stand, weil CSS
   es nicht kann, ist der Taktgeber: die Baender liessen sich wischen, sie
   liefen nicht. Diesen Taktgeber baut dieser Teil.

   ⚠️ WELCHER KASTEN EIN BAND IST, WIRD GEFRAGT UND NICHT GERATEN.
   Gemessen am 01.09.2026 im echten Chrome bei 390 px auf drei Seiten
   (Startseite, /products/eilik, /collections/all): 15, 16 und 10 waagerecht
   rollende Kaesten je Seite. Nur ein Teil davon gehoert diesem Haus. Die
   uebrigen sind Shopifys Bildergalerie (23 Kinder), die Miniaturleiste, die
   Filterschublade, die Suchvorschau, die Vergleichstabelle und die
   Antwortpillen des Geschenkfinders. Ein Selbstlauf auf einer Tabelle
   schiebt dem Leser die Zeile unter dem Auge weg; einer auf einer
   Formulargruppe verstellt die Antwort, die er gerade lesen wollte.
   Deshalb steht hier eine ZULASSUNGSliste und keine Verbotsliste, und
   dahinter noch eine Sperrliste fuer die Faelle, in denen ein .rb-grid des
   Hauses in einem fremden Kasten steckt.

   ⚠️ EIN KASTEN, DESSEN INHALT HINEINPASST, BEKOMMT KEINEN SELBSTLAUF.
   Die Baender aus Abschnitt 41 sind ausschliesslich unter 750 px Baender;
   darueber ist dasselbe Element ein stehendes Raster. Geprueft wird
   deshalb nicht die Breite des Fensters, sondern die einzige Tatsache, auf
   die es ankommt: scrollWidth ueber clientWidth. Ein Selbstlauf auf einem
   Kasten ohne Ueberhang ruckelt, ohne etwas zu zeigen -- und der Halteknopf
   daneben verspricht eine Bewegung, die es nicht gibt.

   ⚠️ DER WICHTIGSTE TEIL DIESES ABSCHNITTS IST NICHT DER LAUF, SONDERN DAS
   ANHALTEN. Sechs Anlaesse halten an, und einer davon dauerhaft:

     reduzierte Bewegung   es laeuft gar nichts an, und es entsteht auch
                           kein Knopf -- ohne Bewegung gibt es nichts
                           anzuhalten
     ausserhalb des Bildes IntersectionObserver, derselbe wie ueberall
     Fenster im Hintergrund document.hidden
     Zeiger darueber       nur wo es einen Zeiger gibt (hover:hover)
     Fokus IM Kasten       wer mit der Tastatur in den Karten steht, dem
                           springt der Kasten sonst unter dem Fokus weg
     Beruehrung            der Finger liegt auf, bevor er wischt
     DER KUNDE WISCHT      dauerhaft. Wer selbst blaettert, hat gesagt,
                           dass er die Fuehrung uebernimmt.

   Der letzte Fall wird an ZWEI Stellen erkannt und nicht an einer:
   unmittelbar an Rad und Pfeiltaste, und als Netz darunter an jedem
   Rollvorgang, der nicht dort endet, wo dieser Teil ihn hingeschickt hat.
   Ein Wisch mit dem Finger loest kein 'wheel' und kein 'keydown' aus --
   ohne das Netz liefe das Band dem Kunden unter dem Finger weiter, und
   genau das ist der Fehler, an dem schlechte Karussells erkannt werden.

   ⚠️ Aus dem dauerhaften Halt fuehrt EIN Weg zurueck: der Knopf. Er zeigt
   dann das Startzeichen. Ein Halt, aus dem es kein Zurueck gibt, waere kein
   Dienst, sondern ein kaputtes Bauteil.

   WCAG 2.2 SC 2.2.2 (Pause, Stop, Hide) verlangt den Knopf, sobald sich
   etwas laenger als fuenf Sekunden von selbst bewegt. SC 2.5.5 verlangt im
   Haus 44x44 px -- das Mass steht in rb-motion.css Abschnitt 33.
   aria-pressed traegt den Zustand. ⚠️ aria-live traegt der Kasten NICHT:
   ein Vorleser wuerde sonst alle fuenf Sekunden von selbst zu sprechen
   anfangen, ohne dass jemand etwas getan hat.

   ------------------------------------------------------------------------
   ⚠️ NACHTRAG 01.09.2026: SIEBEN HALTEKNOEPFE AUF EINER SEITE SIND ZU
   VIELE. Der Auftraggeber sah bei 390 px "viel leer und ein stop symbol".
   Gemessen: sieben Knoepfe auf der Startseite, sieben auf /products/eilik,
   drei auf /products/eiliko, zwei auf /products/eiliko-spinkit. Drei
   Aenderungen, jede einzeln gemessen:

     1. WENIGER BAENDER LAUFEN -- das ist der grosse Hebel, und er kommt
        NICHT vom Ueberhang. Drei Pruefungen, jede einzeln gemessen:

          laufZeigtEtwas      ein Band aus reiner Schrift laeuft nicht.
                              Trifft 8 der 19 Baender. Startseite 7 -> 5,
                              /products/eilik 7 -> 3, /products/eiliko
                              3 -> 2, /products/eiliko-spinkit 2 -> 1.
          LAUF_MINDESTHOEHE   ein Band, das nicht doppelt so hoch ist wie
                              sein Knopf, laeuft nicht. Trifft 1 Band
                              (61 px) -- dasselbe, das schon die erste
                              Regel trifft.
          LAUF_MINDESTKACHEL  mindestens eine ganze Kachel muss verdeckt
                              sein. Trifft heute KEIN Band.

        ⚠️ Die Hoffnung, ueber den Ueberhang zu kuerzen, traegt NICHT:
        gemessen verdeckt das knappste Band immer noch 1,02 Kachelbreiten,
        das groesste 9,65. Kein einziges Band zeigt "ohnehin schon alles".
        Wer hier kuerzen will, muss nach dem INHALT fragen, nicht nach der
        Breite -- und genau das tut laufZeigtEtwas.

     2. NUR DAS BAND IM BILD ZEIGT SEINEN KNOPF. Der grosse Hebel. Gemessen
        beruehrt das Fenster bei 390 px hoechstens ZWEI Baender gleichzeitig;
        in 63 Prozent der Fensterlagen der Startseite keins. Aus sieben
        gleichzeitigen Knoepfen werden hoechstens zwei. Wie das gebaut ist,
        ohne die Tastatur auszusperren, steht bei laufPruefen.

     3. EIN HALT FUER DIE GANZE SEITE WURDE GEPRUEFT UND VERWORFEN. SC 2.2.2
        verlangt einen erreichbaren Mechanismus, nicht einen je Element --
        ein einzelner Knopf waere also zulaessig. Er muesste aber fest im
        Fenster kleben, um von jeder Stelle der Seite aus erreichbar zu
        sein, und dann liegt er auf JEDER Seite dauerhaft auf Inhalt statt
        nur dort, wo gerade etwas laeuft. Gegen den gemessenen Gewinn --
        hoechstens ein Knopf weniger, und das in 15 von 610 Fensterlagen --
        ist das ein schlechtes Geschaeft. Der Knopf bleibt an dem Band, das
        er anhaelt; das ist ausserdem das einzige, was ihn erklaert.
   ------------------------------------------------------------------------
   ========================================================================== */

/* Fuenf Sekunden je Kachel. Darunter wird aus dem Hinweis "hier geht es
   weiter" eine Bewegung, die man nicht mitlesen kann; darueber merkt sie
   niemand mehr. Der Anlauf ist kuerzer als der Takt, damit das Band nach
   dem Sichtbarwerden nicht wie eingefroren dasteht. */
const LAUF_TAKT = 5000;
const LAUF_ANLAUF = 1800;
/* Acht Bildpunkte Spiel. Ein Rollkasten meldet durch Rundung von
   Zwischengroessen fast immer ein bis zwei Punkte Ueberhang, ohne dass es
   etwas zu rollen gaebe. */
const LAUF_LUFT = 8;

/* ⚠️ ZWEI SCHWELLEN, DIE EINEM BAND DEN SELBSTLAUF VERWEIGERN. Beide sind am
   01.09.2026 an 19 Baendern auf vier Seiten bei 390 px gemessen worden, und
   beide beantworten dieselbe Frage: zeigt der Lauf ueberhaupt etwas, das
   sonst niemand sieht -- und ist Platz fuer den Knopf, den er kostet?

   LAUF_MINDESTKACHEL: mindestens EINE ganze Kachel muss verdeckt sein.
   Gemessen ragt jedes der 19 Baender um 1,02 bis 9,65 Kachelbreiten ueber
   den Rand; die Schwelle nimmt heute also KEINEM Band den Lauf. Sie steht
   trotzdem hier, weil ein Band, von dem nur ein Rundungsrest verdeckt ist,
   einen Knopf kostet und nichts zeigt -- und weil das knappste gemessene
   Band (/products/eilik, Sektion videos, 374 px Ueberhang bei 365 px
   Kachelmass) nur einen Zeilenumbruch von dieser Lage entfernt ist.

   LAUF_MINDESTHOEHE: ein Band, das nicht doppelt so hoch ist wie sein
   eigener Knopf, wird von ihm beherrscht. Gemessen an /products/eiliko,
   Sektion zu-zweit (.rb-zwei__stufen): 61 px hoch. Der 44-px-Knopf deckte
   dort 72 Prozent der Bandhoehe und lag in BEIDEN rechten Ecken auf
   Schrift (741 Quadratbildpunkte von 1936). Dieses Band verliert seinen
   Selbstlauf -- es ist das einzige der 19. */
const LAUF_MINDESTKACHEL = 1;
const LAUF_MINDESTHOEHE = 88;

/* Die Zulassungsliste: das sind die Baender des Hauses. */
const LAUF_JA = '[data-rb-band], .rb-grid, .rb-rail';

/* ⚠️ 11.09.2026: DIESER TEIL BEWEGT NICHTS MEHR VON SELBST. ER BAUT PFEILE.

   Auf Ansage: "da ist das einfach ohne Grund abgehackt, da will ich auch
   keinen Autoplay sondern Pfeile haben damit der Kunde die 4 Kacheln sehen
   kann" -- und danach ausdruecklich fuer den ganzen Laden.

   Gemessen am 11.09.2026 ueber 42 Adressen bei 390 px, jede vollstaendig
   durchgerollt: 45 blaetterbare Kaesten auf 25 Adressen, davon liefen 29 in
   13 verschiedenen Sektionen von selbst. Dreizehn Sektionen einzeln
   anzufassen waere dreizehnmal derselbe Griff gewesen -- der Lauf kam aus
   der Zulassungsliste darueber, also faellt er hier.

   ⚠️ DAMIT SCHLIESST SICH DIE LUECKE AUS rb-motion.css ABSCHNITT 33b. Dort
   steht seit dem 07.09.2026 schriftlich, dass der versteckte Halteknopf eine
   bewusst eingegangene Abweichung von WCAG 2.2 SC 2.2.2 war: die Baender
   liefen, der Halt war unsichtbar. Ohne Bewegung braucht es keinen Halt.

   ⚠️ DER RUECKWEG IST EINE EINZIGE ZEILE. Steht hier wieder true, laufen die
   Baender wie vorher, der Halteknopf wird wieder gebaut und die beiden
   Schwellen weiter unten gelten wieder. Deshalb ist der ganze Laufapparat
   stehengeblieben und nicht herausgeschnitten worden. */
const LAUF_SELBST = false;

/* Die Sperrliste. Jeder Eintrag ist am 01.09.2026 als rollender Kasten
   gemessen worden, und keiner davon darf von selbst weiterspringen. */
const LAUF_NEIN = [
  '.rb-verg',            /* die Vergleichstabelle -- "auch keine abgeschnittenen tabellen" */
  '.rb-finder__frage',   /* die Antwortpillen des Geschenkfinders sind ein Formular */
  '.rb-schrank',         /* der Kleiderschrank hat seinen eigenen Takt, Teil 12 */
  '.rb-band', '.rb-collage', /* Laufband und Collage laufen schon, per CSS */
  'slider-component', 'slideshow-component', 'media-gallery',
  '.product-media-modal', '.quick-add-modal',
  '.menu-drawer', '.mobile-facets', '.predictive-search',
].join(',');

const laufStand = new WeakMap();
const laufAlle = new Set();
const laufListe = new Set();
let laufUhr = null;
let laufMasse = null;
let laufSichtHorcher = false;

/* ⚠️ EIN Taktgeber fuer alle Baender, nicht einer je Band -- dieselbe
   Regel wie beim einen Beobachter und beim einen Bildtakt. Er laeuft nur,
   solange mindestens ein Band wirklich laeuft, und wird sonst abgeraeumt.
   Eine Uhr, die im Leerlauf weitertickt, kostet auf dem Handy Akku fuer
   nichts. */
function laufUhrPruefen() {
  if (laufListe.size && laufUhr === null) laufUhr = setInterval(laufTakt, 500);
  else if (!laufListe.size && laufUhr !== null) { clearInterval(laufUhr); laufUhr = null; }
}

function laufTakt() {
  const jetzt = Date.now();
  /* ⚠️ Eine Kopie, keine Schleife ueber die lebende Menge: laufPruefen
     nimmt gleich Baender heraus, und ueber eine Menge zu laufen, die man
     dabei aendert, ist der Anfang eines uebersprungenen Eintrags. */
  Array.from(laufListe).forEach((z) => {
    if (jetzt < z.faellig) return;
    /* Vor jedem Schritt wird der Zustand NEU gefragt. Warum das nicht
       genuegt, wenn nur die Horcher ihn schreiben, steht bei laufZeigerDrauf. */
    laufPruefen(z);
    if (!laufListe.has(z)) return;
    z.faellig = jetzt + LAUF_TAKT;
    laufWeiter(z);
  });
}

/* ⚠️ ZEIGER UND FOKUS WERDEN GEFRAGT, NICHT GEMERKT.

   Erster Bau am 01.09.2026: zwei Merker, geschrieben von pointerenter und
   pointerleave beziehungsweise focusin und focusout. Ein Merker kann
   haengenbleiben -- ein pointerenter, dessen pointerleave nie kommt, laesst
   ihn auf "Zeiger liegt darauf" stehen, und das Band steht dann fuer immer
   still, ohne dass irgendwo ein Fehler erschiene. ⚠️ NICHT GEMESSEN, dass
   das im Betrieb wirklich vorkommt; die Umstellung ist eine Vorsorge und
   kostet nichts, weil :hover und document.activeElement ohnehin das sind,
   was der Browser in diesem Augenblick wirklich weiss. Die Horcher bleiben,
   aber sie loesen nur noch das Nachfragen aus.

   GEMESSEN am 01.09.2026, echtes Chrome, 390 px OHNE Handykennung (also
   mit Zeiger), Band __garantie in der Fenstermitte (top 216, hoch 469 px),
   mit einer echten Mausbewegung statt eines geschickten Ereignisses:

     Zeiger auf 5,5 (Kopfzeile)   zeigerDrauf=false   scrollLeft 0 -> 534
     Zeiger auf 195,451 (Band)    zeigerDrauf=true    scrollLeft 534 -> 534
     Zeiger wieder auf 5,5        zeigerDrauf=false   scrollLeft 534 -> 267

   Der Halt durch den Zeiger ist damit belegt, und er ist voruebergehend:
   halt blieb in allen drei Schritten false, der Knopf hat sich nicht
   veraendert. Ein Zeigerhalt ist keine Ansage des Kunden. */
function laufZeigerDrauf(band) {
  if (!zeiger) return false;
  try { return band.matches(':hover'); } catch (_) { return false; }
}

/* ⚠️ GEMESSEN am 01.09.2026 am Band __sets: wer mit der Tastatur in eine
   Karte hineinspringt, haelt das Band GLEICH ZWEIMAL an. Einmal hier, weil
   der Fokus im Kasten steht -- und einmal dauerhaft, weil der Browser den
   Rollkasten beim Fokussieren selbst verschiebt, damit die Karte im Bild
   steht. Dieses Verschieben endet woanders als das eigene Ziel, und das
   Netz weiter unten liest es richtig als eine Bewegung des Kunden.
   Gemessen: lief vorher=true, danach inListe=false, scrollLeft 0 -> 0 in
   neun Sekunden, halt=true. Das ist gewollt: wer sich durch die Karten
   tabbt, will nicht, dass ihm die naechste weggeschoben wird. */
function laufFokusDrin(band) {
  const a = document.activeElement;
  return !!a && a !== document.body && band.contains(a);
}

/* Nur die Kacheln, die es wirklich gibt. ⚠️ Der Geschenkfinder blendet
   seine Treffer mit dem hidden-Attribut aus und Shrine markiert leere
   Karten mit .non-existent -- wer die mitzaehlt, misst die Kachelbreite an
   einem Kasten von null Breite und schiebt danach um null. */
function laufKinder(band) {
  return Array.from(band.children).filter((k) => (
    !k.hasAttribute('hidden') &&
    !k.classList.contains('non-existent') &&
    !k.hasAttribute('data-rb-lauf-halt') &&
    k.getBoundingClientRect().width > 0
  ));
}

/* ⚠️ DIE KACHELBREITE WIRD GEMESSEN, NICHT GERATEN. Gesucht ist der
   Abstand von Kachelkante zu Kachelkante, also Breite PLUS Fuge. Die Fuge
   ist je nach Sektion --rb-gap (12 px) oder ein fester Wert (14 px);
   gemessen am 01.09.2026 stehen beide Werte gleichzeitig auf einer Seite.
   Die Differenz zweier Kachelkanten traegt beide Zahlen in sich und
   braucht den Namen der Eigenschaft nicht zu kennen. */
function laufSchritt(band) {
  const k = laufKinder(band);
  if (k.length < 2) return 0;
  const a = k[0].getBoundingClientRect();
  const b = k[1].getBoundingClientRect();
  const s = Math.round(b.left - a.left);
  return s > 8 ? s : Math.round(a.width);
}

/* ⚠️ DER SELBSTLAUF ZEIGT, WAS ES ZU SEHEN ODER ZU KAUFEN GIBT. ER SCHIEBT
   KEINEN FLIESSTEXT.

   Das ist die Regel, die am 01.09.2026 die meisten Halteknoepfe abgeraeumt
   hat, und sie ist an 19 Baendern auf vier Seiten bei 390 px gemessen:

     Seite                       Baender   davon nur Text   bleiben
     Startseite                     7            2             5
     /products/eilik                7            4             3
     /products/eiliko               3            1             2
     /products/eiliko-spinkit       2            1             1
     zusammen                      19            8            11

   "Nur Text" heisst gemessen: in keiner Kachel des Bandes steht ein
   Verweis, ein Bild oder ein Film. Betroffen sind die Absicherung
   (774 Zeichen), Vier Gruende (1107), Was er kann (11 Kacheln, 939), Im
   Karton (347), Vier Griffe (474) und Zu zweit (42).

   ⚠️ WARUM DAS NICHT NUR EIN SPARZWANG IST: eine Kachel, die man LESEN
   muss, kann man nicht lesen, waehrend sie weglaeuft. Genau dagegen ist
   WCAG 2.2 SC 2.2.2 geschrieben worden. Bei einer Bildkachel dagegen
   genuegt der Blick, und der Lauf zeigt dem Kunden etwas, das er sonst nie
   zu Gesicht bekommt. Gewischt werden koennen die Textbaender weiterhin von
   Hand, und die halbe Vorschau aus rb-sections.css Abschnitt 41 sagt
   weiterhin, dass es dort weitergeht -- es faellt nur die Bewegung weg,
   nicht der Inhalt und nicht der Weg dorthin.

   ⚠️ Ein <svg>-Zeichen zaehlt ABSICHTLICH nicht als Bild. Die
   Absicherungsspalten und die Vier-Gruende-Punkte tragen solche Zeichen;
   sie sind Schmuck neben der Schrift, nichts, wofuer man ein Band laufen
   laesst. */
function laufZeigtEtwas(band) {
  return !!band.querySelector('a[href], img, video, picture, model-viewer');
}

function laufRollt(band) {
  const ueberhang = band.scrollWidth - band.clientWidth;
  if (ueberhang <= LAUF_LUFT) return false;
  /* ⚠️ AB HIER ENTSCHEIDEN SCHWELLEN, DIE NUR DEM SELBSTLAUF GALTEN.

     Die Hoehenschwelle stammt von einem 44-px-Knopf, der IM Band sass und
     ein niedriges Band beherrschte; die Kachelschwelle davon, dass eine
     Bewegung, die nur einen Rundungsrest zeigt, ihren Knopf nicht wert ist.
     Die Pfeile stehen UNTER dem Band und kosten es keine Flaeche -- fuer sie
     zaehlt allein, ob etwas abgeschnitten ist. Ein 61 px hohes Band mit
     400 px Ueberhang ist abgeschnitten, und der Kunde braucht den Weg zum
     Rest genauso wie bei einem hohen. */
  if (!LAUF_SELBST) return true;
  if (band.clientHeight < LAUF_MINDESTHOEHE) return false;
  /* Ist das Kachelmass nicht zu ermitteln (eine einzige Kachel, alles gleich
     breit), bleibt es beim reinen Ueberhang -- eine Schwelle, die man nicht
     messen kann, darf nicht heimlich abschalten. */
  const schritt = laufSchritt(band);
  if (schritt > 0 && ueberhang < schritt * LAUF_MINDESTKACHEL) return false;
  return true;
}

function laufWeiter(z) {
  const band = z.band;
  const schritt = laufSchritt(band);
  const rest = band.scrollWidth - band.clientWidth;
  if (schritt <= 0 || rest <= LAUF_LUFT) { laufPruefen(z); return; }
  /* Am Ende zurueck auf Anfang. Der Vergleich laesst LAUF_LUFT stehen:
     sonst bleibt das Band an einem Rundungsrest von zwei Bildpunkten
     haengen und springt nie zurueck. */
  let ziel = band.scrollLeft + schritt;
  if (ziel > rest - LAUF_LUFT) ziel = 0;
  z.ziel = ziel;
  band.scrollTo({ left: ziel, behavior: 'smooth' });
}

/* --- Der dauerhafte Halt ------------------------------------------------ */
function laufKundeUebernimmt(z) {
  if (z.halt) return;
  z.halt = true;
  laufKnopfSchreiben(z);
  laufPruefen(z);
}

/* --- Der Zustand entscheidet, ob dieses Band in der Laufliste steht ----- */
function laufPruefen(z) {
  const rollt = laufRollt(z.band);
  if (rollt && !z.geruestet) laufRuesten(z);
  /* ⚠️ ZWEI STUFEN, UND SIE SIND NICHT DASSELBE.

     `hidden` heisst: es gibt hier nichts anzuhalten. Auf dem PC ist
     dasselbe Element ein stehendes Raster; ein Knopf, der eine Bewegung
     verspricht, die es nicht gibt, gehoert weder ins Bild noch in die
     Tabreihenfolge.

     `is-fern` heisst: es gibt etwas anzuhalten, aber der Kunde schaut
     gerade woandershin. Der Knopf wird durchsichtig und nimmt keine
     Beruehrung mehr an -- er bleibt aber im Dokument und FOKUSSIERBAR, und
     rb-motion.css Abschnitt 33 holt ihn bei :focus-visible sofort zurueck.
     Genau daran haengt WCAG 2.2 SC 2.2.2 fuer die Tastatur: der Halt muss
     erreichbar bleiben, auch wenn er nicht zu sehen ist. Mit `hidden` waere
     er aus der Tabreihenfolge gefallen, und der Nachweis waere verloren.

     ⚠️ GEMESSEN am 01.09.2026 bei 390 px, warum das die richtige Stufe ist:
     die Startseite fuehrt sieben Baender, aber in 610 Fensterlagen beruehrt
     das Fenster hoechstens ZWEI davon gleichzeitig -- 384 Lagen mit keinem
     Band, 211 mit einem, 15 mit zweien. Aus sieben gleichzeitig sichtbaren
     Halteknoepfen werden damit hoechstens zwei, in 63 Prozent der Lagen
     keiner. Auf /products/eilik (ebenfalls sieben Baender): 543 Lagen mit
     keinem, 212 mit einem, 4 mit zweien. */
  if (z.knopf) {
    z.knopf.hidden = !rollt;
    z.knopf.classList.toggle('is-fern', !z.drin);
  }
  /* Aus dem Handyband wird am grossen Schirm ein stehendes Raster. Dann gibt
     es nichts zu blaettern, und zwei Pfeile waeren eine Behauptung ueber
     verborgenen Inhalt, den es nicht gibt. Der ResizeObserver weiter unten
     fuehrt hierher. */
  laufPfeileStand(z);
  const laeuft = LAUF_SELBST && rollt && !z.halt && z.drin && !z.beruehrt && !document.hidden
    && !laufZeigerDrauf(z.band) && !laufFokusDrin(z.band);
  if (laeuft) {
    /* Beim Wiederanlaufen die volle Anlaufzeit, nicht den Rest des alten
       Takts: sonst springt das Band in dem Augenblick weiter, in dem der
       Zeiger es verlaesst, und genau das wirkt wie ein Fehler. */
    if (!laufListe.has(z)) { z.faellig = Date.now() + LAUF_ANLAUF; laufListe.add(z); }
  } else {
    laufListe.delete(z);
  }
  laufUhrPruefen();
}

function laufKnopfSchreiben(z) {
  if (!z.knopf) return;
  z.knopf.setAttribute('aria-pressed', String(z.halt));
  z.knopf.setAttribute('aria-label', z.halt
    ? 'Automatisches Weiterblättern wieder starten'
    : 'Automatisches Weiterblättern anhalten');
}

/* ⚠️ DIE HUELLE IST DER EINZIGE EINGRIFF IN FREMDES MARKUP, UND SIE IST
   EIN LEERER BLOCK MIT position:relative -- SONST NICHTS.

   Der Knopf muss am Band haengen und nicht am Abschnitt: .rb-sec__in ist
   gemessen ein Vielfaches so hoch wie das Band darin, ein Knopf an seiner
   unteren Ecke saesse also irgendwo. Absolut positioniert im Band selbst
   waere er auch nichts: ein absolut gesetztes Kind eines Rollkastens rollt
   mit und ist nach der ersten Kachel aus dem Bild.

   Warum die Huelle nichts verschiebt, und das ist gerechnet und danach
   gemessen: sie bekommt kein overflow, kein display, kein padding und
   keinen Rand. Damit entsteht KEIN neuer Blockformatierungskontext, die
   negativen Aussenabstaende des Bandes (margin-block bis -32 px,
   margin-inline bis -24 px aus Abschnitt 41) fallen weiterhin mit denen
   der Umgebung zusammen, und die Huelle ist genau so breit und so hoch wie
   das Band. Steht das Band in einem Raster (gemessen: .rb-finder,
   display:grid), wird die Huelle das Rasterkind und das Band fuellt sie --
   dieselbe Spur, dieselbe Breite.

   ⚠️ Der Knopf ist absichtlich KEIN Rasterkind und KEIN Flexkind: er ist
   absolut positioniert, und ein absolut positioniertes Kind eines Raster-
   oder Flexkastens ist keins von beidem. Ohne diese Eigenschaft haette ein
   Knopf in .rb-finder dort eine siebte Rasterzelle aufgemacht. */
/* ⚠️ DIE BESCHRIFTUNG WIRD GELESEN, NICHT GESETZT. Ein Vorleseprogramm
   sagt sonst 45-mal im Laden dasselbe "weiterblaettern", ohne dass jemand
   wuesste, WOVON. Die Ueberschrift der Sektion steht ohnehin unmittelbar
   darueber und ist genau die Auskunft, die ein Sehender an dieser Stelle
   auch hat. Findet sich keine, bleibt es beim neutralen Wort -- eine
   erfundene Beschriftung waere schlimmer als eine allgemeine. */
function laufPfeilName(band) {
  const sek = band.closest('[id^="shopify-section"]');
  const h = sek && sek.querySelector('h1, h2, h3');
  const t = h && h.textContent ? h.textContent.trim().replace(/\s+/g, ' ') : '';
  return t && t.length <= 60 ? t : 'Inhalt';
}

/* ⚠️ DIE PFEILE STEHEN UNTER DEM BAND UND NEBEN DER HUELLE, NICHT DARIN.

   Nicht im Band: ein Kind des Rollkastens rollt mit und ist nach der ersten
   Kachel aus dem Bild -- derselbe Grund, aus dem der Halteknopf seinerzeit
   die Huelle bekam.

   Nicht in der Huelle: die ist mit Bedacht ein leerer Block mit
   position:relative und sonst nichts. Ein zweites Kind im Fluss haette die
   negativen Aussenabstaende des Bandes aus rb-sections.css Abschnitt 41
   anders zusammenfallen lassen als heute, und die Huelle waere nicht mehr
   genau so hoch wie das Band. Als Geschwister DAHINTER aendert die Leiste an
   der Huelle nichts und nimmt sich ihren Platz im normalen Fluss.

   ⚠️ Das Blaettern folgt derselben Einstellung wie alles andere: wer
   "Bewegung reduzieren" gewaehlt hat, bekommt den Sprung ohne Gleiten. */
function laufPfeileBauen(z) {
  const band = z.band;
  const anker = z.huelle || band;
  if (!anker.parentNode) return;

  const leiste = document.createElement('div');
  leiste.className = 'rb-blaettern';
  leiste.setAttribute('data-rb-blaettern', '');
  leiste.hidden = true;

  const ZEICHEN = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">'
    + '<path d="M9 5l7 7-7 7" stroke="currentColor" stroke-width="2"'
    + ' stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const was = laufPfeilName(band);

  const machen = (richtung, beschriftung) => {
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'rb-blaettern__knopf';
    b.setAttribute('aria-label', beschriftung);
    b.innerHTML = ZEICHEN;
    if (richtung < 0) b.firstChild.style.transform = 'scaleX(-1)';
    b.addEventListener('click', () => {
      /* Eine Kachel je Druck, und die Kachelbreite wird gemessen: sie haengt
         an clamp-Werten, die sich mit dem Fenster aendern. Ist sie nicht zu
         ermitteln, bleibt ein Grossteil der Sichtbreite. */
      const schritt = laufSchritt(band) || Math.round(band.clientWidth * 0.8);
      band.scrollBy({ left: richtung * schritt, behavior: ruhig ? 'auto' : 'smooth' });
      laufKundeUebernimmt(z);
    });
    return b;
  };

  const zurueck = machen(-1, was + ': zurückblättern');
  const vor = machen(1, was + ': weiterblättern');
  leiste.appendChild(zurueck);
  leiste.appendChild(vor);
  anker.parentNode.insertBefore(leiste, anker.nextSibling);
  z.pfeile = { leiste, zurueck, vor };

  band.addEventListener('scroll', () => { laufPfeileStand(z); }, { passive: true });
  laufPfeileStand(z);
}

/* ⚠️ DAS RECHNERISCHE ENDE EINER BAHN IST NICHT IMMER ANFAHRBAR.

   Gemessen am 11.09.2026, Bahn .rb-neu-vid auf drei Adressen bei 390 px:
   scrollWidth minus clientWidth ergibt 1469, auf Anschlag geschoben bleibt
   sie bei 1460 stehen. Ursache ist scroll-snap-type x mandatory -- die Bahn
   rastet auf Kachelanfaenge, und der letzte Rastpunkt liegt neun Bildpunkte
   davor.

   Diese Funktion liefert die Toleranz, mit der "ganz rechts" gemeint ist.
   Sie misst die FUGE zwischen zwei Kacheln, und das ist kein Kunstgriff: wo
   auf Kachelanfaenge gerastet wird und die letzte Kachel buendig stehen
   soll, bleibt genau die Fuge uebrig. An allen 45 blaetterbaren Bahnen des
   Ladens nachgemessen -- 42 kommen exakt ans Ende, drei bleiben neun
   Bildpunkte davor, und KEINE EINZIGE bleibt weiter zurueck als ihre eigene
   Fuge. Vorkommende Fugen: 12 und 14.

   ⚠️ Die Obergrenze ist eine Plausibilitaetspruefung, keine Messung. Traegt
   ein Kasten nur ein sichtbares Kind oder liegen seine Kinder uebereinander,
   liefert die Rechnung Unsinn, und eine Toleranz von 300 Bildpunkten
   schaltete den Knopf lange vor dem Ende ab. Dann bleibt es bei den zwei
   Bildpunkten, die Rundungen abfangen. */
function laufFuge(band) {
  const k = laufKinder(band);
  if (k.length < 2) return 0;
  const fuge = Math.round(laufSchritt(band) - k[0].getBoundingClientRect().width);
  return fuge > 0 && fuge < 80 ? fuge : 0;
}

/* ⚠️ EIN PFEIL, DER SICHTBAR IST UND NICHTS TUT, IST EINE ZUSAGE, DIE DIE
   SEITE NICHT EINLOEST. Deshalb zwei Stufen: keine Leiste, wo nichts
   ueberhaengt -- und ein abgeschalteter Knopf am Ende der Bahn.

   Links genuegen zwei Bildpunkte: der Anfang ist immer anfahrbar. Rechts
   entscheidet die gemessene Fuge, siehe darueber. */
/* ⚠️ EIN KASTEN, DER NICHT ROLLT, IST KEIN BAND -- UND SEINE PFEILE SIND
   GENAU DIE ZUSAGE, DIE DER KOMMENTAR DARUNTER VERBIETET.

   Gemessen am 11.09.2026 im Warenkorb: dort hing ein Pfeilpaar an einer
   Huelle mit overflow-x visible, waehrend die Spur DARIN rollte. Jeder
   Druck bewegte 0 px, bei 1440 wie bei 390 px. Bis dahin hat dieser Teil
   nie gefragt, ob das Element ueberhaupt einen Rollkasten bildet.

   ⚠️ NICHT AUF auto|scroll PRUEFEN, SONDERN visible AUSSCHLIESSEN.
   overflow-x hidden rollt per scrollBy sehr wohl; nur Wischen und
   Rollbalken fehlen. Ein Praedikat auf auto|scroll naehme genau solchen
   Baendern die Pfeile weg. clip faellt mit heraus: dort gibt es keinen
   Rollversatz.

   ⚠️ UND ZWAR HIER, NICHT BEI DER ANMELDUNG. overflow-x aendert sich mit
   der Fensterbreite -- aus einem PC-Raster wird beim Drehen ein Band, und
   genau dafuer steht der Groessenbeobachter weiter oben. Eine Pruefung bei
   der Anmeldung schloesse das Element FUER IMMER aus: die Lauf-Marke wird
   einmalig gesetzt, und was nie angemeldet wurde, beobachtet auch niemand.
   Hier laeuft sie bei jedem Rollen und bei jeder Groessenaenderung neu.

   Gemessen, bevor diese Zeile geschrieben wurde: von 47 gefuehrten Baendern
   bei 390 px melden 30 rollbar. Von den 17 uebrigen haben 16 einen
   Ueberlauf von 0 -- ihre Leiste ist ohnehin versteckt, fuer sie aendert
   sich nichts. Es bleibt genau eines: die Warenkorbhuelle. */
function laufRollbar(band) {
  const o = getComputedStyle(band).overflowX;
  return o !== 'visible' && o !== 'clip';
}

/* 12.10.2026 Tempo P1-4: erst lesen, dann schreiben. Im Sammelbetrieb
   (laufSammeln, gesetzt vom Groessenbeobachter) werden die Schreibzugriffe
   aller Baender gesammelt und am Ende in einem Zug ausgefuehrt -- vorher
   erzwang jedes Band nach dem Schreiben des vorigen ein eigenes Layout. */
let laufSammeln = null;
function laufPfeileStand(z) {
  if (!z.pfeile) return;
  const band = z.band;
  const ueber = band.scrollWidth - band.clientWidth;
  const luft = Math.max(2, laufFuge(band));
  const versteckt = !laufRollbar(band) || ueber <= LAUF_LUFT;
  const links = band.scrollLeft;
  const p = z.pfeile;
  const schreiben = () => {
    p.leiste.hidden = versteckt;
    p.zurueck.disabled = links <= 2;
    p.vor.disabled = links >= ueber - luft;
  };
  if (laufSammeln) laufSammeln.push(schreiben); else schreiben();
}

function laufRuesten(z) {
  if (z.geruestet) return;
  z.geruestet = true;
  const band = z.band;
  /* ⚠️ 01.09.2026: z.ziel traegt ab hier IMMER eine Zahl, nie null. Vorher stand hier null,
     und das erste Rollereignis der Seite -- scroll-snap zieht beim Aufbau um 2 bis 12 px nach --
     wurde als Wisch des Kunden gelesen und hielt das Band dauerhaft an. Gemessen: 6 von 7
     Baendern der Startseite standen still, ehe sie ein einziges Mal gelaufen waren. */
  z.ziel = band.scrollLeft;
  z.ersteRuhe = true;

  const huelle = document.createElement('div');
  huelle.className = 'rb-lauf';
  band.parentNode.insertBefore(huelle, band);
  huelle.appendChild(band);
  z.huelle = huelle;

  /* ⚠️ EIN HALTEKNOPF NUR, WENN ES EINE BEWEGUNG ZUM ANHALTEN GIBT. Seit
     dem 11.09.2026 steht LAUF_SELBST auf false, also wird hier nichts
     gebaut. Der Block bleibt vollstaendig stehen, damit der Rueckweg eine
     einzige Zeile bleibt.

     ⚠️ VOR DEM BAND, NICHT DAHINTER. Bis zum 01.09.2026 wurde der Knopf
     angehaengt; wer mit der Tastatur ankam, tabbte erst durch alle Kacheln
     des Bandes -- gemessen bis zu elf Stueck mit je einem Verweis -- und
     erreichte den Halt danach. Ein Halt hinter der Bewegung, die er
     anhalten soll, ist ein Halt, den niemand rechtzeitig findet. */
  if (LAUF_SELBST) {
    const knopf = document.createElement('button');
    knopf.type = 'button';
    knopf.className = 'rb-lauf-halt';
    knopf.setAttribute('data-rb-lauf-halt', '');
    knopf.addEventListener('click', () => {
      z.halt = !z.halt;
      laufKnopfSchreiben(z);
      laufPruefen(z);
    });
    huelle.insertBefore(knopf, band);
    z.knopf = knopf;
    laufKnopfSchreiben(z);
  }

  laufPfeileBauen(z);

  /* Rad und Pfeiltaste sind ein Kunde, unmittelbar und ohne Zweifel. */
  band.addEventListener('wheel', () => laufKundeUebernimmt(z), { passive: true });
  band.addEventListener('keydown', (e) => {
    if (/^(Arrow|Page|Home|End)/.test(e.key)) laufKundeUebernimmt(z);
  });

  /* Zeiger, Fokus, Finger: das sind Pausen, keine Ansage. Sie stehen
     deshalb NICHT in aria-pressed -- der Knopf zeigt, was der Kunde
     eingestellt hat, nicht was sein Zeiger gerade tut. */
  if (zeiger) {
    band.addEventListener('pointerenter', () => laufPruefen(z));
    band.addEventListener('pointerleave', () => laufPruefen(z));
  }
  band.addEventListener('focusin', () => laufPruefen(z));
  /* focusout meldet, BEVOR der neue Fokus steht. Ohne den Umweg ueber die
     naechste Aufgabe waere document.activeElement hier noch der alte
     Knoten, und ein Sprung von Karte zu Karte innerhalb des Bandes saehe
     wie ein Verlassen aus. */
  band.addEventListener('focusout', () => { setTimeout(() => laufPruefen(z), 0); });
  band.addEventListener('touchstart', () => { z.beruehrt = true; laufPruefen(z); }, { passive: true });
  band.addEventListener('touchend', () => {
    /* Erst nach dem Auslauf des Schwungs wieder freigeben. Endet der
       Schwung woanders als beim eigenen Ziel, hat ohnehin schon das Netz
       darunter dauerhaft angehalten. */
    setTimeout(() => { z.beruehrt = false; laufPruefen(z); }, 1200);
  }, { passive: true });

  /* ⚠️ DAS NETZ. Ein Wisch mit dem Finger meldet weder 'wheel' noch
     'keydown'; er meldet nur 'scroll', und das meldet der eigene Lauf
     auch. Unterschieden wird deshalb nicht nach dem Anlass, sondern nach
     dem ERGEBNIS: kommt der Kasten dort zur Ruhe, wohin dieser Teil ihn
     geschickt hat, war es der eigene Lauf. Kommt er woanders zur Ruhe, war
     es der Kunde.

     Die Toleranz ist ein Drittel Kachel und mindestens 12 px, weil
     scroll-snap-type:x mandatory am Ende noch einmal um einige Bildpunkte
     nachzieht. Ein Wisch bewegt ein Vielfaches davon.

     160 ms Ruhe: das ist laenger als der Abstand zweier scroll-Ereignisse
     eines weichen Laufs und kuerzer als der kuerzeste Takt hier. */
  band.addEventListener('scroll', () => {
    clearTimeout(z.ruhe);
    z.ruhe = setTimeout(() => {
      const soll = z.ziel;
      const luft = Math.max(12, Math.round(laufSchritt(band) / 3));
      /* ⚠️ Die erste Ruhe stammt aus dem Aufbau der Seite und wird bedingungslos hingenommen.
         Danach gilt: weit weg vom vereinbarten Punkt = der Kunde hat gewischt. Nahe dran =
         der eigene Lauf oder ein Nachziehen des Snap-Rasters; dann wird der neue Punkt zum
         vereinbarten. So steht z.ziel nie wieder auf null, und ein Nachziehen um 9 px kann
         den Lauf nicht mehr faelschlich beenden. */
      if (z.ersteRuhe) { z.ersteRuhe = false; z.ziel = band.scrollLeft; return; }
      if (soll !== null && Math.abs(band.scrollLeft - soll) > luft) laufKundeUebernimmt(z);
      else z.ziel = band.scrollLeft;
    }, 160);
  }, { passive: true });

  /* Der eine Beobachter des Hauses. Er kommt erst hier dazu, also erst
     wenn dieser Kasten wirklich ein Band ist -- auf dem PC meldet sich
     dieselbe Sektion gar nicht erst an. */
  beiSichtDauernd(band, (_el, drin) => { z.drin = drin; laufPruefen(z); });
}

function selbstlauf(wurzel = document) {
  /* ⚠️ 11.09.2026: HIER WURDE FRUEHER BEDINGUNGSLOS AUSGESTIEGEN, und das
     war richtig, solange dieser Teil nur Bewegung baute. Jetzt baut er
     Pfeile, und ein Pfeil ist keine Bewegung, sondern Bedienung. Wer
     "Bewegung reduzieren" eingeschaltet hat, braucht den Weg zum
     abgeschnittenen Rest eher mehr als weniger -- ihm bliebe sonst als
     einziger Weg der Wisch. Die Bewegung des Blaetterns selbst richtet sich
     nach derselben Einstellung, siehe laufPfeileBauen. */
  if (ruhig && LAUF_SELBST) return;

  /* Ein Horcher am Dokument, EINMAL. Er darf nicht in TEILE stehen: TEILE
     laeuft bei jedem shopify:section:load erneut. */
  if (!laufSichtHorcher) {
    laufSichtHorcher = true;
    document.addEventListener('visibilitychange', () => { laufAlle.forEach(laufPruefen); });
    /* Aus dem PC-Raster wird beim Drehen des Geraets ein Band und
       umgekehrt. Ohne diese Zeilen stuende auf einem gedrehten Handy ein
       Band ohne Knopf und ohne Lauf. */
    if ('ResizeObserver' in window) {
      laufMasse = new ResizeObserver((eintraege) => {
        laufSammeln = [];
        try {
          for (const e of eintraege) { const z = laufStand.get(e.target); if (z) laufPruefen(z); }
        } finally {
          const q = laufSammeln;
          laufSammeln = null;
          q.forEach((f) => f());
        }
      });
    }
  }

  alle(LAUF_JA, wurzel).forEach((band) => {
    if (band.dataset.rbLauf) return;
    if (band.closest(LAUF_NEIN)) return;
    /* Weniger als zwei Kacheln ist kein Band. */
    if (laufKinder(band).length < 2) return;
    /* Ein Band aus reiner Schrift laeuft nicht von selbst. Begruendung und
       die gemessenen acht Faelle stehen bei laufZeigtEtwas. */
    /* ⚠️ NUR DER LAUF MEIDET DEN FLIESSTEXT, DIE PFEILE NICHT. Die
       Begruendung bei laufZeigtEtwas gilt weiter und ist richtig: eine
       Kachel, die man lesen muss, kann man nicht lesen, waehrend sie
       weglaeuft. Ein Pfeil laeuft nicht weg, er wird gedrueckt. Gemessen am
       11.09.2026 stehen 13 solcher Baender im Laden -- die Garantiekacheln
       auf vier Adressen und "Warum hier kaufen" ragen um 1102 px aus einem
       390 px breiten Fenster und hatten bis heute keinen Hinweis darauf,
       dass es rechts weitergeht. */
    if (LAUF_SELBST && !laufZeigtEtwas(band)) return;
    band.dataset.rbLauf = '1';
    const z = {
      band, halt: false, drin: false, beruehrt: false,
      geruestet: false, huelle: null, knopf: null, pfeile: null, ziel: null, faellig: 0, ruhe: 0,
    };
    laufStand.set(band, z);
    laufAlle.add(z);
    /* 12.10.2026 Tempo P1-4: mit Groessenbeobachter kein Sofort-Pruefen --
       der Beobachter meldet beim Anmelden einmal (vor dem naechsten Bild)
       und prueft dann alle Baender gesammelt. Vorher lief laufPruefen je
       Band zweimal, jedes Mal mit erzwungenem Layout. */
    if (laufMasse) laufMasse.observe(band);
    else laufPruefen(z);
  });
}

/* ==========================================================================
   Start
   ========================================================================== */
/* ⚠️ JEDER TEIL WIRD EINZELN GEKAPSELT.

   Vorher stand hier eine nackte Kette von siebzehn Aufrufen. Wirft einer --
   ein fehlendes Element, ein leeres data-Attribut, ein JSON.parse auf einer
   leeren Zeichenkette --, laeuft KEINER der folgenden mehr. Ein Tippfehler
   im Groessenvergleich legte so die Zeigereffekte, den Warenkorb-
   Fortschritt und alles dazwischen still.

   Ein Fehler in einem Bauteil darf nur dieses eine Bauteil kosten. Der
   Fehler wird auf der Konsole genannt, nicht verschluckt: eine stille
   Ausnahme ist schlimmer als eine laute. */
/* ⚠️ SYMBOLNAMEN WERDEN NICHT MITGESPROCHEN. 11.09.2026.

   Gemessen trug auf den Produktseiten KEIN EINZIGES der Symbole ein
   aria-hidden -- 11 auf Eiliko, 14 auf Eilik, 12 auf Panxer, davon je vier
   in einer Ueberschrift. Ein Vorleseprogramm sagt dort also erst den
   Symbolnamen und dann die Ueberschrift.

   ⚠️ DAS FREMDTHEME BLEIBT UNANGETASTET. 39 Dateien schreiben
   material-icon, 38 gehoeren Shrine -- darunter der Renderer
   snippets/material-icon.liquid. Ein Attribut dort waere beim naechsten
   Theme-Update weg. Hier gesetzt ueberlebt es jedes Update.

   ⚠️ EIN SYMBOL, DAS DIE AUSKUNFT ALLEIN TRAEGT, BLEIBT HOERBAR. Ein Knopf
   mit nichts als einem Symbol waere nach dem Stummschalten fuer ein
   Vorleseprogramm LEER, also schlechter als vorher. Gemessen am 11.09.2026
   ueber sechs Adressen trifft das auf KEINES der 37 Symbole zu -- alle
   tragen Text oder ein aria-label daneben. Die Pruefung bleibt trotzdem
   stehen: eine Messung von heute ist keine Zusage fuer morgen. */
function symboleStumm(wurzel = document) {
  alle('.material-icon', wurzel).forEach((sp) => {
    if (sp.hasAttribute('aria-hidden')) return;
    const ziel = sp.closest('a, button, summary, label, [role="button"]');
    if (ziel) {
      const wort = (sp.textContent || '').trim();
      const rest = (ziel.textContent || '').replace(wort, '').trim();
      const label = ziel.getAttribute('aria-label') || '';
      /* Traegt das Bedienelement sonst nichts, ist das Symbol die einzige
         Auskunft -- dann bleibt es hoerbar. */
      if (rest.length < 2 && label.length < 2) return;
    }
    sp.setAttribute('aria-hidden', 'true');
  });
}

function sicher(name, fn, wurzel) {
  try { fn(wurzel); }
  catch (e) { console.error(`[robbytoys] ${name} ist ausgefallen:`, e); }
}

/* ⚠️ 31.08.2026: eintrittNachruesten steht VOR revealsStarten und muss dort
   bleiben. Es schreibt nur Attribute; die Arbeit macht danach die
   vorhandene Maschine. Laeuft es hinterher, findet revealsStarten seine
   frisch gesetzten data-rb-rev nicht mehr, und der Nachruester waere
   wirkungslos, ohne dass irgendwo ein Fehler erschiene. */
/* ===========================================================================
   ⚠️ HIER STAND DER KI-HINWEIS AN DEN BILDERN. Gebaut am 13.09.2026 vormittags,
   am selben Abend auf Anwaltsrat vollstaendig ausgebaut.

   Auftrag zum Rueckbau, woertlich:
     "bitte rueckzug alle i mit ki usw weg fehlinfos anwalt hat gesagt"

   Der Satz, der an den Bildern stand:
     "Dieses Bild entstand mit Unterstuetzung durch KI."
     "Dieses Video entstand mit Unterstuetzung durch KI."
     "Abbildungen in diesem Abschnitt entstanden mit Unterstuetzung durch KI."

   ⚠️ DER GRUND IST NICHT TECHNISCH, SONDERN INHALTLICH: die Angabe ist
   anwaltlich als FEHLINFORMATION eingestuft. Gebaut wurde sie auf die
   Auskunft "alle unsere Bilder sind KI-gestuetzt" -- und schon damals hielt
   die der eigenen Akte nicht stand. Gemessen am 13.09.2026: die Dateien
   el-leben-nutzerfoto-01..16 stellen 24 von 53 Bildern auf /products/eilik
   und 34 von 65 auf der Startseite, und das Bilder-Register fuehrt sie als
   KUNDENFOTOS der Hersteller-Website, 23 davon mit erkennbaren Personen.
   Sie wurden damals ausgenommen; die anwaltliche Bewertung geht weiter.

   ⚠️ WER DAS WIEDER EINBAUEN WILL, BRAUCHT VORHER DIE BELEGKETTE JE BILD --
   nicht die Annahme, dass "die meisten wohl" KI sind. Eine Kennzeichnung ist
   eine Aussage ueber die Ware und braucht denselben Beleg wie eine Zahl im
   Datenblatt. Der vollstaendige Bauplan liegt als Baustein im Haus
   (60-BAUKASTEN, baustein-ki-hinweis) samt allen elf Messbefunden, die beim
   ersten Bau entstanden sind -- er muss nicht neu erfunden werden.

   Entfernt wurden: KI_BILD, KI_VIDEO, KI_BLOCK, KI_AUS, KI_ID_BILD,
   KI_ID_VIDEO, KI_ID_BLOCK, kiMass, kiSchluessel, kiTreffer, kiHinweise,
   kiSatzknoten, kiBeschreiben, kiKnopfBauen, kiDarfRelativ, kiUeberlagert,
   kiAnker, kiEckeFrei, kiGrundHell, kiAbschnittsknopf, kiNachpruefen,
   kiAlleZu, kiSchliesser, kiNachzug -- dazu der Eintrag in TEILE und die
   zwei Aufrufe in loslegen(). Und in rb-overrides.css der Abschnitt 57.
   =========================================================================== */

const TEILE = [
  /* ⚠️ symboleStumm steht GANZ VORNE und schreibt nur ein Attribut -- wie
     eintrittNachruesten. Es haengt von nichts ab und nichts haengt von ihm
     ab; vorne steht es, damit ein Vorleseprogramm die Seite nie in einem
     Zwischenzustand vorliest. */
  ['symboleStumm', symboleStumm],
  ['eintrittNachruesten', eintrittNachruesten],
  ['revealsStarten', revealsStarten],
  /* ⚠️ augenEinsetzen steht VOR blinzelnVerteilen und vor zeigerEffekte:
     es BAUT die Augen erst. Liefe es danach, bekaeme das neue Augenpaar
     weder seine gestreute Blinzeldauer noch den Zeigereffekt -- es blinzelte
     im Gleichtakt mit allen anderen und die Pupillen stuenden still. */
  ['augenEinsetzen', augenEinsetzen], ['blinzelnVerteilen', blinzelnVerteilen],
  ['gesichterAnmelden', gesichterAnmelden], ['schleifenAnmelden', schleifenAnmelden],
  ['cursorSetzen', cursorSetzen],
  ['baenderStarten', baenderStarten], ['zaehlerStarten', zaehlerStarten],
  ['ringeStarten', ringeStarten], ['ausklapper', ausklapper],
  ['reiter', reiter], ['kleiderschrank', kleiderschrank],
  ['anatomie', anatomie], ['schreibtisch', schreibtisch],
  ['schieber', schieber], ['stimmenFilter', stimmenFilter],
  ['fortschritt', fortschritt], ['hoehenangst', hoehenangst],
  ['geschenkfinder', geschenkfinder], ['groessenvergleich', groessenvergleich],
  ['videokacheln', videokacheln], ['videoflaechen', videoflaechen],
  ['filmeUebernehmen', filmeUebernehmen],
  ['collagen', collagen], ['nachladen', nachladen], ['schweben', schweben],
  ['wellen', wellen],
  ['zeigerEffekte', zeigerEffekte], ['scrollWerk', scrollWerk],
  /* ⚠️ buehnenScan steht ABSICHTLICH HINTER scrollWerk. bahnenSammeln
     (in scrollWerk) meldet dieselbe .rb-neu-buehne mit einer LEEREN
     Rueckruffunktion beim Dauerbeobachter an. Stuende buehnenScan davor,
     wuerde unsere Rueckruffunktion von der leeren ueberschrieben und die
     Scanline liefe nie -- ohne dass irgendwo ein Fehler erschiene.
     Andersherum ueberschreiben wir die leere Funktion, und `is-sicht`,
     das bahnenSammeln allein braucht, setzt der Beobachter unabhaengig
     von jeder Rueckruffunktion. */
  ['buehnenScan', buehnenScan],
  /* ⚠️ HIER STAND ['kiHinweise', kiHinweise] -- der Einhaengepunkt des
     KI-Hinweises. Er ist am 13.09.2026 auf Anwaltsrat mit dem ganzen Apparat
     gefallen; die Begruendung steht oben am Grabstein. */
  /* ⚠️ selbstlauf steht GANZ HINTEN und muss dort bleiben. Er misst
     scrollWidth gegen clientWidth, und diese Zahl stimmt erst, wenn
     alles davor sein Markup gesetzt hat -- eintrittNachruesten haengt
     Attribute an, augenEinsetzen BAUT Elemente. Vor ihnen gemessen,
     bekaeme ein Band, das erst danach ueberlaeuft, keinen Lauf. */
  ['selbstlauf', selbstlauf],
];

function start(wurzel = document) {
  for (const [name, fn] of TEILE) sicher(name, fn, wurzel);
}

/* Modulskripte laufen nach dem Parsen des Dokuments. DOMContentLoaded kann
   also bereits gefeuert haben, bevor dieser Zuhoerer haengt -- dann waere er
   nie ausgeloest worden. Deshalb wird der Zustand vorher abgefragt. */
function loslegen() {
  sicher('start', () => start(), document);
  sicher('bootScanline', bootScanline);
  sicher('herzHaengen', herzHaengen);
  sicher('atcAjax', atcAjax);
  sicher('ankerWeich', ankerWeich);
  sicher('ladegesicht', ladegesicht);
  sicher('atcHoehe', atcHoehe);
  /* ⚠️ DIE VIER STEHEN HIER UND NICHT IN TEILE. Jede haengt genau EINEN
     Horcher ans Dokument. TEILE laeuft bei jedem shopify:section:load
     erneut -- dort wuerden aus einem Horcher im Theme-Editor nach zwanzig
     Sektionswechseln zwanzig, und der Warenkorb ruckte zwanzigmal. */
  sicher('willChangeAbraeumen', willChangeAbraeumen);
  sicher('servoNicken', servoNicken);
  sicher('korbQuittung', korbQuittung);
  sicher('swatchKlackFreigeben', swatchKlackFreigeben);
  sicher('swatchSpurenNachziehen', swatchSpurenNachziehen);
  /* ⚠️ HIER STANDEN sicher('kiSchliesser') und sicher('kiNachzug') -- die
     zwei Einzelhorcher des KI-Hinweises. Mit ihm gefallen am 13.09.2026.
     ⚠️ Sie MUSSTEN mitfallen: ein Aufruf ohne Funktion laesst loslegen()
     abbrechen, und dann steht der ganze Laden ohne JavaScript da. */
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', loslegen);
} else {
  loslegen();
}

/* Der Theme-Editor baut Sektionen einzeln neu auf. Ohne diese beiden Zeilen
   ist jede neu geladene Sektion tot, und der Auftraggeber sieht im Editor
   etwas anderes als im Shop. */
document.addEventListener('shopify:section:load', (e) => { start(e.target); atcHoehe(); });
document.addEventListener('shopify:section:select', (e) => start(e.target));

/* Nach jedem Warenkorb-Vorgang neu rechnen. */
document.addEventListener('cart:refresh', () => fortschritt());
document.addEventListener('cart:updated', () => fortschritt());

/* --- Der Videokasten nimmt das Mass des Videos ---------------------------
   Ein <video> kennt seine Groesse erst, wenn der Dateikopf da ist. Bis
   dahin steht im Kasten der Anfangswert aus dem Stilblatt. Sobald
   videoWidth gefuellt ist, wird das gemessene Verhaeltnis gesetzt --
   damit ist der Kasten exakt so gross wie sein Inhalt und kein Bildpunkt
   bleibt leer.

   ⚠️ Nicht auf 'loadedmetadata' allein hoeren: ein Video, das schon im
   Zwischenspeicher liegt, hat das Ereignis beim Anhaengen des Horchers
   bereits ausgeloest. Deshalb wird vorher einmal direkt nachgesehen.

   ⚠️ Befund 22.08.2026: bis das Video seinen Kopf geladen hat, steht im
   Kasten der feste Anfangswert 16/9 aus dem Stilblatt (robby-kleiderschrank
   .liquid, robby-textbild.liquid). Bei einem hochkant gefilmten Standbild
   (gemessen 720x1280, 0,562) sind das 68,4 Prozent Rahmenflaeche statt
   Bild, bis das Video antwortet. Das Standbild (poster) kennt sein eigenes
   Verhaeltnis oft laengst, bevor das Video ueberhaupt zu laden beginnt --
   dieselbe Regel wie beim Video gilt auch hier: ein Bild aus dem
   Zwischenspeicher hat sein 'load'-Ereignis oft schon ausgeloest, bevor ein
   Horcher haengt, also wird ueber `complete` + `naturalWidth` direkt
   nachgesehen. Das Video gewinnt, sobald es misst -- die Zeile dazu prueft
   ausdruecklich, ob schon "gemessen" gilt, damit ein spaetes Standbild ein
   bereits gemessenes Video nie wieder ueberschreibt. */
(function () {
  var kaesten = document.querySelectorAll('[data-rb-vidkasten]');
  if (!kaesten.length) return;
  kaesten.forEach(function (kasten) {
    var v = kasten.querySelector('video');
    if (!v) return;
    var setzen = function () {
      if (!v.videoWidth || !v.videoHeight) return;
      kasten.style.setProperty('--rb-vid-verh', v.videoWidth + ' / ' + v.videoHeight);
      kasten.dataset.rbVidkasten = 'gemessen';
    };
    if (v.poster && !v.dataset.rbVidkasten) {
      var standbild = new Image();
      var posterSetzen = function () {
        if (kasten.dataset.rbVidkasten === 'gemessen') return;
        if (!standbild.naturalWidth || !standbild.naturalHeight) return;
        kasten.style.setProperty('--rb-vid-verh', standbild.naturalWidth + ' / ' + standbild.naturalHeight);
      };
      standbild.addEventListener('load', posterSetzen);
      standbild.src = v.poster;
      if (standbild.complete) posterSetzen();
    }
    setzen();
    v.addEventListener('loadedmetadata', setzen);
    /* Die Quelle wechselt am Umbruchpunkt zwischen PC- und Handyfassung.
       Die beiden Fassungen haben nicht dasselbe Mass. */
    v.addEventListener('resize', setzen);
  });
})();

/* ==========================================================================
   38 - Endlose Animationen ruhen, solange niemand sie sieht
   --------------------------------------------------------------------------
   Gemessen am 12.09.2026 an /products/eiliko, gedrosselt (1,6 Mbit / 150 ms /
   CPU x4), acht Sekunden LEERLAUF -- geladen, nichts angeklickt, nicht
   gescrollt:

                               Stilberechnung   Bilder je Sekunde
     wie sie war                    4847 ms            57
     alle Animationen gestoppt        65 ms            19

   Neun endlose Animationen liefen, keine davon im Bild. Die Zeitspur weist zu
   den 715 Stilberechnungen in acht Sekunden KEINEN Aufrufstapel aus: kein
   Skript loest sie aus, es ist der Bildtakt der Animationen selbst.

   ⚠️ WARUM "TRANSFORM IST BILLIG" HIER NICHT GILT. Eine Animation laeuft nur
   dann im Compositor, wenn sie ausschliesslich transform, opacity oder filter
   bewegt UND das Element dafuer befoerdert werden kann. rb-blink bewegt
   transform auf einem SVG-Element -- das befoerdert Chrome nicht. Sobald EINE
   nicht befoerderte Animation laeuft, rechnet der Browser bei jedem Bild den
   Stil der ganzen Seite neu.

   ⚠️ WARUM HIER EIN ZWEITER BEOBACHTER STEHT, obwohl dieser Shop sonst mit
   einem auskommt: der geteilte traegt rootMargin "0px 0px -8% 0px". Er meldet
   "draussen", waehrend unten noch rund 67 px sichtbar sind. Zum Einblenden
   ist das richtig; zum Anhalten waere es ein sichtbarer Fehler -- ein Band,
   das gerade hereinkommt, stuende die letzten 67 px still. Dieser hier hat
   400 px Vorlauf nach beiden Seiten.

   ⚠️ UND WARUM DIE MARKIERUNG NUR GESETZT, NIE ANGENOMMEN WIRD. Am 23.08.2026
   ist genau diese Pause schon einmal entfernt worden, weil das Band beim
   ersten Bild ein, zwei Bildwechsel stillstand: die alte Fassung pausierte,
   BIS der Beobachter meldete. Hier ist es umgekehrt -- es laeuft, bis jemand
   sagt, dass niemand hinsieht. Ein Browser ohne IntersectionObserver
   markiert nie, also laeuft dort alles wie bisher.
   ========================================================================== */
(function () {
  if (typeof IntersectionObserver !== 'function') return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var MARKE = 'data-rb-anim';
  var RUHT = 'rb-anim-ruht';

  var wache = new IntersectionObserver(function (eintraege) {
    for (var i = 0; i < eintraege.length; i++) {
      var e = eintraege[i];
      e.target.classList.toggle(RUHT, !e.isIntersecting);
    }
  }, { rootMargin: '400px 0px 400px 0px', threshold: 0 });

  /* Welcher Behaelter wird beobachtet? Nicht das animierte Element selbst --
     bei vier Augenlidern in einem SVG waeren das vier Ziele fuer dieselbe
     Sektion. Der naechste Abschnitt reicht, und das Stilblatt haelt alles
     darin an. */
  function behaelter(el) {
    if (!el || !el.closest) return null;
    return el.closest('section, .shopify-section, [id^="shopify-section"]') || el;
  }

  function einsammeln() {
    if (!document.getAnimations) return 0;
    var neu = 0;
    var alle = document.getAnimations();
    for (var i = 0; i < alle.length; i++) {
      var a = alle[i];
      var w = a.effect && a.effect.getTiming ? a.effect.getTiming() : null;
      /* Nur die endlosen. Eine Einblendung laeuft einmal und ist danach
         still -- die anzuhalten braeuchte niemand und koennte sie mitten im
         Bild einfrieren. */
      if (!w || w.iterations !== Infinity) continue;
      var el = behaelter(a.effect && a.effect.target);
      if (!el || el.hasAttribute(MARKE)) continue;
      el.setAttribute(MARKE, '');
      wache.observe(el);
      neu++;
    }
    return neu;
  }

  /* Zweimal nachsehen: Sektionen, die ihr Markup spaeter nachreichen, haben
     beim ersten Durchgang noch keine Animation. */
  function anlauf() { einsammeln(); setTimeout(einsammeln, 2500); }
  if (document.readyState === 'complete') anlauf();
  else window.addEventListener('load', anlauf, { once: true });

  /* Der Theme-Editor baut Sektionen neu auf. */
  document.addEventListener('shopify:section:load', function () { setTimeout(einsammeln, 60); });
})();

/* 10 — STILLGELEGT AM 15.09.2026. GEMESSEN: ER HAT NICHT GEWIRKT.
 *
 * Der Beobachter wurde gesetzt (rootMargin 600px, Sektion gefunden), aber nach
 * dem Durchscrollen standen die Bilder unveraendert auf loading=lazy: gemessen
 * 24 Bilder, davon 8 geladen und 16 LEER. Das Setzen von img.loading = 'eager'
 * stoesst bei einem bereits zurueckgestellten Bild in dieser Umgebung KEINEN
 * Ladevorgang an. Wer es erneut versucht, muss src neu zuweisen, nicht loading.
 * Bis dahin gilt wieder eager -- ein leerer Kasten ist schlimmer als ein spaetes
 * Byte. Der Sparweg lief stattdessen ueber die Auslieferungsbreite (640 -> 480).
 *
 * Der urspruengliche Gedanke, zur Erinnerung:
 *
 * ⚠️ WARUM NICHT EINFACH loading="lazy" ALLEIN. Am 22.08.2026 ist genau das
 * schon einmal versucht worden und hat sechs Kaesten leer gelassen: die Spur
 * der Collage ist seitlich verschoben und wird vom Elternteil beschnitten, der
 * Browser haelt die Bilder deshalb dauerhaft fuer ausserhalb des Sichtfelds
 * und laedt sie nie. Seitdem stand dort eager -- und holte 968 kB elf
 * Bildschirmhoehen unter dem Falz, gemessen am 15.09.2026 auf 390 px:
 * 58 Prozent des gesamten Bildverkehrs der Seite.
 *
 * Dieser Beobachter loest beides: die Bilder stehen auf lazy und werden vom
 * Browser zurueckgehalten, und sobald die SEKTION (nicht das Bild) in die
 * Naehe kommt, wird loading auf eager gesetzt. Das stoesst den Ladevorgang
 * sofort an, unabhaengig davon, wie die Spur verschoben ist.
 *
 * ⚠️ Faellt JavaScript aus, bleiben die Bilder auf lazy. Dann entscheidet der
 * Browser -- schlimmstenfalls wie 2026 mit leeren Kaesten, aber ohne Ladekosten.
 * Das ist der bewusst gewaehlte Rueckfall: ein spaetes Bild ist besser als eine
 * Seite, die eine Sekunde laenger braucht.
 */
(function () {
  /* ⚠️ 15.09.2026, beim ersten Versuch gemessen: der Beobachter lief sofort beim
     Einlesen des Skripts, da stand die Collage noch nicht im Dokument.
     querySelectorAll fand null Sektionen, der Beobachter wurde nie gesetzt, und
     nach dem Scrollen blieben 16 von 24 Kaesten leer -- genau der Ausfall vom
     22.08.2026. Deshalb wird jetzt auf das fertige Dokument gewartet, und der
     Theme-Editor stoesst nach jedem Neuaufbau erneut an. */
  return; /* ⚠️ 15.09.2026 STILLGELEGT, siehe unten. */
  function starten() {
  var sektionen = document.querySelectorAll('.rb-neu-collage');
  if (!sektionen.length) return;
  if (!('IntersectionObserver' in window)) {
    /* Alter Browser: sofort freigeben, lieber laden als leer bleiben. */
    for (var i = 0; i < sektionen.length; i++) freigeben(sektionen[i]);
    return;
  }
  function freigeben(wurzel) {
    var bilder = wurzel.querySelectorAll('img[loading="lazy"]');
    for (var i = 0; i < bilder.length; i++) bilder[i].loading = 'eager';
  }
  var wache = new IntersectionObserver(function (eintraege) {
    for (var i = 0; i < eintraege.length; i++) {
      if (!eintraege[i].isIntersecting) continue;
      freigeben(eintraege[i].target);
      wache.unobserve(eintraege[i].target);
    }
  }, { rootMargin: '600px 0px' });
  for (var j = 0; j < sektionen.length; j++) wache.observe(sektionen[j]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', starten, { once: true });
  else starten();
  document.addEventListener('shopify:section:load', function () { setTimeout(starten, 60); });
})();

/* ==========================================================================
   DER EINPASSER - KACHELTEXTE BLEIBEN EINZEILIG. Angelegt 16.09.2026.

   Anweisung des Auftraggebers, woertlich: "die benefits in der buy section
   sowie egal wo anders auch muessen einzeilig stehen! das darf nie irgendwo
   in 2 zeilen rutschen, das muss fuer jedes geraet immer 100% sauber sich
   ueberall mit anpassen so das ueberschrift und untertext immer nur in einer
   zeile sind".

   ⚠️ WARUM DAS STILBLATT DAS NICHT ALLEIN KANN. Ein Stilblatt kennt die
   Breite eines Kastens, aber nicht die Laenge eines Wortes. white-space:
   nowrap verhindert den Umbruch und erzeugt dafuer einen Ueberlauf; eine
   clamp-Formel skaliert mit dem Kasten, nicht mit dem Text. Einzeiligkeit
   fuer JEDEN Text auf JEDEM Geraet laesst sich nur messen, nicht
   deklarieren. Deshalb dieser Einpasser.

   ⚠️ 16.09.2026 IN DREI PUNKTEN REPARIERT, nachdem eine unabhaengige
     Gegenpruefung ihm 27 von 33 Befunden zugeschrieben hat:
       1. platz() mass den ELTERNKASTEN. Bei jeder Kachel mit Symbolspalte
          fehlten dadurch rund 60 px, der Text galt als passend und lief aus
          dem Kasten -- auf /cart 56,5 px, abgeschnitten von der Kachelkante.
       2. Er prueft sein Ergebnis jetzt NACH. Vorher liess er 20,9 px stehen,
          wo seine eigene Formel 19,5 px ergab, und schnitt ein "g" ab.
       3. Der gemeinsame Gruppenfaktor ist gefallen. Er zog kurze
          Ueberschriften auf bis zu 45 Prozent herunter. Statt dessen gilt
          eine Untergrenze von 85 Prozent je Element.

   WAS ER TUT, JE ROLLE:
     1. Er misst fuer jeden Text, wie breit er in einer Zeile waere - an einem
        unsichtbaren Klon mit nowrap, nicht am Element selbst.
     2. Er misst, wie viel Platz der Elternkasten wirklich hergibt.
     3. Texte, die selbst bei der Untergrenze nicht hineinpassen, nimmt er
        aus dem Spiel: sie duerfen wieder umbrechen und tragen danach
        data-rb-1z="zu-lang".
     4. Aus dem Rest bildet er EINEN gemeinsamen Faktor - den kleinsten.
     5. Passt alles ohne Verkleinerung, ruehrt er nichts an.

   ⚠️ SCHRITT 4 IST DER GRUND, WARUM ER GRUPPENWEISE ARBEITET. Wuerde jeder
   Text fuer sich verkleinert, staenden vier Kacheln nebeneinander in vier
   verschiedenen Schriftgroessen. Gemessen am 16.09.2026 auf /products/eiliko
   bei 390 px: eine Kachel 10,7 px, die drei anderen 14 px. Das sieht
   schlimmer aus als der Umbruch, den es beheben soll. Ein gemeinsamer Faktor
   je Rolle haelt die Reihe ruhig.

   ⚠️ SCHRITT 3 IST DAS SICHERHEITSNETZ. Ein Text, der abgeschnitten wird
   oder aus der Kachel laeuft, ist schlimmer als zwei Zeilen. Der Einpasser
   bricht deshalb lieber seine eigene Regel, als etwas unlesbar zu machen.
   Wer data-rb-1z="zu-lang" im Laden findet, hat einen Text, der gekuerzt
   gehoert - die Maschine sagt es an der Stelle, an der es passiert.

   ⚠️ UNTERGRENZE 10 px. Darunter ist Text auf einem Telefon nicht mehr
   lesbar. Das ist eine Lesbarkeitsgrenze, keine Geschmacksfrage.

   ⚠️ OBERGRENZE 40 ZEICHEN. Was laenger ist, ist kein Kachelwort mehr,
   sondern ein Satz - und ein Satz darf umbrechen. Ohne diese Grenze wuerde
   der Einpasser Fliesstext auf 10 px herunterrechnen. Titel sind davon
   ausgenommen: eine Ueberschrift ist immer eine Beschriftung.

   ⚠️ ER SCHRUMPFT NUR, ER VERGROESSERT NIE. Vor jeder Messung wird die
   Inline-Groesse geloescht, damit die Kaskade wieder gilt - sonst bliebe ein
   einmal verkleinerter Text beim Drehen des Telefons klein.

   ⚠️ DIE SCHLEIFE IST DIE GEFAHR. Wer die Schriftgroesse aendert, aendert
   die Elementhoehe, und ein ResizeObserver auf demselben Element feuert dann
   erneut. Beobachtet wird deshalb die GRUPPE und nur ihre BREITE
   (box: 'border-box' liefert beide Achsen, geprueft wird nur die inline-
   Achse), denn die Breite kommt vom Raster und aendert sich durch eine
   kleinere Schrift nicht. Dazu eine Sperre waehrend des Laufs und ein
   rAF-Sammler.
   ========================================================================== */
(function () {
  'use strict';

  /* Die Ziele. "gruppe" ist der Kasten, in dem eine gemeinsame Schriftgroesse
     gelten soll; "rollen" sind die Textsorten darin.
     ⚠️ Wer hier etwas ergaenzt, muss im Stilblatt an derselben Stelle
     white-space: nowrap und min-width: 0 setzen - sonst misst der Einpasser
     einen Text, der ohnehin umbricht, und findet nie einen Ueberlauf.
     Die Gegenstuecke stehen in assets/rb-overrides.css Abschnitt 50 und in
     snippets/robby-kaufbox.liquid Gruppe (z1c). */
  var ZIELE = [
    /* Die vier Vorteilskacheln der Kaufbox - der Anlass.

       ⚠️ 01.10.2026: HIER GIBT DER EINPASSER NICHT MEHR AUF. Bis heute galt
       auch hier die Untergrenze von 85 Prozent und 11 px -- und damit liess
       er die Titel umbrechen, sobald sie nicht passten. Gemessen am
       01.10.2026 an allen fuenf Produktseiten von 300 bis 1600 px: 29
       zweizeilige Texte, alle zwischen 340 und 380 px Fenster, alle mit
       data-rb-1z="zu-lang". Bei 340 px braucht "Uebersetzt Sprachen" 119 px
       und hat 95 -- noetig waeren 10,4 px Schrift, erlaubt waren 11,05.
       Der Untertext steht dort auf 11 px und durfte wegen der 11-px-Grenze
       GAR NICHT verkleinert werden. Ein Besucher hat genau das gesehen.
       Die Anweisung des Auftraggebers ist hier woertlich "niemals":
         boden      10 px statt 85 Prozent / 11 px
         gemeinsam  eine Schriftgroesse je Rolle fuer alle vier Kacheln --
                    vier Groessen nebeneinander sahen unruhig aus
         luft       2 px Reserve, damit Rundung und Schriftglaettung eines
                    anderen Geraets nicht doch noch umbrechen
         kippen     reicht auch der Boden nicht, stehen die Kacheln
                    UNTEREINANDER statt zu zweit. Eine Spalte hat doppelt so
                    viel Platz; Umbruch ist damit ausgeschlossen. */
    { gruppe: '[id$="__k_vorteile"]', kasten: '.icons-with-text__icon-item', boden: 10, gemeinsam: true, luft: 2, kippen: true,
      rollen: [
        { waehler: '.icons-with-text__icon__title > span', titel: true },
        { waehler: '.icons-with-text__icon__text > .rte p' }
      ] },
    /* Die Vertrauensleiste - der meistbenutzte Baustein des Ladens. */
    { gruppe: '.rb-grid:has(> .rb-icon-zeile)',
      rollen: [
        { waehler: '.rb-icon-zeile b', titel: true },
        { waehler: '.rb-icon-zeile > span > span' }
      ] },
    /* Die Hauskachel in allen ihren Verwendungen. */
    { gruppe: '.rb-grid',
      rollen: [
        { waehler: '.rb-kachel__titel', titel: true },
        { waehler: '.rb-serie__name', titel: true },
        { waehler: '.rb-gar__titel', titel: true },
        { waehler: '.rb-teil__name', titel: true },
        { waehler: '.rb-teil__hinweis' },
        { waehler: '.rb-face__name', titel: true },
        { waehler: '.rb-face__ausloeser' },
        { waehler: '.rb-set__name', titel: true }
      ] },
    { gruppe: '.rb-warum',
      rollen: [ { waehler: '.rb-warum__titel', titel: true } ] },
    { gruppe: '.rb-neu-bento',
      rollen: [
        { waehler: '.rb-neu-bento__titel', titel: true },
        { waehler: '.rb-neu-bento__satz' }
      ] },
    { gruppe: '.rb-neu-vid',
      rollen: [
        { waehler: '.rb-neu-vid__titel', titel: true },
        { waehler: '.rb-neu-vid__dauer' }
      ] },
    { gruppe: '.rb-neu-zahlen__raster',
      rollen: [
        { waehler: '.rb-neu-zahlen__wert', titel: true },
        { waehler: '.rb-neu-zahlen__name', titel: true },
        { waehler: '.rb-neu-zahlen__quelle' }
      ] },
    { gruppe: '.rb-weg',
      rollen: [
        { waehler: '.rb-weg__wann', titel: true },
        { waehler: '.rb-weg__was' }
      ] },
    { gruppe: '.rb-rail',
      rollen: [ { waehler: '.rb-stimme__titel', titel: true } ] },
    /* Der Fussbereich - fuenf Spaltenkoepfe, auf jeder Seite dieselben. */
    { gruppe: '.footer__content-top',
      rollen: [ { waehler: '.footer-block__heading', titel: true } ] },
    /* Die Paketwahl auf der Produktseite. */
    { gruppe: '.product__info-container',
      rollen: [ { waehler: '.color-swatch__label', titel: true } ] }
  ];

  /* ⚠️ 16.09.2026: DIE UNTERGRENZE IST JETZT EIN ANTEIL, NICHT NUR EIN
     PIXELWERT. Zehn Pixel waren als Lesbarkeitsgrenze gedacht und haben in
     der Praxis das Gegenteil bewirkt: eine Gegenpruefung fand 19 Textrollen
     unter 85 Prozent ihrer Kaskadengroesse, die schlimmsten bei 45 bis 60.
     Auf der Startseite standen die vier Karten-Ueberschriften bei 500 px auf
     11,7 px gegen 24,55 px Kaskadenwert -- kleiner als ihr eigener
     Fliesstext. Einzeilig war die Zeile damit, lesbar nicht.
     Eine Zeile, die nur einzeilig ist, weil sie halbiert wurde, erfuellt den
     Auftrag dem Buchstaben nach und dem Sinn nach nicht. */
  var MINDESTANTEIL = 0.85;   /* nie unter 85 Prozent der Kaskadengroesse */
  var UNTERGRENZE = 11;       /* px - und nie unter elf Pixel */
  var TOLERANZ = 0.5;         /* px - Rundungsluft */
  var HOECHSTZEICHEN = 40;    /* ab hier ist es ein Satz, kein Kachelwort */

  if (!('ResizeObserver' in window) || !document.createRange) return;

  var laeuft = false;
  var messplatz = null;   /* der Kasten, in dem gemessen wird - ausserhalb aller Gruppen */
  var angemeldet = new WeakSet();   /* wird nach jedem Durchgang neu gesetzt, damit die Beobachter neu greifen */
  var breiten = new WeakMap();
  /* Siehe textbreite(): Inhalt + Schriftmerkmale + Schriftladezustand -> Breite. */
  var textbreiteSpeicher = new Map();

  /* Wie breit waere der Text in genau einer Zeile?
     ⚠️ NICHT scrollWidth: ein Titel ist oft ein Flexkind und bekommt seine
     Breite vom Inhalt - scrollWidth und clientWidth sind dort immer gleich,
     ein Ueberlauf waere unsichtbar. */
  function textbreite(el) {
    /* ⚠️ NICHT ueber die Zeilenrechtecke summieren. Gemessen am 16.09.2026
       auf / bei 320 px an "Schuetteln macht ihn schwindelig": zwei Rechtecke
       148 + 135 = 283 px, in EINER Zeile aber 299 px. Die Leerzeichen an den
       Umbruchstellen fehlen in der Summe. Der Einpasser hielt den Text
       daraufhin fuer passend und liess ihn zweizeilig stehen.
       Der Klon kennt keine Umbruchstellen und misst die Wahrheit. */
    var klon = el.cloneNode(true);
    var s = getComputedStyle(el);
    klon.style.cssText = 'position:absolute;left:-99999px;top:0;visibility:hidden;' +
      'white-space:nowrap;text-wrap:nowrap;width:auto;max-width:none;min-width:0;';
    /* ⚠️ 16.09.2026: DIE KURZFORM "font" IST GEFALLEN, UND DAS WAR EIN ECHTER
       FEHLER. Hier stand 'font:' + s.font. getComputedStyle().font liefert
       LEER, sobald ein Merkmal nicht auf dem Ausgangswert steht -- etwa
       font-feature-settings oder font-variant, und genau die tragen die
       Zahlenkacheln. Der Klon bekam dann GAR KEINE Schriftgroesse und erbte
       die seines Elternteils; gemessen wurde also eine Breite, die es nicht
       gibt.
       Folge, gemessen am 16.09.2026 auf /products/ai-station bei 400 px:
       "etwa 330 g" stand auf 28,2 px und lief 6,6 px heraus, waehrend der
       Einpasser es fuer passend hielt -- er hatte bei der Elterngroesse
       gemessen. Zwei Nachzuegler und ein Sichtbeobachter haben daran nichts
       geaendert, weil die Rechnung selbst falsch war, nicht ihr Zeitpunkt.
       Jetzt wird jedes Merkmal einzeln uebertragen. */
    var merkmale = ['fontSize', 'fontFamily', 'fontWeight', 'fontStyle', 'fontStretch',
      'lineHeight', 'letterSpacing', 'wordSpacing', 'textTransform', 'fontVariant',
      'fontVariantNumeric', 'fontFeatureSettings', 'fontKerning'];
    var schluessel = '';
    for (var m = 0; m < merkmale.length; m++) {
      var w = s[merkmale[m]];
      if (w) klon.style[merkmale[m]] = w;
      schluessel += (w || '') + '|';
    }
    /* ⚠️ 03.10.2026 TEMPO: ZWISCHENSPEICHER. Die Breite eines Textes in einer
       Zeile haengt NUR an seinem Inhalt (der Klon ist eine tiefe Kopie) und an
       genau diesen uebertragenen Merkmalen -- der Klon erbt seit dem
       16.09.2026 nichts mehr (eigener Messplatz unter <html>). Gleicher
       Inhalt + gleiche Merkmale = gleiche Breite, per Bauart. Neu gemessen
       wird also nur, was sich wirklich geaendert hat.
       Dazu gehoert die Schrift selbst: solange sie nachlaedt, misst der
       Browser in der Ersatzschrift. Deshalb steht der Ladezustand der
       Schriften mit im Schluessel.
       Gemessen vorher auf /products/eiliko, 390 px, CPU x4: textbreite()
       907 ms Eigenzeit beim Laden -- jeder Aufruf haengte einen Klon ein
       und erzwang damit ein Layout. */
    schluessel += (document.fonts ? document.fonts.status : '') + '|' + el.innerHTML;
    var gemerkt = textbreiteSpeicher.get(schluessel);
    if (gemerkt !== undefined) return gemerkt;
    /* ⚠️ 16.09.2026 NOTFALL: DER KLON DARF NICHT IN DEN ELTERNKASTEN.
       Hier stand el.parentElement.appendChild(klon) -- und genau das hat
       den Laden lahmgelegt. Der Textbeobachter (weiter unten) horcht auf
       childList im Teilbaum der Gruppe; ein Klon IM Elternkasten ist eine
       childList-Aenderung, also loeste jede Messung die naechste Messung
       aus. Endlos.
       GEMESSEN am 16.09.2026, gedrosseltes Handy auf /: Hauptfaden ab
       Sekunde 15 zu 98,9 Prozent belegt, Langzeitaufgaben 144.551 ms,
       load bei 93 s beziehungsweise in einem Lauf ueberhaupt nicht.
       Ohne den Baustein: 2.709 ms und load bei 19,4 s.
       Der Klon haengt jetzt in einem eigenen Kasten direkt unter <html>,
       also ausserhalb jeder beobachteten Gruppe. Das geht, weil seit
       heute jedes Schriftmerkmal einzeln uebertragen wird und der Klon
       nichts mehr erben muss. */
    if (!messplatz) {
      messplatz = document.createElement('div');
      messplatz.setAttribute('aria-hidden', 'true');
      messplatz.style.cssText = 'position:absolute;left:-99999px;top:0;width:0;height:0;overflow:hidden;contain:strict';
      document.documentElement.appendChild(messplatz);
    }
    messplatz.appendChild(klon);
    var b = klon.getBoundingClientRect().width;
    klon.remove();
    textbreiteSpeicher.set(schluessel, b);
    return b;
  }

  /* Wie viel Platz hat der Text wirklich?

     ⚠️ 16.09.2026 BERICHTIGT, UND DAS WAR DER SCHWERSTE FEHLER DIESES
     BAUSTEINS. Hier stand der ELTERNKASTEN. Das stimmt nur, wenn der Text
     die ganze Breite des Elternteils bekommt -- bei jeder Kachel mit
     Symbolspalte stimmt es nicht.

     Gemessen am 16.09.2026 auf /cart, .rb-vertrauen__kachel: der Kasten ist
     ein Raster mit grid-template-columns: auto minmax(0,1fr) und 16 px
     Fuge. Innenbreite 234 px, davon 44 px Symbol und 16 px Fuge -- dem
     Absatz bleiben 174 px. Der Einpasser verglich 230,5 gegen 234, hielt
     den Text fuer passend und tat NICHTS. Ergebnis: "Lieferung in 1 bis 3
     Werktagen" lief 56,5 px aus seinem Kasten und wurde von der Kachelkante
     abgeschnitten. Dasselbe Muster an elf weiteren Stellen.

     Richtig ist die Inhaltsbreite des ELEMENTS SELBST. Sie steht in
     clientWidth, sobald das Element ein Blockkasten ist -- und das ist es
     hier ueberall, weil nowrap nur auf Bloecke und blockifizierte Flexkinder
     gesetzt wird. Fuer den Fall, dass ein Element doch inline bleibt
     (clientWidth 0), faellt die Rechnung auf den Elternkasten zurueck, aber
     mit abgezogenen Geschwistern. */
  function platz(el) {
    var s = getComputedStyle(el);
    var eigen = el.clientWidth - (parseFloat(s.paddingLeft) || 0) - (parseFloat(s.paddingRight) || 0);
    if (eigen > 0) return eigen;
    var e = el.parentElement;
    if (!e) return 0;
    var es = getComputedStyle(e);
    var frei = e.clientWidth - (parseFloat(es.paddingLeft) || 0) - (parseFloat(es.paddingRight) || 0);
    /* ⚠️ Geschwister abziehen. Ein Symbol neben dem Text nimmt Platz weg,
       und genau dieser Abzug fehlte. */
    for (var i = 0; i < e.children.length; i++) {
      if (e.children[i] === el) continue;
      var r = e.children[i].getBoundingClientRect();
      if (r.width > 0 && r.height > 0) frei -= r.width;
    }
    return frei;
  }

  function zuruecksetzen(el) {
    el.style.removeProperty('font-size');
    el.style.removeProperty('white-space');
    el.removeAttribute('data-rb-1z');
  }

  /* ⚠️ 01.10.2026: DIE STRENGE FASSUNG FUER ZIELE MIT "boden".
     Sie gibt nie auf: entweder passt jede Zeile -- mit EINER Groesse je
     Rolle, nie unter dem Boden --, oder sie meldet false, und der Aufrufer
     legt die Kacheln untereinander. Gemessen wird wie unten am Klon; die
     Rechnung wird nachgeprueft, weil Breite und Schriftgroesse nicht streng
     linear zusammenhaengen. */
  /* ⚠️ 01.10.2026: platz() TAUGT HIER NICHT. Titel und Titelkasten sind
     Flexkinder und nur so breit wie ihr Text -- clientWidth liefert dann die
     abgerundete TEXTBREITE, nicht den Platz. Gemessen bei 390 px: "Etwa 150
     Minuten" 105,5 px Text, clientWidth 105, Platz in Wahrheit 117. Mit 2 px
     Luft "passte" damit nie etwas, und die Gruppe kippte auf jeder Breite.
     Auch der Elternkasten half nicht, er ist ebenso schmal.
     Gemessen wird deshalb die Innenbreite des KASTENS (ziel.kasten): das
     Symbol sitzt im linken Polster der Kachel, Titel und Untertext bekommen
     beide die volle Innenbreite. Nachgemessen am 01.10.2026: Innenbreite und
     rechte Textkante stimmen bei 340 px auf den Pixel ueberein (95 / 95). */
  function platzStreng(el, ziel) {
    var k = ziel.kasten ? el.closest(ziel.kasten) : el.parentElement;
    if (!k) return 0;
    var ks = getComputedStyle(k);
    return k.clientWidth - (parseFloat(ks.paddingLeft) || 0) - (parseFloat(ks.paddingRight) || 0);
  }

  function gruppeStreng(wurzel, rolle, ziel) {
    var els = wurzel.querySelectorAll(rolle.waehler);
    var luft = ziel.luft || 0;
    var faktor = 1, i, el;
    var liste = [];
    for (i = 0; i < els.length; i++) {
      el = els[i];
      zuruecksetzen(el);
      if (!(el.textContent || '').trim()) continue;
      var basis = parseFloat(getComputedStyle(el).fontSize) || 0;
      if (!basis) continue;
      el.style.setProperty('white-space', 'nowrap');
      var frei = platzStreng(el, ziel) - luft, noetig = textbreite(el);
      if (!(frei > 0) || !(noetig > 0)) return false;
      liste.push({ el: el, basis: basis });
      if (noetig > frei) faktor = Math.min(faktor, frei / noetig);
    }
    if (faktor >= 1) return true;
    for (var v = 0; v < 6; v++) {
      var alle = true;
      for (i = 0; i < liste.length; i++) {
        var g = Math.floor(liste[i].basis * faktor * 10) / 10;
        if (g < ziel.boden) return false;
        liste[i].el.style.setProperty('font-size', g + 'px');
      }
      for (i = 0; i < liste.length; i++) {
        if (textbreite(liste[i].el) > platzStreng(liste[i].el, ziel) - luft + TOLERANZ) { alle = false; break; }
      }
      if (alle) return true;
      faktor -= 0.03;
    }
    return false;
  }

  function gruppeEinpassen(wurzel, rolle) {
    var els = wurzel.querySelectorAll(rolle.waehler);
    if (!els.length) return;
    var i, el;

    for (i = 0; i < els.length; i++) {
      el = els[i];
      zuruecksetzen(el);
      var txt = (el.textContent || '').trim();
      if (!txt) continue;
      /* Ein Satz darf umbrechen. Nur Ueberschriften sind immer Beschriftung. */
      if (!rolle.titel && txt.length > HOECHSTZEICHEN) continue;

      var basis = parseFloat(getComputedStyle(el).fontSize) || 0;
      if (!basis) continue;

      /* ⚠️ 16.09.2026: nowrap WIRD VOR DEM MESSEN GESETZT, NICHT DANACH.
         Das war eine Reihenfolge, die zwei Faelle uebrig liess. nowrap
         aendert die Breite des Elements SELBST: ein Text, der vorher umbrach,
         belegt danach eine Zeile und kann eine Rasterspalte anders verteilen.
         Wer vorher misst, misst einen Zustand, den es nach dem Setzen nicht
         mehr gibt. Gemessen am 16.09.2026 auf /products/ai-station bei
         400 px: "etwa 330 g" und "2,4 + 5 GHz" liefen danach 6,6 bzw. 6,4 px
         heraus, obwohl der Einpasser sie fuer passend gehalten hatte. */
      el.style.setProperty('white-space', 'nowrap');
      var frei = platz(el);
      var noetig = textbreite(el);
      if (!(frei > 0) || !(noetig > 0)) { el.style.removeProperty('white-space'); continue; }

      if (noetig <= frei + TOLERANZ) continue;   /* passt - nowrap bleibt stehen */

      /* ⚠️ 16.09.2026: JE ELEMENT STATT JE GRUPPE. Bis heute nahm der
         Einpasser EINEN gemeinsamen Faktor je Gruppe -- den kleinsten -- und
         zog damit kurze Ueberschriften mit, die von sich aus bequem gepasst
         haetten. Gemessen auf / im Geschenkfinder: auch das Wort "Eiliko"
         stand auf 67,6 Prozent, weil ein laengerer Nachbar es mitzog.
         Mit der neuen Untergrenze von 85 Prozent liegen Nachbarn hoechstens
         15 Prozent auseinander -- das traegt die Reihe ruhig genug, ohne
         kurze Woerter zu opfern. */
      var grenze = Math.max(basis * MINDESTANTEIL, UNTERGRENZE);
      var neu = Math.floor(basis * (frei / noetig) * 10) / 10;

      if (neu < grenze) {
        /* ⚠️ Lieber zwei Zeilen als unlesbar oder abgeschnitten. */
        el.style.setProperty('white-space', 'normal');
        el.setAttribute('data-rb-1z', 'zu-lang');
        continue;
      }

      el.style.setProperty('white-space', 'nowrap');
      el.style.setProperty('font-size', neu + 'px');

      /* ⚠️ 16.09.2026: DAS ERGEBNIS WIRD NACHGEPRUEFT. Bis heute hat der
         Einpasser seine eigene Rechnung nie gegengemessen. Gemessen auf /
         an der Videowand-Unterschrift: er liess 20,9 px stehen, obwohl seine
         eigene Formel 19,5 px ergibt -- das letzte "g" wurde abgeschnitten.
         Der Grund ist, dass Schriftbreite und Schriftgroesse nicht streng
         linear zusammenhaengen (Kerning, Hinting, Rundung auf ganze
         Bildpunkte). Eine einzige Rechnung trifft deshalb nicht immer.
         Jetzt wird bis zu viermal nachgebessert, und wenn es dann immer noch
         nicht passt, faellt die Zeile auf zwei Zeilen zurueck statt
         ueberzulaufen. */
      for (var v = 0; v < 4; v++) {
        var jetzt = textbreite(el);
        if (jetzt <= platz(el) + TOLERANZ) break;
        neu = Math.floor((neu - 0.5) * 10) / 10;
        if (neu < grenze) {
          el.style.removeProperty('font-size');
          el.style.setProperty('white-space', 'normal');
          el.setAttribute('data-rb-1z', 'zu-lang');
          break;
        }
        el.style.setProperty('font-size', neu + 'px');
      }
    }
  }

  /* 12.10.2026 Tempo P1-4: NUR GRUPPEN IN DER NAEHE DES SICHTFELDS.
     Vorher rechnete jeder der sechs Durchgaenge (Start, Schriften, 400 ms,
     1400 ms, 3000 ms, load) ALLE Gruppen der Seite durch -- gemessen auf /
     bei CPU x4 rund 1,9 s Hauptfaden. Jetzt nur die, die hoechstens einen
     Bildschirm entfernt sind; die uebrigen kommen dran, sobald sie sich auf
     einen Bildschirm naehern (Beobachter naehe) -- also bevor man sie sieht.
     Ohne IntersectionObserver gilt alles als nah, wie bisher. */
  var nahe = new WeakSet();
  var naehe = ('IntersectionObserver' in window)
    ? new IntersectionObserver(function (eintraege) {
        var neu = false;
        for (var i = 0; i < eintraege.length; i++) {
          if (!eintraege[i].isIntersecting || nahe.has(eintraege[i].target)) continue;
          nahe.add(eintraege[i].target);
          naehe.unobserve(eintraege[i].target);
          neu = true;
        }
        if (neu) anstossen();
      }, { rootMargin: '100% 0px 100% 0px' })
    : null;
  function durchgang() {
    if (laeuft) return;
    laeuft = true;
    try {
      for (var i = 0; i < ZIELE.length; i++) {
        var z = ZIELE[i];
        var gruppen;
        try { gruppen = document.querySelectorAll(z.gruppe); }
        catch (e) { continue; }                    /* :has() kennt nicht jeder Browser */
        for (var g = 0; g < gruppen.length; g++) {
          if (naehe && !nahe.has(gruppen[g])) continue;
          if (!z.boden) {
            for (var r = 0; r < z.rollen.length; r++) gruppeEinpassen(gruppen[g], z.rollen[r]);
            continue;
          }
          /* Erst zu zweit versuchen; scheitert eine Rolle am Boden, kippt
             die Gruppe auf eine Spalte und ALLE Rollen werden neu gemessen,
             denn die Kachel ist danach eine andere. Das Kippen wird bei
             jedem Durchgang erst zurueckgenommen -- sonst bliebe ein einmal
             gekipptes Telefon nach dem Drehen ins Querformat gekippt. */
          gruppen[g].removeAttribute('data-rb-1z-kipp');
          var ok = true;
          for (var r2 = 0; r2 < z.rollen.length && ok; r2++) ok = gruppeStreng(gruppen[g], z.rollen[r2], z);
          if (!ok && z.kippen) {
            gruppen[g].setAttribute('data-rb-1z-kipp', '');
            ok = true;
            for (var r3 = 0; r3 < z.rollen.length && ok; r3++) ok = gruppeStreng(gruppen[g], z.rollen[r3], z);
          }
          /* Passt es selbst in einer Spalte nicht -- ein Text ueber rund
             35 Zeichen --, greift die alte Regel: lieber zwei Zeilen als
             ein abgeschnittener Text. Gemessen kommt das heute nicht vor. */
          if (!ok) for (var r4 = 0; r4 < z.rollen.length; r4++) gruppeEinpassen(gruppen[g], z.rollen[r4]);
        }
      }
    } finally {
      laeuft = false;
    }
  }

  var geplant = 0;
  function anstossen() {
    if (geplant) return;
    geplant = requestAnimationFrame(function () { geplant = 0; durchgang(); });
  }

  /* ⚠️ NUR DIE BREITE WECKT IHN. Eine kleinere Schrift aendert die HOEHE der
     Gruppe - liefe der Beobachter auch darauf an, weckte er sich selbst. */
  var wache = new ResizeObserver(function (eintraege) {
    var noetig = false;
    for (var i = 0; i < eintraege.length; i++) {
      var b = Math.round(eintraege[i].contentRect.width);
      if (breiten.get(eintraege[i].target) !== b) { breiten.set(eintraege[i].target, b); noetig = true; }
    }
    if (noetig) anstossen();
  });

  /* ⚠️ 16.09.2026: EIN ZWEITER BEOBACHTER FUER DAS ERSTE ERSCHEINEN.

     Der ResizeObserver weckt nur auf, wenn sich die BREITE aendert. Das
     reicht nicht: rb-motion.css blendet Abschnitte beim Scrollen ein, und
     bis dahin steht eine Gruppe mit einer Breite da, die spaeter nicht mehr
     stimmt. Der Einpasser hat sie dann einmal gemessen, fuer passend
     gehalten und nowrap gesetzt -- und danach lief der Text heraus.

     Gemessen am 16.09.2026 auf / bei 500 px: .rb-set__name lief 12,2 px aus
     seinem Kasten, .rb-neu-zahlen__name 13,7 px, die Videowand-Unterschrift
     10,3 px. Alle drei stehen in Abschnitten, die erst beim Scrollen
     erscheinen; auf /cart, wo alles sofort dasteht, gab es keinen einzigen
     Fall mehr.

     Der Sichtbeobachter fasst deshalb nach, sobald eine Gruppe zum ersten
     Mal ins Bild kommt -- einmal je Gruppe, danach meldet er sich ab. */
  var sicht = ('IntersectionObserver' in window)
    ? new IntersectionObserver(function (eintraege) {
        var noetig = false;
        for (var i = 0; i < eintraege.length; i++) {
          if (!eintraege[i].isIntersecting) continue;
          sicht.unobserve(eintraege[i].target);
          noetig = true;
        }
        if (noetig) anstossen();
      }, { rootMargin: '200px 0px' })
    : null;

  /* ⚠️ 16.09.2026: HIER STAND EIN MutationObserver, UND ER HAT DEN LADEN
     LAHMGELEGT. Er sollte die hochzaehlenden Zahlenkacheln abfangen und
     horchte dafuer auf childList im Teilbaum jeder Gruppe. Der Einpasser
     misst aber an einem KLON, und der Klon hing im Elternkasten -- jede
     Messung war damit selbst eine childList-Aenderung und loeste die
     naechste aus. Endlos.
     GEMESSEN am 16.09.2026, gedrosseltes Handy auf /: Hauptfaden ab
     Sekunde 15 zu 98,9 Prozent belegt, Langzeitaufgaben 144.551 ms,
     load bei 93 s und in einem von drei Laeufen ueberhaupt nicht.
     Ohne den Baustein: 2.709 ms und load bei 19,4 s. 2.886 Layouts
     gegen 69.
     ⚠️ ER IST ERSATZLOS GEFALLEN, obwohl der Klon inzwischen ausserhalb
     der Gruppen misst und die Schleife damit schon gebrochen waere. Ein
     Beobachter, der einmal den ganzen Laden angehalten hat, kommt nicht
     mit einer Sicherung zurueck -- er kommt gar nicht zurueck. Die
     Zaehlerkacheln faengt statt dessen der dritte feste Nachlauf ab
     (3000 ms, siehe starten): die Zaehler sind nach rund 600 ms fertig.
     Drei feste Zeitpunkte koennen sich nicht gegenseitig wecken. */

  function anmelden() {
    for (var i = 0; i < ZIELE.length; i++) {
      var gruppen;
      try { gruppen = document.querySelectorAll(ZIELE[i].gruppe); }
      catch (e) { continue; }
      for (var g = 0; g < gruppen.length; g++) {
        if (angemeldet.has(gruppen[g])) continue;
        angemeldet.add(gruppen[g]);
        var rechteck = gruppen[g].getBoundingClientRect();
        breiten.set(gruppen[g], Math.round(rechteck.width));
        if (naehe) {
          var vh = window.innerHeight || 800;
          if (rechteck.bottom > -vh && rechteck.top < 2 * vh) nahe.add(gruppen[g]);
          else naehe.observe(gruppen[g]);
        }
        wache.observe(gruppen[g]);
        if (sicht) sicht.observe(gruppen[g]);
      }
    }
  }

  function starten() {
    anmelden();
    durchgang();
    /* ⚠️ ZWEITER LAUF NACH DEN SCHRIFTEN. Vor document.fonts.ready misst der
       Browser in der Ersatzschrift, und die ist anders breit. Ohne diesen
       Lauf stehen die Kacheln nach dem Schriftwechsel wieder zweizeilig da. */
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { anmelden(); durchgang(); });
    }
    /* ⚠️ ZWEI NACHZUEGLER, UND DAS IST KEINE VORSICHT, SONDERN GEMESSEN.
       Der Einpasser rechnet richtig, aber zu frueh: ein Raster verteilt seine
       Spalten noch einmal neu, nachdem Schriften, Bilder und eingeblendete
       Abschnitte fertig sind. Gemessen am 16.09.2026 auf /products/ai-station
       bei 400 px: die Kachel "etwa 330 g" stand auf 28,2 px und lief 6,6 px
       heraus -- zum Zeitpunkt der Messung hatte ihre Spalte noch 147 px, am
       Ende nur 140.
       ⚠️ ZWEI FESTE ZEITPUNKTE STATT EINER SCHLEIFE. Ein Beobachter auf die
       Hoehe wuerde sich selbst wecken (jede Schriftaenderung aendert die
       Hoehe); ein Dauerlauf kostet Rechenzeit ohne Ende. durchgang() setzt
       vor jeder Messung zurueck und ist damit wiederholbar -- zweimal
       nachfassen genuegt und hoert von selbst auf. */
    setTimeout(function () { anmelden(); durchgang(); }, 400);
    setTimeout(function () { anmelden(); durchgang(); }, 1400);
    /* Der dritte faengt die hochzaehlenden Zahlenkacheln ab; sie sind
       nach rund 600 ms fertig, hier ist reichlich Luft. */
    setTimeout(function () { anmelden(); durchgang(); }, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', starten, { once: true });
  } else {
    starten();
  }
  /* Der Theme-Editor baut Sektionen neu auf - dann sind die alten Kaesten weg. */
  document.addEventListener('shopify:section:load', function () { setTimeout(starten, 60); });
  window.addEventListener('pageshow', anstossen);
  /* ⚠️ EIN LAUF NACH DEM VOLLSTAENDIGEN LADEN. Bilder und Videos aendern die
     Hoehe, nicht die Breite - der Beobachter wacht davon nicht auf. Ein
     Element, das beim ersten Lauf noch keine Breite hatte, bekaeme sonst nie
     einen zweiten. */
  window.addEventListener('load', function () { anmelden(); anstossen(); });
})();

/* ======================================================================
   ECHTER DOWNLOAD STATT ANZEIGE IM BROWSER  ·  16.09.2026
   Gehoert zu snippets/robby-downloads.liquid.

   ⚠️ DAS PROBLEM. Das Merkmal download an einem <a> wirkt nur bei gleicher
   Herkunft. Die Handbuecher liegen auf cdn.shopify.com, der Laden auf
   www.robbytoys.com -- der Browser ignoriert das Merkmal und zeigt das PDF
   in seinem Betrachter an. Der Gesellschafter hat aber ausdruecklich einen
   DOWNLOAD verlangt.

   ⚠️ WARUM ES TROTZDEM GEHT. Am 16.09.2026 am CDN gemessen:
       access-control-allow-origin: *
       content-type: application/pdf
       content-disposition: (fehlt)
   Weil die Herkunft freigegeben ist, darf die Seite die Datei selbst holen
   und als Blob mit eigenem Dateinamen speichern.

   ⚠️ WAS BEWUSST NICHT GETAN WIRD. Kein MutationObserver, kein
   ResizeObserver, kein Intervall. Am selben Tag hat ein Beobachter in
   dieser Datei eine Endlosschleife erzeugt: 144.551 ms Langaufgaben,
   DOMContentLoaded nach 46,4 s. Hier steht genau EIN Zuhoerer am Dokument,
   der nur bei einem Klick etwas tut.

   Faellt dieses Skript aus, bleibt der Link und oeffnet das PDF. Lesbar ist
   es dann immer noch -- der Rueckfall ist kein Fehlerzustand.
   ====================================================================== */
(function () {
  'use strict';
  if (window.__rbDlBereit) return;
  window.__rbDlBereit = true;

  document.addEventListener('click', function (ev) {
    var a = ev.target && ev.target.closest ? ev.target.closest('a[data-rb-dl]') : null;
    if (!a) return;
    /* Wer mit Strg, Befehlstaste oder mittlerer Taste klickt, will einen
       neuen Tab. Das nimmt ihm niemand weg. */
    if (ev.defaultPrevented || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey || ev.button !== 0) return;
    if (!window.fetch || !window.URL || !URL.createObjectURL) return;

    var name = a.getAttribute('data-rb-dl') || 'handbuch.pdf';
    var adresse = a.href;
    ev.preventDefault();
    a.setAttribute('data-rb-dl-laeuft', '');

    fetch(adresse, { credentials: 'omit' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.blob();
      })
      .then(function (blob) {
        var u = URL.createObjectURL(blob);
        var h = document.createElement('a');
        h.href = u; h.download = name;
        document.body.appendChild(h);
        h.click();
        document.body.removeChild(h);
        /* ⚠️ Die Objektadresse wird wieder freigegeben. Ohne das haelt der
           Browser bis zum Seitenwechsel 224 kB je Klick im Speicher. */
        setTimeout(function () { URL.revokeObjectURL(u); }, 4000);
      })
      .catch(function () {
        /* Netz weg, CORS geaendert, was auch immer: dann eben der normale
           Weg. Lieber das PDF im Betrachter als gar nichts. */
        window.location.href = adresse;
      })
      .then(function () { a.removeAttribute('data-rb-dl-laeuft'); });
  }, false);
})();

/* ======================================================================
   DER VERSANDHINWEIS FOLGT DER VARIANTE  ·  19.09.2026
   Gehoert zu snippets/robby-versandhinweis.liquid.

   ⚠️ WARUM ES DIESEN NACHZIEHER UEBERHAUPT BRAUCHT. Liquid rechnet den
   Hinweis beim Seitenaufbau richtig -- aber nur einmal. Am 19.09.2026 auf
   /products/eiliko gemessen: beim Wechsel von "Einzeln" (79,90) auf "Mit
   Ueberraschungsbox" (89,90) tauscht Shrine den Preis aus, der Kasten des
   Hinweises BLEIBT jedoch derselbe Knoten stehen. Gemessen an einem
   Merkmal, das nur im Browser gesetzt wird: es hat den Wechsel ueberlebt.
   Ohne diesen Nachzieher zeigte die Seite nach jedem Wechsel den Hinweis
   der vorigen Ausfuehrung.

   ⚠️ KEIN BEOBACHTER. Am 16.09.2026 hat ein MutationObserver in dieser
   Datei den Laden zwei Stunden lang lahmgelegt (144.551 ms Langaufgaben).
   Hier steht genau ein Zuhoerer am Dokument, und er laeuft nur bei einer
   Aenderung im Variantenwaehler. Die zwei Zeitpunkte sind dieselbe
   Vorsichtsmassnahme wie in Abschnitt 28: Shrine tauscht Teile der Kaufbox
   aus, der erste Lauf faellt gelegentlich in den Zustand davor.

   ⚠️ EINE UNBEKANNTE VARIANTENNUMMER AENDERT NICHTS. Lieber der vom Server
   gerechnete Stand als eine geratene Umschaltung -- die Zeile ist eine
   Pflichtangabe nach Paragraf 6 PAngV, kein Schmuck. */
(function () {
  var kasten = document.querySelector('[data-rb-vkhinweis][data-rb-preise]');
  if (!kasten) return;

  var frei = kasten.querySelector('[data-rb-vkfrei]');
  var zzgl = kasten.querySelector('[data-rb-vkzzgl]');
  if (!frei || !zzgl) return;

  var schwelle = Number(kasten.getAttribute('data-rb-schwelle')) || 9900;

  var preise = {};
  kasten.getAttribute('data-rb-preise').split(',').forEach(function (paar) {
    var teil = paar.split(':');
    if (teil.length === 2) preise[teil[0]] = Number(teil[1]);
  });

  function nachziehen() {
    /* Das Formular traegt die gewaehlte Ausfuehrung als verstecktes Feld.
       Der Preis im Text waere die andere Quelle -- er ist es nicht: dort
       steht ein Waehrungstext, dessen Zerlegung von Sprache und Markt
       abhaengt. Eine Nummer ist eine Nummer. */
    var feld = document.querySelector(
      '.product__info-container input.product-variant-id, .product__info-container input[name="id"]'
    );
    if (!feld) return;
    var preis = preise[String(feld.value)];
    if (typeof preis !== 'number' || isNaN(preis)) return;

    var istFrei = preis >= schwelle;
    if (istFrei) { frei.removeAttribute('hidden'); zzgl.setAttribute('hidden', ''); }
    else { zzgl.removeAttribute('hidden'); frei.setAttribute('hidden', ''); }
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (!t.closest('variant-selects, .product-form__input')) return;
    setTimeout(nachziehen, 0);
    setTimeout(nachziehen, 260);
  }, { passive: true });

  nachziehen();
})();

/* ======================================================================
   DAS WARENKORB-POP-UP BLEIBT STEHEN — 25.10.2026
   ======================================================================
   Auftrag: "das pop up wenn man atc macht, das soll bleiben" und sich
   nicht nach einer Zeit schliessen.

   ⚠️ HIER STAND BIS HEUTE DAS GEGENTEIL. Am 29.09.2026 lautete der Auftrag
   "und der soll sich automatisch nach spaetestens 10 sek schliessen". Die
   Uhr lief mit SEKUNDEN = 10, hielt an, solange der Zeiger im Kasten stand
   oder die Tastatur darin war, und rief sonst close(). Gemessen am
   25.10.2026 auf /products/eiliko ging das Pop-up nach 10.469 ms zu.
   Die Uhr ist ersatzlos weg, nicht auf einen grossen Wert gestellt: eine
   Uhr, die erst nach Minuten zuschlaegt, ist dasselbe Versprechen nur
   spaeter gebrochen.

   ⚠️ DAS POP-UP IST DAMIT NICHT UNSCHLIESSBAR. Es bleibt bei den drei
   Wegen, die Shrine in cart-notification.js mitbringt und die nicht von
   dieser Datei abhingen: der Schliessknopf, die Escape-Taste und ein Klick
   daneben (handleBodyClick). Nur die Uhr faellt weg.

   ⚠️ WER SIE ZURUECKHOLEN WILL, holt sie aus der Versionsgeschichte und
   nicht aus dem Kopf: die abgeloeste Fassung hatte zwei Anlaeufe gekostet.
   Der zweite Fehler lag daran, dass cart-notification.js mit `defer` laedt
   und close() zum Laufzeitpunkt dieser Datei noch gar nicht existiert --
   ein Waechter, der das im Voraus prueft, schaltet sich stillschweigend
   selbst ab. Beides steht im Commit von heute.

   window.__rbPopupUhr bleibt als Marke stehen und meldet jetzt 0. Ohne sie
   laesst sich von aussen nicht unterscheiden, ob die Uhr aus ist oder das
   Stueck gar nicht erst geladen wurde -- genau das hat damals zwei Anlaeufe
   gekostet. */
(function () {
  window.__rbPopupUhr = 0;
})();
